import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { MatDialog } from '@angular/material/dialog';
import { AddNewSubOtpModalComponent } from 'src/app/pages/add-new-sub-otp-modal/add-new-sub-otp-modal.component';
import { CancelSubDialogComponent } from 'src/app/pages/cancel-sub-dialog/cancel-sub-dialog.component';
import { CancelRepDialogComponent } from 'src/app/pages/cancel-rep-dialog/cancel-rep-dialog.component';
import { EncdecriptService } from 'src/app/services/encdecrypt.service';
import { AddNewAdminDialogComponent } from 'src/app/pages/add-new-admin-dialog/add-new-admin-dialog.component';
import { WpParamMappingDialogComponent } from 'src/app/pages/wp-param-mapping-dialog/wp-param-mapping-dialog.component';
import { Router } from '@angular/router';
import jsPDF from 'jspdf';
import { FileUploader } from 'ng2-file-upload';
import { AfterViewInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';

import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Observable, timer } from 'rxjs';
import { UpdatePlublishDatesComponent } from '../update-plublish-dates/update-plublish-dates.component';
import { map, startWith } from 'rxjs/operators';
import { UpdateMagazineNameAndCategoryComponent } from '../update-magazine-name-and-category/update-magazine-name-and-category.component';
import { UpdateAdvtSizesComponent } from '../update-advt-sizes/update-advt-sizes.component';
import { UpdateIssueDatesComponent } from 'src/app/pages/update-issue-dates/update-issue-dates.component';
import { UpdateStateMasterComponent } from '../update-state-master/update-state-master.component';
import { UpdateDistrictMasterComponent } from '../update-district-master/update-district-master.component';
import { UpdateTalukaMasterComponent } from '../update-taluka-master/update-taluka-master.component';
import { UpdatePrantComponent } from '../admin/update-prant/update-prant.component';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatOptionSelectionChange } from '@angular/material/core';

interface tableData {
  id: number;
  name: string;
  mobile: string;
}

export interface StateGroup {
  category: string;
  details: string[];
}

export const _filter4 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter5 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter6 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter7 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter8 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter9 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter10 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter11 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

const uploadAPI = 'http://minimasters.in/digisub/portal_fileUpload.php';
@Component({
  selector: 'app-icons',
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IconsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  officeRepDataSource = new MatTableDataSource<any>([]);



  subscriptionTypeList: any[] = [];
  deliveryModeList: any[] = [];
  bookNameList: any[] = [];
  issueNameList: any[] = [];
  getMagIssueDatesandAdvtNames: any[] = [];
  issueSellerIssueDates: any[] = [];

  bookSearch: string = '';
  bookDropdownOpen = false;
  issueDateDropdownOpen = false;
  issueDateSearch = '';
  subscriptionTypeDropdownOpen = false;
  subscriptionTypeSearch = '';
  deliveryModeDropdownOpen = false;
  deliveryModeSearch = '';
  advtCategoryDropdownOpen = false;
  advtCategorySearch = '';
  issueSellerIssueDropdownOpen = false;
  issueSellerIssueSearch = '';
  issueSellerIssueDateDropdownOpen = false;
  issueSellerIssueDateSearch = '';
  issueSellerTypeDropdownOpen = false;
  issueSellerTypeSearch = '';
  readonly issueSellerTypeOptions = ['All', 'Agent', 'Representative', 'Distributor'];
  isEditingOffRep: boolean;
  // Change this line at the top of your class


  statusFilter: string = '';
startDateFrom: Date | null = null;
startDateTo: Date | null = null;

typeFilter: string = '';
filterEndDate: Date | null = null;


allRepresentatives: any[] = [];
  dataSource: any;

  ngAfterViewInit(): void {
    // existing cursor code stays
    this.cursorGlow = document.getElementById('cursor-glow')!;
    this.cursorDot = document.getElementById('cursor-dot')!;
    this.cursorRing = document.getElementById('cursor-ring')!;
    this.cursorLabel = document.getElementById('cursor-label')!;

    // ADD this — assign paginator after view is ready
    this.officeRepDataSource.paginator = this.paginator;
  }


  @HostListener('document:click')
  closeDropdowns() {
    this.bookDropdownOpen = false;
    this.issueDateDropdownOpen = false;
    this.subscriptionTypeDropdownOpen = false;
    this.deliveryModeDropdownOpen = false;
    this.advtCategoryDropdownOpen = false;
    this.issueSellerIssueDropdownOpen = false;
    this.issueSellerIssueDateDropdownOpen = false;
    this.issueSellerTypeDropdownOpen = false;
  }

  translationTimeout: any; //
  BookForm: FormGroup;
  addform: FormGroup;
  MasterTable: FormGroup;
  OccupationMaster: FormGroup;
  sbhet: FormGroup;
  startenddate: FormGroup;
  tableData: tableData[] = [];
  selectedState = '';
  selectedCity = '';
  selectedState2 = '';
  selectedCity2 = '';
  displayinvoiceForm = true;
  invoicedate = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
  magform: FormGroup;
  magpriceupdate: FormGroup;
  searchTerm = false;
  displayChequqField = false;
  dataLoaded = false;
  mag = [];
  magname = [];
  magyear = [];
  filterStartDate: Date | null = null;

  displayedColumns: string[] = [
    'srno',
    'issuesellername',
    'mnumber',
    'address',
    'pincode',
    'country',
    'state',
    'district',
    'taluka',
    'email',
    'start_date',   // ← ADD
    'end_date',     // ← ADD
    'status',
    'actions'
  ];

  // statusFilter: number | string = '';
  // allRepresentatives: any[] = [];
  filteredRepresentatives: any[] = [];
  searchName: string = '';
  searchMobile: string = '';

  subscriberDetails = {
    name: '',
    address: '',
  };
  submagsDetails;
  totalamount = 0;
  totalmagamount = 0;
  totaldonationamount = 0;
  displayTotal = false;
  addNewAdminForm: FormGroup;
  addIssueGranthaForm: FormGroup;
  advtSizesForm: FormGroup;
  IssueDates: FormGroup;
  StateMaster: FormGroup;
  CityMaster: FormGroup;
  prantMaster: FormGroup;
  TalukaMaster: FormGroup;
  form2: FormGroup;
  officerepform: FormGroup;
  repassignform: FormGroup;
  repassigntype: FormGroup;
  repassignoff: FormGroup;
  addcountry: FormGroup;
  addseni: FormGroup;
  addlang: FormGroup;


  private cursorGlow!: HTMLElement;
  private cursorDot!: HTMLElement;
  private cursorRing!: HTMLElement;
  private cursorLabel!: HTMLElement;

  NewMagazineForm: FormGroup;
  public copy: string;
  data1;
  data2;
  needToUpdate = false;
  imgPath: string;
  newDateValue;
  newDateArray = [];
  yourMessage = [];
  stateGroups: StateGroup[] = [
    { category: 'Magazine', details: ['Vivek_Weekly'] },
    {
      category: 'Grantha',
      details: ['abc', 'pqr'],
    },
    { category: 'Special Magazine', details: ['xyq'] },
  ];
  advt_mag_name_details = [];
  Filteredadvt_mag_name_details = [];
  delivery_mode;

  public uploader: FileUploader = new FileUploader({
    url: uploadAPI,
    itemAlias: 'file',
  });
  issueName: any;
  advtsizebyCategory: any;
  getMagIssueDatesandNames: any[];
  filterdMagIssueDatesandNames: any;
  issueGranthName: any;
  issueForm: any;
  _filter1: any;
  issueDates: any;
  sbhetdata: any;
  _repDataForPrint: any[] = [];
  id: any;
  updatesbhet: boolean;
  getdepwiserepcount1: any;
  advt_type: any;
  getdatabydep: any;
  rep_type: any;
  count: any;
  count1: any;
  getrepname: any;
  off_rep: any;
  getdatabyoff: any;
  issuedate: any;
  formattedDate: string;
  deactivedata: any;
  getcountry: any;
  countryid: any;
  getdeptdata: any;
  senioritylist: any;
  languagelist: any;
  off_rep_id: any;
  getLanguageList: any;
  getLanguageList1: any;
  setlangugae: any;
  updatecountry123: any = false;
  printPage: any;
  printSection: any;
  totalCount: any;
  repList: any[] = [];
  searchQuery = '';
  // statusFilter = '';
  filteredList: any[] = [];
  filterCountry = '';
  filterState = '';
  filterDistrict = '';
  filterTaluka = '';
  filterDob: Date | null = null;
  filterDobMonth: string = '';
  showSbhetCard = false; // ← hidden by default
  searchStatus: string = '';


  filterDobFrom: Date | null = null;
  filterDobTo: Date | null = null;

  // Dropdown options built from loaded data
  filterCountries: string[] = [];
  filterStates: string[] = [];
  filterDistricts: string[] = [];
  filterTalukas: string[] = [];

  campaignList: any[] = [];
  editingCampaign: any = null;   // campaign currently being edited (inline)
  editCampaignName: string = ''; // bound to the inline edit input
  departmentList: any[] = [];

  countryList: any[] = [];
  stateList: any[] = [];
  districtList: any[] = [];
  talukaList: any[] = [];

  /** Customers loaded from the backend — populated by loadCustomers() */
  selectedCustomers: any[] = [];

  



  /** True while an API call to fetch customers is in progress */
  isLoadingCustomers: boolean = false;

  formData = {
    campaignId: '',
    departmentId: '',
    countryId: '',
    stateId: '',
    districtId: '',
    talukaId: '',
    status: '',
    fromDate: '',
    toDate: '',
    subscriptionTypeIds: [] as string[],
    deliveryModeIds: [] as string[],
    bookNames: [] as string[],
    issueName: '',
    issueDates: [] as string[],
    issueSellerIssueName: '',
    issueSellerIssueDateIds: [] as string[],
    issueSellerTypeIds: [] as string[]
  };

  /**
   * Returns true only when the currently selected department is Subscription.
   * Controls visibility of the Issue Date (From / To) fields.
   */
  get isSubscriptionDept(): boolean {
    if (!this.formData.departmentId) return false;
    const dept = this.departmentList.find(
      d => String(d.dep_id) === String(this.formData.departmentId)
    );
    if (!dept) return false;
    const name = (dept.dep_name as string).toLowerCase();
    return (
      name.includes('subscription') ||
      name.includes('वर्गणी') ||
      name.includes('subscriber')
    );
  }


  removeCustomer(customer: any) {
    this.selectedCustomers = this.selectedCustomers.filter(c => c.id !== customer.id);
    if (this.customerPage > this.totalPages && this.totalPages > 0) {
      this.customerPage = this.totalPages;
    }
  }

  customerSearch: string = '';
  customerPage: number = 1;
  customerPageSize: number = 10;

  get filteredCustomers(): any[] {
    const term = this.customerSearch.toLowerCase().trim();
    if (!term) return this.selectedCustomers;
    return this.selectedCustomers.filter(c =>
      c.name?.toLowerCase().includes(term) ||
      c.mobile?.toString().includes(term)
    );
  }

  get pagedCustomers(): any[] {
    const start = (this.customerPage - 1) * this.customerPageSize;
    return this.filteredCustomers.slice(start, start + this.customerPageSize);
  }

  get totalPages(): number {
    return Math.ceil(this.filteredCustomers.length / this.customerPageSize);
  }

  showCustomerSummary: boolean = false;

  /** Tracks the result of the last WhatsApp send operation */
  sendReport = {
    sent: [] as any[],
    failed: [] as any[],
    isSending: false,
    isComplete: false
  };

  // ─── Load Customers ────────────────────────────────────────────────────────

  /**
   * Builds the filter payload sent to the PHP backend.
   * IDs are resolved to their text names using the already-loaded lists so
   * the PHP can do a direct column comparison — no subqueries needed.
   */
  private buildFilterPayload() {
    const country = this.formData.countryId
      ? (this.countryList.find(c => String(c.country_id) === String(this.formData.countryId))?.country_name ?? null)
      : null;

    const state = this.formData.stateId
      ? (this.stateList.find(s => String(s.id) === String(this.formData.stateId))?.name ?? null)
      : null;

    const district = this.formData.districtId
      ? (this.districtList.find(d => String(d.id) === String(this.formData.districtId))?.name ?? null)
      : null;

    const taluka = this.formData.talukaId
      ? (this.talukaList.find(t => String(t.id) === String(this.formData.talukaId))?.name ?? null)
      : null;



    return {
      country,
      state,
      district,
      taluka,
      // Status is hidden and not applicable for Subscription department
      status: this.isSubscriptionDept ? null : (this.formData.status || null),
      // Issue-date range — sent only for the Subscription department
      fromDate: this.isSubscriptionDept ? (this.formData.fromDate || null) : null,
      toDate: this.isSubscriptionDept ? (this.formData.toDate || null) : null,
      subscriptionType: this.isSubscriptionDept
        ? ((this.formData.subscriptionTypeIds as string[]).length ? (this.formData.subscriptionTypeIds as string[]).join(',') : null) : null,
      deliveryMode: this.isSubscriptionDept
        ? ((this.formData.deliveryModeIds as string[]).length ? (this.formData.deliveryModeIds as string[]).join(',') : null) : null,
      bookName: this.isBookDept
        ? ((this.formData.bookNames as string[]).length ? (this.formData.bookNames as string[]).join(',') : null) : null,
      issueName: this.isAdvtDept ? (this.formData.issueName || null) : null,
      issueDatesIds: this.isAdvtDept
        ? (this.formData.issueDates.length ? this.formData.issueDates.join(',') : null) : null,
      issueSellerType: this.isRepresentativeDept
        ? ((this.formData.issueSellerTypeIds as string[]).length ? (this.formData.issueSellerTypeIds as string[]).join(',') : null)
        : null,
      issueSellerIssueName: this.isIssueSellerDept ? (this.formData.issueSellerIssueName || null) : null,
      issueSellerIssueDates: this.isIssueSellerDept
        ? ((this.formData.issueSellerIssueDateIds as string[]).length ? (this.formData.issueSellerIssueDateIds as string[]).join(',') : null) : null,
    };
  }

  /**
   * Central dispatcher — reads the selected department name and routes
   * to the correct per-department load method.
   */
  loadCustomers() {
    if (!this.formData.departmentId) {
      alert('Please select a department first.');
      return;
    }

    const dept = this.departmentList.find(
      d => String(d.dep_id) === String(this.formData.departmentId)
    );
    const deptName: string = dept ? (dept.dep_name as string).toLowerCase() : '';

    if (
      deptName.includes('subscription') ||
      deptName.includes('वर्गणी') ||
      deptName.includes('subscriber')
    ) {
      this.loadSubscriptionCustomers();
    } else if (
      deptName.includes('advt') ||
      deptName.includes('advertisement') ||
      deptName.includes('जाहिरात')
    ) {
      this.loadAdvertisementCustomers();
    } else if (
      deptName.includes('issue') ||
      deptName.includes('अंक')
    ) {
      this.loadIssueSellerCustomers();
    } else if (
      deptName.includes('office') ||
      deptName.includes('book') ||
      deptName.includes('पुस्तक')
    ) {
      this.loadOfficeRepCustomers();
    } else if (
      deptName.includes('representative') ||
      deptName.includes('प्रतिनिधी') ||
      deptName.includes('rep')
    ) {
      this.loadRepresentativeCustomers();
    } else {
      // Fallback for any other department — use the generic endpoint
      this.loadCustomersByDepartmentId();
    }
  }

  /** Fetch customers belonging to the Subscription department (वर्गणी) */
  loadSubscriptionCustomers() {
    this.isLoadingCustomers = true;
    this.selectedCustomers = [];
    const filters = this.buildFilterPayload();

    this.service.getSubscriptionCustomers(filters).subscribe({
      next: (data: any[]) => {
        this.selectedCustomers = data || [];
        this.isLoadingCustomers = false;
        this.customerPage = 1;
        this.showCustomerSummary = this.selectedCustomers.length > 0;
        if (!this.selectedCustomers.length) {
          alert('No customers found for the selected filters.');
        }
      },
      error: (err) => {
        console.error('Error loading subscription customers', err);
        this.isLoadingCustomers = false;
        alert('Failed to load subscription customers. Please try again.');
      }
    });
  }




  // loadSubscriptionCustomers() {
  //   this.isLoadingCustomers = true;
  //   this.selectedCustomers = [];

  //   // Static test data
  //   this.selectedCustomers = [
  //     {
  //       id: 1,
  //       name: 'Mahesh Borude',
  //       mobile: '9373117389',
  //       address: 'Mumbai',
  //       state: 'Maharashtra',
  //       district: 'Mumbai',
  //       taluka: 'Andheri'
  //     },
  //     {
  //       id: 2,
  //       name: 'Suchita Joil',
  //       mobile: '7506676990',
  //       address: 'Pune',
  //       state: 'Maharashtra',
  //       district: 'Pune',
  //       taluka: 'Haveli'
  //     }
  //   ];

  //   this.isLoadingCustomers = false;
  //   this.customerPage = 1;
  //   this.showCustomerSummary = this.selectedCustomers.length > 0;

  //   console.log(this.selectedCustomers);
  // }

  /** Fetch customers belonging to the Advertisement department (जाहिरात) */
  loadAdvertisementCustomers() {
    this.isLoadingCustomers = true;
    this.selectedCustomers = [];
    const filters = this.buildFilterPayload();

    this.service.getAdvertisementCustomers(filters).subscribe({
      next: (data: any[]) => {
        this.selectedCustomers = data || [];
        this.isLoadingCustomers = false;
        this.customerPage = 1;
        this.showCustomerSummary = this.selectedCustomers.length > 0;
        if (!this.selectedCustomers.length) {
          alert('No customers found for the selected filters.');
        }
      },
      error: (err) => {
        console.error('Error loading advertisement customers', err);
        this.isLoadingCustomers = false;
        alert('Failed to load advertisement customers. Please try again.');
      }
    });
  }


  /** Fetch customers belonging to the Issue Seller department (अंक विक्रेता) */
  loadIssueSellerCustomers() {
    this.isLoadingCustomers = true;
    this.selectedCustomers = [];
    const filters = this.buildFilterPayload();

    this.service.getIssueSellerCustomers(filters).subscribe({
      next: (res: any) => {
        const data: any[] = Array.isArray(res) ? res : (res?.data || []);
        this.selectedCustomers = data;
        this.isLoadingCustomers = false;
        this.customerPage = 1;
        this.showCustomerSummary = this.selectedCustomers.length > 0;
        if (!this.selectedCustomers.length) {
          alert('No customers found for the selected filters.');
        }
      },
      error: (err) => {
        console.error('Error loading issue seller customers', err);
        this.isLoadingCustomers = false;
        alert('Failed to load issue seller customers. Please try again.');
      }
    });
  }


  /** Fetch customers belonging to the Office Rep / Book Store department (पुस्तक भांडार) */
  loadOfficeRepCustomers() {
    this.isLoadingCustomers = true;
    this.selectedCustomers = [];
    const filters = this.buildFilterPayload();

    this.service.getOfficeRepCustomers(filters).subscribe({
      next: (data: any[]) => {
        this.selectedCustomers = data || [];
        this.isLoadingCustomers = false;
        this.customerPage = 1;
        this.showCustomerSummary = this.selectedCustomers.length > 0;
        if (!this.selectedCustomers.length) {
          alert('No customers found for the selected filters.');
        }
      },
      error: (err) => {
        console.error('Error loading office rep customers', err);
        this.isLoadingCustomers = false;
        alert('Failed to load office rep customers. Please try again.');
      }
    });
  }

  /** Fetch customers belonging to the Representative department (प्रतिनिधी) */
  loadRepresentativeCustomers() {
    this.isLoadingCustomers = true;
    this.selectedCustomers = [];
    const filters = this.buildFilterPayload();

    this.service.getRepresentativeCustomers(filters).subscribe({
      next: (data: any[]) => {
        this.selectedCustomers = data || [];
        this.isLoadingCustomers = false;
        this.customerPage = 1;
        this.showCustomerSummary = this.selectedCustomers.length > 0;
        if (!this.selectedCustomers.length) {
          alert('No customers found for the selected filters.');
        }
      },
      error: (err) => {
        console.error('Error loading representative customers', err);
        this.isLoadingCustomers = false;
        alert('Failed to load representative customers. Please try again.');
      }
    });
  }

  /**
   * Generic fallback — used when the selected department name doesn't match
   * any known keyword. Sends dep_id + filters to a single backend endpoint.
   */
  loadCustomersByDepartmentId() {
    this.isLoadingCustomers = true;
    this.selectedCustomers = [];
    const filters = this.buildFilterPayload();

    this.service
      .getCustomersByDepartment(this.formData.departmentId, filters)
      .subscribe({
        next: (data: any[]) => {
          this.selectedCustomers = data || [];
          this.isLoadingCustomers = false;
          this.customerPage = 1;
          this.showCustomerSummary = this.selectedCustomers.length > 0;
          if (!this.selectedCustomers.length) {
            alert('No customers found for the selected filters.');
          }
        },
        error: (err) => {
          console.error('Error loading customers by department', err);
          this.isLoadingCustomers = false;
          alert('Failed to load customers. Please try again.');
        }
      });
  }

  // ─── Next Step ─────────────────────────────────────────────────────────────

  /**
   * "Next" button handler — validates required fields then triggers the
   * department-appropriate customer load.  The summary panel opens automatically
   * once data arrives.
   */
  nextStep() {
    if (!this.formData.campaignId) {
      alert('Please select a campaign first.');
      return;
    }
    if (!this.formData.departmentId) {
      alert('Please select a department first.');
      return;
    }
    this.showCustomerSummary = false;
    this.loadCustomers();
  }

  constructor(
    private router: Router,
    private fb: FormBuilder,
    public service: DigisubservicesService,
    public dialog: MatDialog,
    public encr: EncdecriptService,
    private http: HttpClient
  ) {
    this.BookForm = fb.group({
      book_name: '',
      book_desc: '',
      book_price: '',
      event_saleprice: '',
      book_img: '',
      book_active: '',
    });

    this.magform = fb.group({
      magname: [''],
      magedition: [''],
      magamount: '',
      magyear: '',
      magdesc: '',
      magapp: '',
      magfullname: '',
    });

    this.magpriceupdate = fb.group({
      magname: [''],
      magedition: [''],
      magamount: '',
      magyear: '',
    });

    this.addNewAdminForm = fb.group({
      adminMobile: [''],
      adminEmail: [''],
      adminPassword: [''],
    });
    this.addIssueGranthaForm = fb.group({
      igcategory: [''],
      igsubcategory: [''],
    });
    this.advtSizesForm = fb.group({
      advt_category: [''],
      advt_size_name: ['', [Validators.required]],
      isactive: [''],
    });
    this.IssueDates = fb.group({
      advt_category: [''],
      issuedate: [],
      publisheddate: [],
      issue_name: ['', [Validators.required]],
      issue_price: [],
      lang: [],
      blackwhite: [''],
      insidecolour: [''],
      cover: [''],
      totalpages: [''],
      issuesize: [''],
      percopyweight: [''],
      prntdcopies: [''],
      maflitho: [''],
      lwc: [''],
      artpaper: [''],
      paperreams1: [''],
      paperreams2: [''],
      paperreams3: [''],
      rnireleated: [''],
    });
    this.StateMaster = fb.group({
      State_name: '',
    });

    this.CityMaster = fb.group({
      city_name: '',
      prant_name: '',
    });

    this.prantMaster = fb.group({
      prant_name: '',
      sequence_id: [''] 
    });

    this.TalukaMaster = fb.group({
      taluka_name: [''],
      pincode: [''],
    });

    this.MasterTable = fb.group({
      title: '',
    });

    this.OccupationMaster = fb.group({
      occupation: '',
    });

    this.repassigntype = fb.group({
      type: '',
    });
    this.repassignoff = fb.group({
      off_rep: '',
    });

    this.sbhet = fb.group({
      issuename: '',
      issuedate: '',
      issueseller: '',
      sbhet: '0',
      id: '',
      date: '',
      jahiratsbhet: '0',
      issuesbhet: '0',
      input_value: '0',
      input_value1: '0',
      input_value2: '0',
    });

    this.startenddate = fb.group({
      start: '',
      end: '',
      id: '',

    });

    // this.addform = this.fb.group({
    //   issuesellername: [''],
    //   address1: [''],
    //   pincode: [
    //     '',
    //     [Validators.maxLength(6), Validators.pattern('^[1-9][0-9]{5}$')],
    //   ],
    //   country: ['', [Validators.required, Validators.minLength(2)]],
    //   state: ['', [Validators.required, Validators.minLength(2)]],
    //   taluka: ['', [Validators.required, Validators.minLength(2)]],
    //   district: ['', [Validators.required, Validators.minLength(2)]],
    //   mnumber: [
    //     '',
    //     [
    //       Validators.minLength(10),
    //       Validators.maxLength(10),
    //       Validators.pattern('^[7-9][0-9]{9}$'),
    //     ],
    //   ],
    //   email: [
    //     '',
    //     [Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[a-z]{2,3}$')],
    //   ],
    //   landline_no: ['', Validators.pattern('^[0-9]\\d{2,4}-\\d{6,8}$')],
    //   dob: [],
    //   gstno: ['', [Validators.minLength(15), Validators.maxLength(15)]],
    //   panno: ['', [Validators.minLength(10), Validators.maxLength(10)]],
    //   depositamt: [],
    //   option: [''],
    //   sampremebhet: [''],
    //   distype: [''],
    //   issuename: [''],
    //   issuedate: [''],
    // });

    // this.addform = this.fb.group({

    //   // Name
    //   issuesellername: [''],           // DB: issueSellerName
    //   issuesellername_en: [''],           // DB: eng_issueSellerName

    //   // Address
    //   address1: [''],                  // DB: address
    //   address1_en: [''],                  // DB: e_Address

    //   // Pincode
    //   pincode: ['', [
    //     Validators.maxLength(6),
    //     Validators.pattern('^[1-9][0-9]{5}$'),
    //   ]],

    //   // Country
    //   country: ['', [Validators.required, Validators.minLength(2)]],  // DB: country
    //   country_en: [''],                                                    // DB: e_Country

    //   // State
    //   state: ['', [Validators.required, Validators.minLength(2)]],    // DB: state
    //   state_en: [''],                                                      // DB: e_State

    //   // District
    //   district: ['', [Validators.required, Validators.minLength(2)]], // DB: district
    //   district_en: [''],                                                   // DB: eng_districts

    //   // Taluka
    //   taluka: ['', [Validators.required, Validators.minLength(2)]],   // DB: taluka
    //   taluka_en: [''],                                                     // DB: e_Taluka

    //   // Contact
    //   mnumber: ['', [                                                      // DB: mobile_no
    //     Validators.minLength(10),
    //     Validators.maxLength(10),
    //     Validators.pattern('^[7-9][0-9]{9}$'),
    //   ]],
    //   mnumber_search: [''],   // Search-only — NOT saved to DB. Fixes duplicate-control bug.

    //   email: ['', [
    //     Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[a-z]{2,3}$'),
    //   ]],
    //   landline_no: ['', Validators.pattern('^[0-9]\\d{2,4}-\\d{6,8}$')],

    //   // Other
    //   dob: [],
    //   gstno: ['', [Validators.minLength(15), Validators.maxLength(15)]],
    //   panno: ['', [Validators.minLength(10), Validators.maxLength(10)]],
    //   depositamt: [],
    //   option: [''],
    //   sampremebhet: [''],
    //   distype: [''],
    //   issuename: [''],
    //   issuedate: [''],
    // });

    console.log('dept data:', this.getdeptdata);

    this.addform = this.fb.group({
      // Marathi fields (from DB)
      issuesellername: [''],           // DB: issueSellerName
      address1: [''],                  // DB: address
      country: ['', [Validators.required, Validators.minLength(2)]],  // DB: country
      state: ['', [Validators.required, Validators.minLength(2)]],    // DB: state
      district: ['', [Validators.required, Validators.minLength(2)]], // DB: district
      taluka: ['', [Validators.required, Validators.minLength(2)]],   // DB: taluka

      // English fields (from DB)
      issuesellername_en: [''],        // DB: eng_issueSellerName
      address1_en: [''],               // DB: e_Address
      country_en: [''],                // DB: e_Country
      state_en: [''],                  // DB: e_State
      district_en: [''],               // DB: eng_districts
      taluka_en: [''],                 // DB: e_Taluka
      start_date: [''],
      end_date: [''],
      narration: [''],
      rep_status: [''],

      // Other fields (from DB)
      pincode: ['', [Validators.maxLength(6), Validators.pattern('^[1-9][0-9]{5}$')]],  // DB: pincode
      mnumber: ['', [Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[7-9][0-9]{9}$')]],  // DB: mobile_no
      mnumber_search: [''],            // Search only field
      email: ['', [Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[a-z]{2,3}$')]],  // DB: email
      landline_no: ['', Validators.pattern('^[0-9]\\d{2,4}-\\d{6,8}$')],  // DB: landline_no
      dob: [],                         // DB: dateofbirth
      gstno: ['', [Validators.minLength(15), Validators.maxLength(15)]],  // DB: gst_no
      panno: ['', [Validators.minLength(10), Validators.maxLength(10)]],  // DB: pan_no
      depositamt: [],                  // DB: deposit_amt
      option: [''],                    // DB: issueSellerType
      sampremebhet: [''],              // DB: s_bhet
      distype: [''],                   // DB: distype
      issuename: [''],
      issuedate: ['']
    });

    this.form2 = this.fb.group({
      name: [''],
      mobileNumber: [''],
      email: '',
    });

    this.officerepform = fb.group({
      issuesellername: [''],
      address1: [''],
      pincode: [
        '',
        [Validators.maxLength(6), Validators.pattern('^[1-9][0-9]{5}$')],
      ],
      country: ['', [Validators.required, Validators.minLength(2)]],
      state: ['', [Validators.required, Validators.minLength(2)]],
      taluka: ['', [Validators.required, Validators.minLength(2)]],
      district: ['', [Validators.required, Validators.minLength(2)]],
      mnumber: [
        '',
        [
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern('^[7-9][0-9]{9}$'),
        ],
      ],
      email: [
        '',
        [Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[a-z]{2,3}$')],
      ],
      landline_no: ['', Validators.pattern('^[0-9]\\d{2,4}-\\d{6,8}$')],
      dob: [],
      gstno: ['', [Validators.minLength(15), Validators.maxLength(15)]],
      panno: ['', [Validators.minLength(10), Validators.maxLength(10)]],
      start_date: [''],
      end_date: [''],
      status: [1],
    });

    this.repassignform = fb.group({
      rep: [''],
      district: [''],
      taluka: [''],
      bookstore: [''],
      subscription: [''],
      advt: [''],
      issue: [''],
    });

    this.addcountry = fb.group({
      country_name: [''],
      country_code: [''],
      sequence_id: [''],

    });
    this.addseni = fb.group({
      off_repname: [''],
      seniority: [''],
      dept: ['']

    });

    this.addlang = fb.group({
      language: ['']

    });


    this.NewMagazineForm = fb.group({
      mag_name: [''],
      ig_cat: [''],
    });

    this.rep_List();
  }

  filteredOptions4: Observable<string[]>;
  filteredOptions5: Observable<string[]>;
  filteredOptions6: Observable<string[]>;
  filteredOptions7: Observable<string[]>;
  filteredOptions8: Observable<string[]>;
  filteredOptions9: Observable<string[]>;
  filteredOptions10: Observable<string[]>;
  filteredOptions11: Observable<string[]>;
  isAdminAuthorize = false;
  countries = [];
  states = [];
  state_count = 0;
  cities = [];
  talukas = [];
  selectedTaluka;
  city_count = 0;
  taluka_count = 0;
  titles = [];
  occupations = [];
  issueSellerName: any = [];
  issue_seller_name = [];
  office_rep = [];
  advtCategorylist;
  deptwise_off_rep_list = [];
  MagazineIssueGranthData = [];
  MagazineIssueGranthMag_names = [];
  advtsizesData = [];
  FilteredadvtsizesData = [];
  issueDatesData = [];
  FilteredissueDatesData = [];
  prantData;

  isAddingNewRep: boolean = false;
  public demo1TabIndex = 0

  public demo1BtnClick1(tabCount: any) {

    this.demo1TabIndex = Number(tabCount);

  }

  ngOnInit() {
    this.loadCampaigns();
    this.loadDepartments();
    this.loadCountries();
    // this.applyFilters();
    

    this.demo1BtnClick1(localStorage.getItem("tab"))

    this.service.getdepwiserepcount().subscribe((data) => {
      this.getdepwiserepcount1 = data;
    });
    //  this.service.getdepwiserepcount().subscribe((data) => {
    //   this.getrepname = data;
    // });



    this.service.getcountry().subscribe((data) => {
      this.getcountry = data;
    });

    this.service.getseniority().subscribe((data) => {
      this.senioritylist = data;
    });

    this.service.getlanguagelist().subscribe((data) => {
      this.languagelist = data;
    });


    this.service.getoffrepname().subscribe((data) => {
      this.getrepname = data;
    });

    // KEEP only this one — remove the duplicate below it
    this.service.getOfficeRepName().subscribe((officedata) => {

      
      const mapped = (officedata as any[]).map(item => ({
        id: item.id,
        issuesellername: item.name || item.officerep || '',
        mnumber: item.mob_no || item.mob_number || '',
        address: item.address || '',
        pincode: item.pincode || '',
        country: item.country || '',
        state: item.state || '',
        district: item.district || '',
        taluka: item.taluka || '',
        email: item.email || '',
        is_deleted: item.is_deleted || 'N',
        isActive: item.is_deleted === 'N',
        start_date: item.start_date || '',
        end_date: item.end_date || '',
        status: item.status ?? 1,
      })).sort((a, b) =>
        a.issuesellername.localeCompare(b.issuesellername, 'mr', { sensitivity: 'base' })
      );
      // Temporary debug — remove after confirming
console.log('Sample status values:', mapped.slice(0, 3).map(r => ({ name: r.issuesellername, status: r.status, type: typeof r.status })));

      this.office_rep = mapped;
      this.allRepresentatives = mapped;
      this.filteredRepresentatives = mapped;
      this.officeRepDataSource.data = mapped;

      if (this.paginator) {
        this.officeRepDataSource.paginator = this.paginator;
      }
    });


    this.IssueDates.get('issue_name').setValue('विवेक साप्ताहिक');
    this.IssueDates.get('issue_price').setValue(20);
    this.IssueDates.get('lang').setValue('मराठी');
    // Read All Contries
    this.service.getCountry().subscribe((data) => {
      this.countries = data;
    });

    this.service.getDeliveryMode().subscribe((data) => {
      // console.log('getDeliveryMode', data);
      this.delivery_mode = data;
    });

    this.service.getIssueSellerName().subscribe((data) => {
      this.issueSellerName = data;
      // this.repList = data as any[];
      this.repList = Array.isArray(data) ? data : Object.values(data);
      this.buildFilterDropdowns();   // ← ADD
      this.applyFilters();

      // console.log('issueSellerName ', data);
    });

    this.service.getSbhetdataadmin().subscribe((data) => {
      debugger
      this.sbhetdata = data;
      this.searchData = [...this.sbhetdata];
      console.log('issueSellerName of sbhet ', data);
    });
    this.service.getdeactivedata().subscribe((data) => {
      this.deactivedata = data;
      console.log('issueSellerName of sbhet ', data);
    });

    this.service.getIssuesellersname().subscribe((data) => {
      this.issue_seller_name = data;
      console.log('issue_seller_name', this.issue_seller_name);
    });

    this.service.getOfficeRepName().subscribe((officedata) => {
      // console.log('office_rep', officedata);
      this.office_rep = officedata;
    });

    this.service.getAdvtCategory().subscribe((data) => {
      // console.log('Database data', data);
      this.advtCategorylist = data;
    });

    this.service.getLanguageList().subscribe((data) => {
      // console.log('Database data', data);
      this.getLanguageList1 = data;
    });

    this.service.getOccupation().subscribe((data) => {
      // console.log(data);
      this.occupations = data;
    });

    this.service.getstates(1).subscribe((data) => {
      // console.log(data);
      this.states = data;
      this.state_count = this.states.length;
    });

    this.getAdvtMagDetails();

    this.service.getAlltitle().subscribe((data) => {
      // console.log(data);
      this.titles = data;
    });

    if (sessionStorage.getItem('mobile') == null) {
      this.router.navigate(['/']);
    }

    this.magform.get('magedition').setValue('Digital');

    this.service
      .checkadminissuper(parseInt(sessionStorage.getItem('id')))
      .subscribe((a) => {
        if (Object.keys(a).length > 0) {
          this.isAdminAuthorize = true;
        } else {
          this.isAdminAuthorize = false;
        }
      });

    //change for OEM
    this.service.getMag().subscribe((res) => {
      //console.log(res['name'])
      this.mag = [];
      this.magname = [];
      this.magyear = [];

      for (let i = 0; i < Object.keys(res).length; i++) {
        this.mag.push({
          name: res[i]['name'],
          print: res[i]['print'],
          digital: res[i]['digital'],
          printdigital: res[i]['printdigital'],
          year: parseInt(res[i]['year']),
        });

        if (i == 0) {
          this.magname[0] = {
            name: res[i]['name'],
          };

          this.magyear[0] = {
            year: parseInt(res[i]['year']),
          };
        } else {
          // console.log(this.magname.find((a) => a['name'] == res[i]['name']));

          if (
            this.magname.find((a) => a['name'] == res[i]['name']) == undefined
          ) {
            this.magname.push({
              name: res[i]['name'],
            });
          }

          this.magyear.push({
            year: parseInt(res[i]['year']),
          });
        }

        // console.log(this.magname);
      }

      this.autocomfunction();
      //name.push(amount)
    });
    // console.log('array ', this.newDateArray.length)
    this.getMagazineIssueGranthData();
    this.getAllAdvtSizes();
    this.getAllIssueDates();
    this.getAllPrantData();

    this.filteredOptions = this.sbhet.get('id').valueChanges.pipe(
      startWith(''), map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) =>
        name ? this._filter(name) : this.issue_seller_name.slice()
      )
    );
  }

  campaignName: string = '';
  addCampaign() {
    if (!this.campaignName) {
      alert('Please Enter Campaign Name');
      return;
    }

    this.service.addCampaign({ name: this.campaignName }).subscribe(
      () => {
        alert('Campaign Added Successfully');
        this.campaignName = '';
        this.loadCampaigns();
      },
      (err) => {
        alert('Failed to add campaign. Please try again.');
        console.error(err);
      }
    );
  }

  loadCampaigns() {
    this.service.getCampaigns().subscribe((data: any[]) => {
      this.campaignList = data;
    });
  }

  deleteCampaign(campaign: any) {
    if (!confirm(`Delete campaign "${campaign.name}"? This cannot be undone.`)) {
      return;
    }
    this.service.deleteCampaign(campaign.id).subscribe({
      next: () => {
        // Clear selection if the deleted campaign was currently selected
        if (String(this.formData.campaignId) === String(campaign.id)) {
          this.formData.campaignId = '';
        }
        this.loadCampaigns();
      },
      error: (err) => {
        console.error('Failed to delete campaign', err);
        alert('Failed to delete campaign. Please try again.');
      }
    });
  }

  startEditCampaign(campaign: any) {
    this.editingCampaign = campaign;
    this.editCampaignName = campaign.name;
  }

  cancelEditCampaign() {
    this.editingCampaign = null;
    this.editCampaignName = '';
  }

  saveEditCampaign() {
    const name = this.editCampaignName.trim();
    if (!name) {
      alert('Campaign name cannot be empty.');
      return;
    }
    this.service.editCampaign(this.editingCampaign.id, name).subscribe({
      next: () => {
        // Update the dropdown selection label if this campaign is selected
        if (String(this.formData.campaignId) === String(this.editingCampaign.id)) {
          this.formData.campaignId = this.editingCampaign.id; // keep selection
        }
        this.editingCampaign = null;
        this.editCampaignName = '';
        this.loadCampaigns();
      },
      error: (err) => {
        console.error('Failed to update campaign', err);
        alert('Failed to update campaign. Please try again.');
      }
    });
  }

  // loadDepartments() {
  //   this.service.getdept().subscribe((data: any[]) => {
  //     this.departmentList = data;
  //   });
  // }
  loadDepartments() {
    this.service.getdept().subscribe((data: any[]) => {
      this.getdeptdata = data;
      this.departmentList = data;
    });
  }

  loadCountries() {
    this.service.getCountry().subscribe((data) => {
      this.countryList = data;
    });
  }


  updateOfficeRepForm(): void {
    const f = this.officerepform;
    const payload = {
      id: this.repId1,
      officerep: f.get('issuesellername').value,
      address1: f.get('address1').value,
      pincode: f.get('pincode').value,
      country: f.get('country').value,
      state: f.get('state').value,
      district: f.get('district').value,
      taluka: f.get('taluka').value,
      mnumber: f.get('mnumber').value,
      email: f.get('email').value,
      landline_no: f.get('landline_no').value || '',
      dob: f.get('dob').value || '',
      gstno: f.get('gstno').value || '',
      panno: f.get('panno').value || '',
      start_date: f.get('start_date').value || '',
      end_date: f.get('end_date').value || '',
      status: Number(f.get('status').value),


    };

    this.service.updateOfficeRepT(payload).subscribe({
      next: () => {
        alert('Representative updated successfully.');
        this.isEditingOffRep = false;
        this.repId1 = 0;
        this.officerepform.reset();
        this.ngOnInit();
      },
      error: (err) => {
        console.error('Update failed', err);
        alert('Failed to update. Please try again.');
      }
    });
  }


  // =============================
  // COUNTRY CHANGE
  // =============================

  onCountryChange() {

    if (!this.formData.countryId) {
      this.stateList = [];
      this.districtList = [];
      this.talukaList = [];
      return;
    }

    this.formData.stateId = '';
    this.formData.districtId = '';
    this.formData.talukaId = '';

    this.stateList = [];
    this.districtList = [];
    this.talukaList = [];

    this.service.getStatesByCountryId(this.formData.countryId)
      .subscribe({
        next: (data: any) => {
          this.stateList = data;
        },
        error: (err) => {
          console.error('Error loading states', err);
        }
      });
  }


  // editRep(row: any): void {
  //   this.selected_repname = true;
  //   this.repId1 = row.id;

  //   // Scroll to form
  //   const formEl = document.querySelector('.or-form');
  //   if (formEl) formEl.scrollIntoView({ behavior: 'smooth', block: 'start' });

  //   // Find full rep data from repList (has all fields)
  //   const fullData = this.repList.find(r => r['id'] === row.id) || row;

  //   const formatDateSafe = (val: string) => {
  //     if (!val || val === '0000-00-00' || val === '0000-00-00 00:00:00') return '';
  //     return val.substring(0, 10);
  //   };

  //   this.addform.patchValue({
  //     issuesellername:    fullData['issueSellerName'] || '',
  //     issuesellername_en: fullData['eng_issueSellerName'] || '',
  //     address1:           fullData['address'] || '',
  //     address1_en:        fullData['e_Address'] || '',
  //     pincode:            fullData['pincode'] || '',
  //     country:            fullData['country'] || '',
  //     country_en:         fullData['e_Country'] || '',
  //     state:              fullData['state'] || '',
  //     state_en:           fullData['e_State'] || '',
  //     district:           fullData['district'] || '',
  //     district_en:        fullData['eng_districts'] || '',
  //     taluka:             fullData['taluka'] || '',
  //     taluka_en:          fullData['e_Taluka'] || '',
  //     mnumber:            fullData['mobile_no'] || '',
  //     email:              fullData['email'] || '',
  //     landline_no:        fullData['landline_no'] || '',
  //     dob:                formatDateSafe(fullData['dateofbirth']),
  //     gstno:              fullData['gst_no'] || '',
  //     panno:              fullData['pan_no'] || '',
  //     depositamt:         fullData['deposit_amt'] || '',
  //     option:             fullData['issueSellerType'] || '',
  //     sampremebhet:       fullData['s_bhet'] || '',
  //     distype:            fullData['distype'] || '',
  //     start_date:         formatDateSafe(fullData['start_date']),
  //     end_date:           formatDateSafe(fullData['end_date']),
  //     narration:          fullData['narration'] || '',
  //     rep_status:         (fullData['status'] || fullData['rep_status'] || '').toLowerCase(),
  //   });

  //   this.selectedCity   = fullData['district'];
  //   this.selectedTaluka = fullData['taluka'];
  //   this.selectedState  = fullData['state'];

  //   this.loadLocationDropdowns(fullData);
  // }

  // deleteRep(row: any): void {
  //   if (!confirm(`Mark "${row.issuesellername}" as inactive?`)) return;

  //   const payload = {
  //     id: row.id,
  //     status: 'deactive'
  //   };

  //   this.service.updateActiveStatus('deactive', row.id).subscribe({
  //     next: () => {
  //       alert('Representative marked as inactive.');
  //       // Update local list without full reload
  //       this.allRepresentatives = this.allRepresentatives.map(r =>
  //         r.id === row.id ? { ...r, isActive: false } : r
  //       );
  //       this.officeRepDataSource.data = [...this.allRepresentatives];
  //       this.filteredRepresentatives = [...this.allRepresentatives];
  //     },
  //     error: (err) => {
  //       console.error('Delete failed', err);
  //       alert('Failed to update status. Please try again.');
  //     }
  //   });
  // }


  editRep(row: any): void {
    this.isEditingOffRep = true;
    this.repId1 = row.id;

    // Scroll to form
    const formEl = document.querySelector('.or-form');
    if (formEl) formEl.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // row already has all mapped fields from allRepresentatives
    // Also try to get extra fields (dob, gstno, panno) from office_rep array
    const extraData = (this.office_rep as any[]).find(r => r.id === row.id) || {};

    this.officerepform.patchValue({
      issuesellername: row.issuesellername || '',
      address1: extraData['address'] || '',
      pincode: extraData['pincode'] || '',
      country: extraData['country'] || row.country || '',
      state: extraData['state'] || row.state || '',
      district: row.district || '',
      taluka: row.taluka || '',
      mnumber: row.mnumber || '',
      email: row.email || '',
      landline_no: extraData['landline_no'] || '',
      dob: extraData['dob'] || '',
      gstno: extraData['gstno'] || '',
      panno: extraData['panno'] || '',
      start_date: row.start_date || '',
      end_date: row.end_date || '',
      status: row.status !== undefined && row.status !== null ? Number(row.status) : 1,
    });

    

    // Load location dropdowns so state/district/taluka selects work
    if (extraData['country'] || row.country) {
      this.loadLocationDropdowns({
        country: extraData['country'] || row.country || '',
        state: extraData['state'] || row.state || '',
        district: row.district || '',
        taluka: row.taluka || '',
      });
    }

    setTimeout(() => {
    document.querySelector('.or-card')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 100);

  }


  deleteRep(row: any): void {
    if (!confirm(`Mark "${row.issuesellername}" as inactive?`)) return;

    this.service.deleteOfficeRep(row.id).subscribe({
      next: () => {
        alert('Representative deleted successfully.');
        this.allRepresentatives = this.allRepresentatives.filter(r => r.id !== row.id);
        this.officeRepDataSource.data = [...this.allRepresentatives];
        this.filteredRepresentatives = [...this.allRepresentatives];
      },
      error: (err) => {
        console.error('Delete failed', err);
        alert('Failed to delete. Please try again.');
      }
    });
  }


  onStateChange() {

    this.formData.districtId = '';
    this.formData.talukaId = '';

    this.districtList = [];
    this.talukaList = [];

    this.service.getDistrictsByStateId(this.formData.stateId)
      .subscribe({
        next: (data: any) => {
          this.districtList = data;
        },
        error: (err) => {
          console.error('Error loading districts', err);
        }
      });
  }

  // =============================
  // DISTRICT CHANGE
  // =============================

  onDistrictChange() {

    this.formData.talukaId = '';
    this.talukaList = [];

    this.service.getTalukasByDistrictId(this.formData.districtId)
      .subscribe({
        next: (data: any) => {
          this.talukaList = data;
        },
        error: (err) => {
          console.error('Error loading talukas', err);
        }
      });
  }

  // =============================
  // SEND WHATSAPP MESSAGE
  // =============================

  sendWhatsappMessage() {

    if (!this.selectedCustomers.length) {
      alert('No customers selected to send message.');
      return;
    }

    const campaign = this.campaignList.find(c => c.id == this.formData.campaignId);
    if (!campaign) {
      alert('Please select a campaign before sending.');
      return;
    }

    const customerFields = Object.keys(this.selectedCustomers[0]);

    const dialogRef = this.dialog.open(WpParamMappingDialogComponent, {
      width: '560px',
      panelClass: 'wpm-dialog-panel',
      data: { campaignName: campaign.name, customerFields }
    });

    dialogRef.afterClosed().subscribe(mappings => {
      if (!mappings) return;

      // Reset report before each send
      this.sendReport = { sent: [], failed: [], isSending: true, isComplete: false };

      let processed = 0;
      const total = this.selectedCustomers.length;

      this.selectedCustomers.forEach(customer => {
        const templateParams = mappings.map((m: any) =>
          m.type === 'field' ? (customer[m.value] ?? '') : m.value
        );

        const payload = {
          mobile: customer.mobile,
          campaignName: campaign.name,
          templateParams
        };

        this.service.sendWhatsAppMSG(payload).subscribe({
          next: (res) => {
            console.log('Message sent to', customer.mobile, res);
            this.sendReport.sent.push({ ...customer });
            processed++;
            if (processed === total) {
              this.sendReport.isSending = false;
              this.sendReport.isComplete = true;
            }
          },
          error: (err) => {
            console.error('Failed to send to', customer.mobile, err);
            this.sendReport.failed.push({ ...customer });
            processed++;
            if (processed === total) {
              this.sendReport.isSending = false;
              this.sendReport.isComplete = true;
            }
          }
        });
      });
    });

  }

  /**
   * Exports the send report as an Excel file with two sheets:
   *  • "Sent"   — customers who received the message successfully
   *  • "Failed" — customers where sending failed
   */
  downloadSendReport() {
    const toRows = (list: any[]) =>
      list.map((c, i) => ({
        'Sr. No': i + 1,
        'Name': c.name || '',
        'Mobile': c.mobile || '',
        'Status': list === this.sendReport.sent ? 'Sent' : 'Failed'
      }));

    const wb = XLSX.utils.book_new();
    const sentSheet = XLSX.utils.json_to_sheet(
      this.sendReport.sent.length ? toRows(this.sendReport.sent) : [{ 'Sr. No': '', Name: '', Mobile: '', Status: 'No records' }]
    );
    const failSheet = XLSX.utils.json_to_sheet(
      this.sendReport.failed.length ? this.sendReport.failed.map((c, i) => ({
        'Sr. No': i + 1,
        'Name': c.name || '',
        'Mobile': c.mobile || '',
        'Status': 'Failed'
      })) : [{ 'Sr. No': '', Name: '', Mobile: '', Status: 'No records' }]
    );

    XLSX.utils.book_append_sheet(wb, sentSheet, 'Sent');
    XLSX.utils.book_append_sheet(wb, failSheet, 'Failed');

    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const today = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN');
    saveAs(
      new Blob([buf], { type: 'application/octet-stream' }),
      `whatsapp_report_${today}.xlsx`
    );
  }

  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.issue_seller_name.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }
  filteredOptions: any = []

  getAllAdvtSizes() {
    this.service.getAllAdvtSizes().subscribe((data) => {
      // console.log(data);
      this.advtsizesData = data;
      this.FilteredadvtsizesData = this.advtsizesData;
    });
  }

  getAllIssueDates() {
    this.service.getAllIssueDates().subscribe((data) => {
      this.issueDatesData = data;
      this.FilteredissueDatesData = this.issueDatesData;
    });
  }

  autocomfunction() {
    this.service.getDeptwiseOffRepList().subscribe((data) => {
      // console.log(data);
      this.deptwise_off_rep_list = data;
    });

    this.filteredOptions4 = this.addform
      .get('issuesellername')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) =>
          name ? this._filter4(name) : this.issue_seller_name.slice()
        )
      );

    console.log(this.issue_seller_name, "this name list")

    this.filteredOptions5 = this.addform.get('mnumber_search').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.mob_no)),
      map((mob_no) =>
        mob_no ? this._filter5(mob_no) : this.issue_seller_name.slice()
      )
    );

    this.filteredOptions6 = this.repassignform.get('rep').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) =>
        name ? this._filter6(name) : this.issue_seller_name.slice()
      )
    );

    this.filteredOptions7 = this.repassignform
      .get('bookstore')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) => (name ? this._filter7(name) : this.office_rep.slice()))
      );

    this.filteredOptions8 = this.repassignform
      .get('subscription')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) => (name ? this._filter8(name) : this.office_rep.slice()))
      );

    this.filteredOptions9 = this.repassignform.get('advt').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) => (name ? this._filter9(name) : this.office_rep.slice()))
    );

    this.filteredOptions10 = this.repassignform.get('issue').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) => (name ? this._filter10(name) : this.office_rep.slice()))
    );

    this.filteredOptions11 = this.NewMagazineForm.get(
      'mag_name'
    ).valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.mag_name)),
      map((mag_name) =>
        mag_name
          ? this._filter11(mag_name)
          : this.MagazineIssueGranthMag_names.slice()
      )
    );
  }

  private _filter4(name: string): any[] {
    const filterValue = name;
    return this.issue_seller_name.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter5(mob_no: string): any[] {
    const filterValue = mob_no;
    return this.issue_seller_name.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.mob_no.toLowerCase().includes(filterValue)
    );
  }

  private _filter6(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.issue_seller_name.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter7(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.office_rep.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter8(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.office_rep.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter9(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.office_rep.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter10(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.office_rep.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter11(mag_name: string): any[] {
    const filterValue = mag_name.toLowerCase();

    return this.MagazineIssueGranthMag_names.filter((option) =>
      option.mag_name.toLowerCase().includes(filterValue)
    );
  }

  //   updateRepData(item: any) {
  //     this.selected_repname = true;
  //     this.repId1 = item['id'];

  //     // this.addform.patchValue({
  //     //   issuesellername: item['issueSellerName'] || '',
  //     //   address1: item['address'] || '',
  //     //   country: item['country'] || '',
  //     //   state: item['state'] || '',
  //     //   district: item['district'] || '',
  //     //   taluka: item['taluka'] || '',
  //     //   pincode: item['pincode'] || '',
  //     //   mnumber: item['mobile_no'] || '',
  //     //   email: item['email'] || '',
  //     //   landline_no: item['landline_no'] || '',
  //     //   dob: item['dateofbirth'] || '',
  //     //   gstno: item['gst_no'] || '',
  //     //   panno: item['pan_no'] || '',
  //     //   depositamt: item['deposit_amt'] || '',
  //     //   option: item['issueSellerType'] || '',
  //     //   sampremebhet: item['s_bhet'] || '',
  //     //   distype: item['distype'] || '',
  //     //   issuesellername_en: item['eng_issueSellerName'] || '',
  //     //   address1_en: item['e_Address'] || '',
  //     //   country_en: item['e_Country'] || '',
  //     //   state_en: item['e_State'] || '',
  //     //   district_en: item['eng_districts'] || '',
  //     //   taluka_en: item['e_Taluka'] || '',
  //     //   start_date: item['start_date']
  //     //     ? item['start_date'].substring(0, 10)
  //     //     : '',

  //     //   end_date: item['end_date']
  //     //     ? item['end_date'].substring(0, 10)
  //     //     : '',

  //     //   rep_status: (item['rep_status'] || item['status'] || '').toLowerCase(),

  //     //   narration: item['narration'] || '',



  //     // });

  //     // Translate empty English fields on-the-fly


  //     this.addform.patchValue({
  //   issuesellername: item.issueSellerName,
  //   issuesellername_en: item.eng_issueSellerName,
  //   address1: item.address,
  //   pincode: item.pincode,
  //   country: item.country,
  //   state: item.state,
  //   district: item.district,
  //   taluka: item.taluka,
  //   mnumber: item.mobile_no,
  //   email: item.email,
  //   landline_no: item.landline_no,
  //   dob: item.dateofbirth,
  //   gstno: item.gst_no,
  //   panno: item.pan_no,
  //   depositamt: item.deposit_amt,
  //   option: item.issueSellerType,
  //   sampremebhet: item.s_bhet,
  //   distype: item.distype,

  //   start_date: item.start_date,
  //   end_date: item.end_date,
  //   narration: item.narration,
  //    rep_status: item['rep_status'] ? item['rep_status'].toLowerCase() : ''
  // });


  //     const translateIfEmpty = (dbValue: string, marathiValue: string, targetCtrl: string) => {
  //       if (!dbValue && marathiValue) {
  //         this.translateText(marathiValue, 'mr', 'en').subscribe({
  //           next: (t) => this.addform.get(targetCtrl)?.setValue(t, { emitEvent: false }),
  //         });
  //       }
  //     };
  //     translateIfEmpty(item['eng_issueSellerName'], item['issueSellerName'], 'issuesellername_en');
  //     translateIfEmpty(item['e_Address'], item['address'], 'address1_en');
  //     translateIfEmpty(item['e_Country'], item['country'], 'country_en');
  //     translateIfEmpty(item['e_State'], item['state'], 'state_en');
  //     translateIfEmpty(item['eng_districts'], item['district'], 'district_en');
  //     translateIfEmpty(item['e_Taluka'], item['taluka'], 'ta  luka_en');

  //     this.selectedCity = item['district'];
  //     this.selectedTaluka = item['taluka'];
  //     this.selectedState = item['state'];

  //     this.loadLocationDropdowns(item);
  //   }

  updateRepData(item: any) {
    this.selected_repname = true;
    this.repId1 = item['id'];

    // Format dates safely — handles both 'yyyy-MM-dd' and 'yyyy-MM-dd HH:mm:ss'
    const formatDateSafe = (val: string) => {
      if (!val || val === '0000-00-00' || val === '0000-00-00 00:00:00') return '';
      return val.substring(0, 10); // always take first 10 chars: yyyy-MM-dd
    };

    this.addform.patchValue({
      issuesellername: item['issueSellerName'] || '',
      issuesellername_en: item['eng_issueSellerName'] || '',
      address1: item['address'] || '',
      address1_en: item['e_Address'] || '',
      pincode: item['pincode'] || '',
      country: item['country'] || '',
      country_en: item['e_Country'] || '',
      state: item['state'] || '',
      state_en: item['e_State'] || '',
      district: item['district'] || '',
      district_en: item['eng_districts'] || '',
      taluka: item['taluka'] || '',
      taluka_en: item['e_Taluka'] || '',
      mnumber: item['mobile_no'] || '',
      email: item['email'] || '',
      landline_no: item['landline_no'] || '',
      dob: formatDateSafe(item['dateofbirth']),
      gstno: item['gst_no'] || '',
      panno: item['pan_no'] || '',
      depositamt: item['deposit_amt'] || '',
      option: item['issueSellerType'] || '',
      sampremebhet: item['s_bhet'] || '',
      distype: item['distype'] || '',

      // ── These 4 are the ones not showing ──
      start_date: formatDateSafe(item['start_date']),
      end_date: formatDateSafe(item['end_date']),
      narration: item['narration'] || '',
      rep_status: (item['status'] || '').toLowerCase(),
    });

    this.selectedCity = item['district'];
    this.selectedTaluka = item['taluka'];
    this.selectedState = item['state'];

    this.loadLocationDropdowns(item);
  } zzzzz


  selected_repname = false;

  option = false;
  select(event) {
    // console.log(event.value);
    if (event.value == 'agent') {
      this.option = true;
    } else {
      this.option = false;
    }
  }

  validmobile = false;
  validemail = false;
  validdob = false;
  validateMobile(event) {
    if (this.addform.get('mnumber').valid) {
      this.validmobile = true;
    } else {
      this.validmobile = false;
    }
  }

  validatemobile(event) {
    if (this.officerepform.get('mnumber').valid) {
      this.validmobile = true;
    } else {
      this.validmobile = false;
    }
  }

  validateEmail(event) {
    if (this.addform.get('email').valid) {
      this.validemail = true;
    } else {
      this.validemail = false;
    }
  }

  validateemail(event) {
    if (this.officerepform.get('email').valid) {
      this.validemail = true;
    } else {
      this.validemail = false;
    }
  }

  validatedob(event) {
    if (this.addform.get('dob').valid) {
      this.validdob = true;
    } else {
      this.validdob = false;
    }
  }

  validateDob(event) {
    if (this.addform.get('dob').valid) {
      this.validdob = true;
    } else {
      this.validdob = false;
    }
  }

  rep_id = 0;
  rep_name = '';
  rep_off_assign_id = 0;
  isdata: boolean = false;
  selected_name(event, option) {
    if (event.isUserInput) {
      this.rep_id = option['id'];
      this.repassignform.get('district').setValue(option['district']);
      this.repassignform.get('taluka').setValue(option['taluka']);

      for (
        let index = 0;
        index < Object.keys(this.deptwise_off_rep_list).length;
        index++
      ) {
        if (this.deptwise_off_rep_list[index]['rep_name'] == option['name']) {
          this.isdata = true;
          this.rep_off_assign_id = this.deptwise_off_rep_list[index]['id'];
          this.rep_id = this.deptwise_off_rep_list[index]['rep_id'];
          this.book_id = this.deptwise_off_rep_list[index]['book_id'];
          this.repassignform
            .get('bookstore')
            .setValue(this.deptwise_off_rep_list[index]['book_off_rep_name']);
          this.sub_id = this.deptwise_off_rep_list[index]['sub_id'];
          this.repassignform
            .get('subscription')
            .setValue(this.deptwise_off_rep_list[index]['sub_off_rep_name']);
          this.advt_id = this.deptwise_off_rep_list[index]['advt_id'];
          this.repassignform
            .get('advt')
            .setValue(this.deptwise_off_rep_list[index]['advt_off_rep_name']);
          this.issue_id = this.deptwise_off_rep_list[index]['issue_id'];
          this.repassignform
            .get('issue')
            .setValue(this.deptwise_off_rep_list[index]['issue_off_rep_name']);
        }
      }
    }
  }

  book_id;
  selected_bookstore(event) {
    this.book_id = event['id'];
    this.repassignform.get('bdistrict').setValue(event['district']);
    this.repassignform.get('btaluka').setValue(event['taluka']);
  }

  sub_id;
  selected_subs(event) {
    this.sub_id = event['id'];
    this.repassignform.get('sdistrict').setValue(event['district']);
    this.repassignform.get('staluka').setValue(event['taluka']);
  }

  advt_id;
  selected_advt(event) {
    this.advt_id = event['id'];
    this.repassignform.get('adistrict').setValue(event['district']);
    this.repassignform.get('ataluka').setValue(event['taluka']);
  }

  issue_id;
  selected_issue(event) {
    this.issue_id = event['id'];
    this.repassignform.get('idistrict').setValue(event['district']);
    this.repassignform.get('italuka').setValue(event['taluka']);
  }

  removeEvent(event_id) {
    this.service.removeEvent(parseInt(event_id)).subscribe((res) => {
      window.alert('Event Deleted !');
    });
  }

  removeMag(magname) {
    if (window.confirm('Do you really want to remove the magazine?')) {
      // console.log(magname);
      this.service.removeMag(magname).subscribe((mag) => {
        //console.log(mag)

        window.alert('Magazine Removed Successfully.');
        //change for OEM
        this.service.getMag().subscribe((res) => {
          //console.log(res['name'])
          this.mag = [];

          for (let i = 0; i < Object.keys(res).length; i++) {
            this.mag.push({
              name: res[i]['name'],
              print: res[i]['print'],
              digital: res[i]['digital'],
              printdigital: res[i]['printdigital'],
              year: parseInt(res[i]['year']),
            });
          }
          //name.push(amount)
        });
      });
    }
  }

  action(row: any) {
    if (row.operation === 'updated') {
      //this.update(row); // This is your update call to API
      this.yourMessage.push('success', 'updated successfully'); // Show update success notification
      this.yourMessage = []; // make sure you empty it
    }

    if (row.operation === 'deleted') {
      //this.delete(row.id); // This is your delete call to API
      this.yourMessage.push('success', 'deleted successfully'); // Show delete success notification
      this.yourMessage = []; // make sure you empty it
    }
  }

  rep_List() {
    let filterdData: string[];
    this.service.get_AllRepresentative_List().subscribe((data) => {
      this.data1 = data;
      //console.log("Data from PHP : ", this.data1);
      //console.log(this.data1.filter(item => { return item['name'] != "office" }))

      this.data1 = this.data1.filter((item) => {
        return item['name'] != 'office';
      });

      //Object.values(this.data1).filter(key => !this.data1.includes)
      for (let index = 0; index < Object.keys(this.data1).length; ++index) {
        if (parseInt(this.data1[index]['id']) > 50) {
          this.tableData.push({
            id: this.data1[index]['id'],
            name: this.data1[index]['name'],
            mobile: this.data1[index]['mobile'],
          });
          continue;
        }
      }

      if (Object.keys(this.tableData).length == 0) {
        this.dataLoaded = false;
      } else {
        this.dataLoaded = true;
      }
    });
  }

  getAdvtMagDetails() {
    this.advt_mag_name_details = [];
    this.stateGroups = [];
    let abc;
    this.service.getAdvtMagNames().subscribe((data) => {
      // console.log(data);
      for (let index = 0; index < Object.keys(data).length; index++) {
        // console.log(data[index]);
        this.advt_mag_name_details.push({
          id: data[index]['id'],
          is_active: data[index]['is_active'],
          issue_name: data[index]['issue_name'],
          category: data[index]['category'],
          publishing_date: data[index]['publishing_date'].split(','),
        });

        if (index == 0) {
          // console.log(
          //   data.filter((a) => a.category == data[index]['category'])
          // );
        }

        if (
          this.stateGroups.find((a) => a.category == data[index]['category']) ==
          undefined
        ) {
          let mags = data.filter((a) => a.category == data[index]['category']);
          let mag_to_list = [];
          for (let index = 0; index < Object.keys(mags).length; index++) {
            mag_to_list.push(mags[index]['issue_name']);
          }
          this.stateGroups.push({
            category: data[index]['category'],
            details: mag_to_list,
          });
        }
      }

      this.Filteredadvt_mag_name_details = this.advt_mag_name_details;

      // console.log(this.stateGroups);
      //this.advt_mag_name_details = data
    });
  } //end of getAdvtMagDetails

  make_it_activate(advt) {
    // console.log(' advt id', advt['id']);
    this.service.updateAdvtMagStatus(advt['id'], 'Y').subscribe((data) => {
      // console.log('fetched data', data);
      this.getAdvtMagDetails();
      window.alert('Status Change!');
    });
  }

  isadminexist(event) {
    const mobile = event.target.value;
    this.service.checkadminisexist(parseInt(mobile)).subscribe((a) => {
      if (Object.keys(a).length > 0) {
        window.alert('Admin Already exist with this Number');
        this.addNewAdminForm.get('adminPassword').disable();
      } else {
        this.addNewAdminForm.get('adminPassword').disable();
      }
    });
  }

  superAdmin(id) {
    this.service.makesuperAdmin(id, 'Y').subscribe((a) => {
      this.service.getalladmin().subscribe((ad) => {
        this.getalladmins = [];
        for (let index = 0; index < Object.keys(ad).length; index++) {
          if (ad[index]['issuper'] == 'true') {
            this.getalladmins.push({
              id: ad[index]['id'],
              mobile: ad[index]['mobile'],
              email: ad[index]['email'],
              issuper: true,
            });
          } else {
            this.getalladmins.push({
              id: ad[index]['id'],
              mobile: ad[index]['mobile'],
              email: ad[index]['email'],
              issuper: false,
            });
          }
        }
      });
    });
  }

  advtCategory;
  getAdvtCategory(e) {
    // console.log(e);
    this.advtCategory = e.value;

    this.FilteredadvtsizesData = this.advtsizesData.filter((a) => {
      return (
        a['category'].toLowerCase().indexOf(this.advtCategory.toLowerCase()) >
        -1
      );
    });
  }

  getAdvtCategory1(e) {
    // console.log(e);
    // console.log(this.FilteredissueDatesData);

    this.advtCategory = e.value;

    this.FilteredissueDatesData = this.issueDatesData.filter((a) => {
      return (
        a['advt_category']
          .toLowerCase()
          .indexOf(this.advtCategory.toLowerCase()) > -1
      );
    });
  }
  setLanguage(e) {
    // console.log(e);
    // console.log(this.FilteredissueDatesData);

    this.setlangugae = e.value;

    // this.FilteredissueDatesData = this.issueDatesData.filter((a) => {
    //   return (
    //     a['advt_category']
    //       .toLowerCase()
    //       .indexOf(this.advtCategory.toLowerCase()) > -1
    //   );
    // });
  }

  save_advtSizes() {
    let advtdata = {
      advt_category: this.advtCategory,
      advt_size_name: this.advtSizesForm.get('advt_size_name').value,
      isactive: 'Y',
    };
    this.service.addAdvtSizes(advtdata).subscribe((res) => {
      alert('Advertiesment Sizes Added Successfully...');
      this.advtSizesForm.reset();
    });
  }

  save_issue_dates() {
    if (!this.checkDuplicateEntry) {
      let issuedata = {
        advt_category: this.advtCategory,
        issuedate: formatDate(
          this.IssueDates.get('issuedate').value,
          'yyyy-MM-dd',
          'en-IN',
          'GMT+0530'
        ),
        publisheddate: formatDate(
          this.IssueDates.get('publisheddate').value,
          'yyyy-MM-dd',
          'en-IN',
          'GMT+0530'
        ),
        issue_name: this.IssueDates.get('issue_name').value,
        issue_price: this.IssueDates.get('issue_price').value,
        lang: this.IssueDates.get('lang').value,
        blackwhite: this.IssueDates.get('blackwhite').value,
        insidecolour: this.IssueDates.get('insidecolour').value,
        cover: this.IssueDates.get('cover').value,
        totalpages: this.IssueDates.get('totalpages').value,
        issuesize: this.IssueDates.get('issuesize').value,
        percopyweight: this.IssueDates.get('percopyweight').value,
        prntdcopies: this.IssueDates.get('prntdcopies').value,
        maflitho: this.IssueDates.get('maflitho').value,
        lwc: this.IssueDates.get('lwc').value,
        artpaper: this.IssueDates.get('artpaper').value,
        paperreams1: this.IssueDates.get('paperreams1').value,
        paperreams2: this.IssueDates.get('paperreams2').value,
        paperreams3: this.IssueDates.get('paperreams3').value,
        rnireleated: this.IssueDates.get('rnireleated').value,
      };

      this.service.addAdvtDates(issuedata).subscribe(
        (res) => {
          alert('Advertiesment Dates Added Successfully...');
          this.IssueDates.reset();
          this.ngOnInit();
        }
        // ,
        // (error) => {
        //   alert('Advertiesment Dates Already Present...');
        // }
      );
    } else {
      alert('Issue Date is Already Present. Please change!...');
    }
  }

  checkDuplicateEntry: boolean = false;
  selectDateChange() {
    if (this.IssueDates.get('issuedate').value != null) {
      let day = new Date(this.IssueDates.get('issuedate').value);
      day.setDate(day.getDate() - 7);
      // console.log(formatDate(day, 'yyyy-MM-dd', 'en-IN', 'GMT+0530'));
      this.IssueDates.get('publisheddate').setValue(
        formatDate(day, 'yyyy-MM-dd', 'en-IN', 'GMT+0530')
      );

      if (this.advtCategory === 'नियिमत अंक') {
        this.service
          .checkDuplicateIssueDate(
            this.advtCategory,
            formatDate(
              this.IssueDates.get('issuedate').value,
              'yyyy-MM-dd',
              'en-IN',
              'GMT+0530'
            ),
            formatDate(
              this.IssueDates.get('publisheddate').value,
              'yyyy-MM-dd',
              'en-IN',
              'GMT+0530'
            )
          )
          .subscribe((res) => {
            if (Object.keys(res).length) {
              this.checkDuplicateEntry = true;
              alert('Issue Date is Already Present. Please change!...');
            }
          });
      } else {
        this.checkDuplicateEntry = false;
      }
      // console.log(this.IssueDates.get('publisheddate').value);
    }
  }

  addIssueGrantha() {
    let issueGrantha = {
      igcategory: this.addIssueGranthaForm.get('igcategory').value,
      igsubcategory: this.addIssueGranthaForm.get('igsubcategory').value,
    };
    this.service.insertAdvtMagazine(issueGrantha).subscribe((a) => {
      window.alert('Issue/Grantha added sucessfully...');
      this.addIssueGranthaForm.reset();
      this.newDateArray = [];
    });
    console.log(this.newDateArray);
  }

  updateIssueDates(item) {
    // console.log(item);
    let result = this.dialog.open(UpdateIssueDatesComponent, {
      data: {
        val: item,
      },
      width: '500px',
      height: '600px',
      maxWidth: '100%',
    });

    result.afterClosed().subscribe((res) => {
      // console.log(res);
      if (res['res'] == 'close') {
        window.alert('Data Uploaded Successfully...');
        this.ngOnInit();
      }
    });
  }

  removeIssueDates(item) {
    if (window.confirm('Do you really want to remove ?')) {
      this.service.updateIssueDatetoInactive(item['id']).subscribe((data) => {
        window.alert('Data Removed Successfully...');
        this.ngOnInit();
      });
    }
  }

  manageAdvtDates(advt) {
    this.dialog.open(UpdatePlublishDatesComponent, {
      data: {
        published_dates: advt['publishing_date'],
        advt_dtl_id: advt['id'],
        manage_mode: true,
        issue_date_mode: false,
        height: '600px',
        width: '600px',
      },
    });
  }

  remove_mag_advt(advt) {
    this.service.updateAdvtMagStatus(advt['id'], 'N').subscribe((data) => {
      // console.log(data);
      this.getAdvtMagDetails();
      window.alert('Status Change!');
    });
  } //remove Magazine advt

  removeadmin(id) {
    this.service.makesuperAdmin(id, 'N').subscribe((a) => {
      this.service.getalladmin().subscribe((ad) => {
        this.getalladmins = [];
        for (let index = 0; index < Object.keys(ad).length; index++) {
          if (ad[index]['issuper'] == 'true') {
            this.getalladmins.push({
              id: ad[index]['id'],
              mobile: ad[index]['mobile'],
              email: ad[index]['email'],
              issuper: true,
            });
          } else {
            this.getalladmins.push({
              id: ad[index]['id'],
              mobile: ad[index]['mobile'],
              email: ad[index]['email'],
              issuper: false,
            });
          }
        }
      });
    });
  }

  isvalidAdmin = false;
  getalladmins = [
    {
      id: 1,
      mobile: 7276169890,
      email: '',
      issuper: false,
    },
  ];
  validateAdmin(event) {
    const value = event.target.value;
    this.service.getvalidAdmin(parseInt(value)).subscribe((admobile) => {
      if (Object.keys(admobile).length > 0) {
        this.isvalidAdmin = true;
      } else {
        this.isvalidAdmin = false;
      }

      if (Object.keys(admobile).length > 0) {
        this.service.getalladmin().subscribe((ad) => {
          this.getalladmins = [];
          for (let index = 0; index < Object.keys(ad).length; index++) {
            if (ad[index]['issuper'] == 'true') {
              this.getalladmins.push({
                id: ad[index]['id'],
                mobile: ad[index]['mobile'],
                email: ad[index]['email'],
                issuper: true,
              });
            } else {
              this.getalladmins.push({
                id: ad[index]['id'],
                mobile: ad[index]['mobile'],
                email: ad[index]['email'],
                issuper: false,
              });
            }
          }
        });
      }
    });
  }


  onCountrySelectForState() {
    const countryId = this.StateMaster.value['country_id'];
    if (!countryId) {
      this.states = [];
      this.state_count = 0;
      return;
    }
    this.service.getstates(countryId).subscribe((data) => {
      this.states = data;
      this.state_count = this.states.length;
    });
  }

  save_state() {
    const selectedCountry = this.countries.find(
      c => c.country_id == this.StateMaster.value['country_id']
    );

    if (!selectedCountry) {
      window.alert('Please select a country!');
      return;
    }

    this.service
      .InsertNewState(
        this.StateMaster.value['State_name'],
        selectedCountry['country_code'],   // dynamic instead of hardcoded 'IND'
        selectedCountry['country_id'],
        this.StateMaster.value['sequence_id'],
        // dynamic instead of hardcoded 1
      )
      .subscribe((data) => {
        window.alert('State has been inserted');
        // Reload states filtered by selected country
        this.service.getstates(selectedCountry['country_id']).subscribe((data) => {
          this.states = data;
          this.state_count = this.states.length;
        });
        this.StateMaster.get('State_name').reset();
        this.StateMaster.get('sequence_id').reset();
      });
  }

  save_city() {
    if (this.state_id == 0) {
      window.alert('Please select State !');
    } else {
      this.service
        .InsertNewCity(
          this.CityMaster.value['city_name'],
          this.CityMaster.value['prant_name'],
          this.CityMaster.value['sequence_id'],
          this.state_id

        )
        .subscribe((data) => {
          // console.log(data);
          window.alert('District added successfully..');
          this.CityMaster.reset();
          this.getChangeState(this.changeState_id);
        });
    }
  }

  // save_prant() {

  //   const payload = {
  //   prant_name: this.prantMaster.value['prant_name'],
  //   sequence_id: this.prantMaster.value['sequence_id'] || null
  // };
  //   console.log(this.prantMaster.value['prant_name']);
    
  //   this.service
  //     .insertPrantData(this.prantMaster.value['prant_name'])
  //     .subscribe((res) => {
  //       if (res['success']) {
  //         alert('Prant name added successfully');
  //         this.getAllPrantData();
  //       }
  //     });
  // }

  save_prant() {
  const payload = {
    prant_name: this.prantMaster.value['prant_name'],
    sequence_id: this.prantMaster.value['sequence_id'] || 0
  };

  this.service.insertPrantData(payload).subscribe((res: any) => {
    if (res['success']) {
      alert('Prant name added successfully');
      this.prantMaster.reset();
      this.getAllPrantData();
    }
  });
}

  getAllPrantData() {
    this.service.getAllPrantData().subscribe((res) => {
      // console.log(res);
      this.prantData = res;
    });
  }

  updatePrant(data) {
    console.log(data);
    let result = this.dialog.open(UpdatePrantComponent, {
      data: {
        prant: data,
      },
      width: '500px',
      height: '500px',
      maxWidth: '100%',
    });

    result.afterClosed().subscribe((res) => {
      if (res['res'] == 'close') {
        this.getAllPrantData();
      }
    });
  }

  removePrant(id: number) {
    if (window.confirm('Are you sure! This operation is not reversable?')) {
      this.service.removePrant(id).subscribe((res) => {
        if (res['success']) {
          alert(res['message']);
          this.getAllPrantData();
        }
      });
    }
  }

  save_taluka() {
    if (this.district_id == 0) {
      window.alert('Please select District!');
    } else {
      this.service
        .InsertNewTaluka(
          this.TalukaMaster.value['taluka_name'],
          this.TalukaMaster.value['pincode'],
          this.TalukaMaster.value['sequence_id'],
          this.district_id
        )
        .subscribe((data) => {
          // console.log(data);
          window.alert('Taluka added successfully..');
          this.TalukaMaster.reset();
          this.getChangeDistrict(this.changeDistrict_id);
        });
    }
  }

  onPincodeInput(event: any) {
    const value = event.target.value;
    if (value === '-') {
      this.TalukaMaster.get('pincode')?.setValue('');
    } else if (/^\d*$/.test(value)) { // allow only digits
      this.TalukaMaster.get('pincode')?.setValue(value);
    } else {
      // prevent non-numeric input
      event.target.value = this.TalukaMaster.get('pincode')?.value || ' ';
    }
  }

  getAllCities;
  changeState_id;
  getChangeState(event) {

    // console.log(parseInt(event.value));
    this.changeState_id = event;
    this.service.getCity(parseInt(event.value)).subscribe((data) => {
      this.getAllCities = data;
      this.city_count = this.getAllCities.length;
    });
  }

  getAllTalukas;
  changeDistrict_id;
  getChangeDistrict(event) {
    // console.log(parseInt(event.value));
    this.changeDistrict_id = event;
    this.service.getTaluka([(event.value)]).subscribe((data) => {
      this.getAllTalukas = data;
      this.taluka_count = this.getAllTalukas.length;
    });
  }

  updateState(data) {
    let result = this.dialog.open(UpdateStateMasterComponent, {
      data: {
        state: data,
      },
      width: '500px',
      height: '500px',
      maxWidth: '100%',
    });

    result.afterClosed().subscribe((result) => {
      if (result['res'] == 'close') {
        this.ngOnInit();
      }
    });
  }

  removeState(state_id) {
    window.alert(
      'This is hard delete operation and will be unrecoverable. This may cause your ' +
      'application behave differently.'
    );
    if (
      window.confirm(
        'Do you really want to remove the State and its corresponding cities ?'
      )
    ) {
      this.service.removeStateandCity(parseInt(state_id)).subscribe((data) => {
        this.service.getstates(1).subscribe((data) => {
          console.log(data);
          this.states = data;
        });
      });
    }
  }
  removecountry(id) {
    this.service.getstates(id).subscribe((data) => {
      console.log(data);
      this.states = data;
    });
  }

  updateDistrict(data) {
    let result = this.dialog.open(UpdateDistrictMasterComponent, {
      data: {
        district: data,
      },
      width: '500px',
      height: '500px',
      maxWidth: '100%',
    });

    result.afterClosed().subscribe((res) => {
      if (res['res'] == 'close') {
        this.getChangeState(this.changeState_id);
      }
    });
  }

  removeCity(id) {
    window.alert(
      'This is hard delete operation and will be unrecoverable. This may cause your ' +
      'application behave differently.'
    );
    if (window.confirm('Do you really want to remove City ?')) {
      this.service.removeCity(parseInt(id)).subscribe((data) => {
        this.getChangeState(this.changeState_id);
      });
    }
  }

  updateTaluka(data) {
    let result = this.dialog.open(UpdateTalukaMasterComponent, {
      data: {
        taluka: data,
      },
      width: '500px',
      height: '500px',
      maxWidth: '100%',
    });

    result.afterClosed().subscribe((res) => {
      if (res['res'] == 'close') {
        // this.getChangeState(this.changeState_id);
        this.getChangeDistrict(this.changeDistrict_id);
      }
    });
  }

  removeTaluka(id) {
    window.alert(
      'This is hard delete operation and will be unrecoverable. This may cause your ' +
      'application behave differently.'
    );
    if (window.confirm('Do you really want to remove Taluka ?')) {
      this.service.removeTaluka(parseInt(id)).subscribe((data) => {
        this.getChangeDistrict(this.changeDistrict_id);
      });
    }
  }

  state_id = 0;
  // getState(event) {
  //   // console.log(event);
  //   console.log(event.value);
  //   this.state_id = event.value;
  //   this.selectedState = this.states['state_id'];
  //   let state = this.states.find((a) => a.state_name == event.value);
  //   // console.log();
  //   if (state != undefined) {
  //     // if (
  //     //   state.state_name != 'Maharashtra' ||
  //     //   state.state_name != 'महाराष्ट्र'
  //     // ) {
  //     //   this.showigst = true;
  //     // } else {
  //     //   this.showigst = false;
  //     // }
  //     this.service
  //       .getDistrict(parseInt(state['state_id']))
  //       .subscribe((data) => {
  //         this.cities = data;
  //         this.selectedCity = this.cities['district_name'];
  //         // console.log(this.cities);
  //       });
  //   } else {
  //   }
  // } //get state
  // getState(event) {
  //   this.state_id = parseInt(event.value);
  // }


  // getState(event) {
  //   console.log(event.value);
  //   this.state_id = event.value;

  //   // ✅ Find by state_id (numeric match)
  //   let state = this.states.find((a) => a.state_id == event.value);

  //   if (state != undefined) {
  //     // ✅ Correctly assign selected state name
  //     this.selectedState = state.state_name;

  //     this.service
  //       .getDistrict((state['state_id']))
  //       .subscribe((data) => {
  //         this.cities = data;
  //         // ✅ Reset selected city when state changes
  //         this.selectedCity = null;
  //       });
  //   }
  // }

  district_id = 0;
  // getDistricts(event) {
  //   this.selectedCity = this.cities['district_id'];
  //   let district = this.cities.find((a) => a.district_name == event.value);
  //   let dist = []
  //   dist.push(district['district_id'])
  //   if (district != undefined) {
  //     this.service.getTaluka(dist).subscribe((data) => {
  //       this.talukas = data;
  //       this.selectedTaluka = this.talukas['taluka_name'];
  //     });
  //   }
  // }


  getDistrict(event) {

    this.district_id = parseInt(event.value);
    this.getDistricts(event)
  }

  changeMagPrice() {
    // console.log(
    //   this.magpriceupdate.value['magedition'],
    //   this.magpriceupdate.value['magname'],
    //   this.magpriceupdate.value['magyear']
    // );
    if (parseInt(this.magpriceupdate.value['magamount']) <= 0) {
      window.alert('Please enter valid amount');
    } else {
      let magprintamount = 0;
      let magdigitalamount = 0;
      let magbothamount = 0;
      if (this.magpriceupdate.value['magedition'] == 'print') {
        magprintamount = this.magpriceupdate.value['magamount'];
      } else if (this.magpriceupdate.value['magedition'] == 'digital') {
        magdigitalamount = this.magpriceupdate.value['magamount'];
      } else if (this.magpriceupdate.value['magedition'] == 'printdigital') {
        magbothamount = this.magpriceupdate.value['magamount'];
      }

      this.service
        .changeMagPrice(
          this.magpriceupdate.value['magname'],
          this.magpriceupdate.value['magedition'],
          magprintamount,
          magdigitalamount,
          magbothamount,
          parseInt(this.magpriceupdate.value['magyear'])
        )
        .subscribe((res) => {
          // console.log(res);
          window.alert(
            'Price has been updated! Please try to refresh the page for updated values.'
          );
          this.magpriceupdate.reset();
        });
    }
  }

  AddNewMagazine() {
    if (
      this.magform.value['magyear'] == undefined ||
      this.magform.value['magyear'] < 0
    ) {
      this.magform.get('magyear').setValue(1);
    }
    let magprintamount = 0;
    let magdigitalamount = 0;
    let magbothamount = 0;
    if (this.magform.value['magedition'] == 'print') {
      magprintamount = this.magform.value['magamount'];
    } else if (this.magform.value['magedition'] == 'digital') {
      magdigitalamount = this.magform.value['magamount'];
    } else if (this.magform.value['magedition'] == 'printdigital') {
      magbothamount = this.magform.value['magamount'];
    }

    // console.log(
    //   this.magform.value['magname'],
    //   this.magform.value['magedition'],
    //   this.magform.value['magamount'],
    //   this.magform.value['magyear'],
    //   this.magform.value['magdesc'],
    //   this.magform.value['magapp'],
    //   this.magform.value['magfullname']
    // );

    this.service
      .AddNewMag(
        this.magform.value['magname'],
        this.magform.value['magedition'],
        magprintamount,
        magdigitalamount,
        magbothamount,
        this.magform.value['magyear'],
        this.magform.value['magdesc'],
        this.magform.value['magapp'],
        this.magform.value['magfullname']
      )
      .subscribe((a) => {
        window.alert('Magazine Added Successfully.');
        //change for OEM
        this.service.getMag().subscribe((res) => {
          this.magform.reset();
          //console.log(res['name'])
          this.mag = [];

          for (let i = 0; i < Object.keys(res).length; i++) {
            this.mag.push({
              name: res[i]['name'],
              print: res[i]['print'],
              digital: res[i]['digital'],
              printdigital: res[i]['printdigital'],
              year: parseInt(res[i]['year']),
            });
          }
        });
      });
  }

  removeAdmin(id) {
    this.service.removeAdmin(parseInt(id)).subscribe((rmv) => {
      //console.log(rmv);
      this.service.getalladmin().subscribe((ad) => {
        this.getalladmins = [];
        for (let index = 0; index < Object.keys(ad).length; index++) {
          if (ad[index]['issuper'] == 'true') {
            this.getalladmins.push({
              id: ad[index]['id'],
              mobile: ad[index]['mobile'],
              email: ad[index]['email'],
              issuper: true,
            });
          } else {
            this.getalladmins.push({
              id: ad[index]['id'],
              mobile: ad[index]['mobile'],
              email: ad[index]['email'],
              issuper: false,
            });
          }
        }
      });
    });
  }

  magedition;
  getmagEdition(event) {
    this.magedition = event.value;
  }
  magnames;
  getmagdetails(event) {
    this.magnames = event.value;
  }

  disableOtherFields = true;
  getMagazine;
  subid;
  cancelCheckbox = [];
  changedMobileNumber;
  nochangenumber = false;
  getValidateEvent(event) {
    this.changedMobileNumber = event.target.value;
  }

  addNewAdmin() {
    let mobile = parseInt(this.addNewAdminForm.value['adminMobile']);
    this.addNewAdminForm.patchValue({ adminMobile: mobile });
    var encrypted = this.encr.set(
      '123456$#@$^@1ERF',
      this.addNewAdminForm.value['adminPassword']
    );
    this.addNewAdminForm.patchValue({ adminPassword: encrypted });

    let sixdigitsrandom = Math.floor(100000 + Math.random() * 900000);
    let msg =
      'Dear Subscriber, Your Verification Code is ' +
      sixdigitsrandom +
      ', Regards OEM Ekvira Media Pvt. Ltd.';
    let template = 'Brahman20';
    this.service.sendSMS(mobile, msg, template).subscribe((a) => { });
    this.dialog.open(AddNewAdminDialogComponent, {
      data: {
        otp: sixdigitsrandom,
        mobileNumber: mobile,
        adPassword: encrypted,
        email: this.addNewAdminForm.get('adminEmail').value,
        height: '600px',
        width: '600px',
      },
    });

    this.addNewAdminForm.reset();
  }

  open_cancel_subsciber_dialog(value) {
    let mobile = parseInt(value.mobileNumber);
    var sixdigitsrandom = Math.floor(100000 + Math.random() * 900000);
    // console.log(value);
    let msg =
      'Dear Subscriber, Your Verification Code is ' +
      sixdigitsrandom +
      ', Regards OEM Ekvira Media Pvt. Ltd.';
    let template = 'Brahman20';

    this.service
      .sendSMS(parseInt(sessionStorage.getItem('mobile')), msg, template)
      .subscribe((a) => { });

    this.dialog.open(CancelSubDialogComponent, {
      data: {
        message: sixdigitsrandom,
        magdata: value,
        height: '600px',
        width: '600px',
      },
    });
  }

  save() {
    this.service
      .insertTitle(this.MasterTable.value['title'])
      .subscribe((data) => {
        // console.log(data);
        this.service.getAlltitle().subscribe((data) => {
          // console.log(data);
          this.titles = data;
          this.MasterTable.reset();
        });
      });
  }

  removeTitle(title) {
    if (window.confirm('Do you really want to remove the title?')) {
      this.service.removetitle(title).subscribe((data) => {
        this.service.getAlltitle().subscribe((data) => {
          // console.log(data);
          this.titles = data;
        });
      });
    }
  }

  save_occupation() {
    this.service
      .insertOccupations(
        this.OccupationMaster.value['occupation'],
        this.OccupationMaster.value['occupation_value'].toLowerCase()
      )
      .subscribe((data) => {
        // console.log(data);
        this.service.getOccupation().subscribe((data) => {
          // console.log(data);
          this.occupations = data;
        });
      });
  }


  addRepresentativeForm() {
    const f = this.addform;
    const addrep = {
      issuesellername: f.get('issuesellername').value,
      address1: f.get('address1').value,
      pincode: f.get('pincode').value,
      country: f.get('country').value,
      state: f.get('state').value,
      taluka: f.get('taluka').value,
      district: f.get('district').value,
      mnumber: f.get('mnumber').value,
      email: f.get('email').value,
      // FIX: was reversed — empty string means no landline, keep null
      landline_no: f.get('landline_no').value || null,
      dob: f.get('dob')?.value,
      gstno: f.get('gstno').value,
      panno: f.get('panno').value,
      depositamt: f.get('depositamt').value,
      option: f.get('option').value,
      sbhet: f.get('sampremebhet').value,
      distype: f.get('distype').value,
      issue_date: f.get('issuedate').value,
      issue_name: f.get('issuename').value,
      // English fields
      eng_issueSellerName: f.get('issuesellername_en').value,
      e_Address: f.get('address1_en').value,
      e_Country: f.get('country_en').value,
      e_State: f.get('state_en').value,
      eng_districts: f.get('district_en').value,
      e_Taluka: f.get('taluka_en').value,
      start_date: f.get('start_date').value,
      end_date: f.get('end_date').value,
      narration: f.get('narration').value,
      rep_status: f.get('rep_status').value,
    };

    this.service.addIssueSellerEntry(addrep).subscribe(
      () => {
        alert('Representative added successfully...');
        this.addform.reset();
        this.ngOnInit();
      },
      () => alert('Representative Already Present...'),
    );
  }

  // ─── 12. updaterep (landline_no bug fixed) ───────────────────
  updaterep() {
    const f = this.addform;
    const addrep = {
      id: this.repId1,
      issuesellername: f.get('issuesellername').value,
      address1: f.get('address1').value,
      pincode: f.get('pincode').value,
      country: f.get('country').value,
      state: f.get('state').value,
      taluka: f.get('taluka').value,
      district: f.get('district').value,
      mnumber: f.get('mnumber').value,
      email: f.get('email').value,
      landline_no: f.get('landline_no').value || null, // FIX
      dob: f.get('dob').value,
      gstno: f.get('gstno').value,
      panno: f.get('panno').value,
      depositamt: f.get('depositamt').value,
      option: f.get('option').value,
      sbhet: f.get('sampremebhet').value,
      distype: f.get('distype').value,
      // English fields
      eng_issueSellerName: f.get('issuesellername_en').value,
      e_Address: f.get('address1_en').value,
      e_Country: f.get('country_en').value,
      e_State: f.get('state_en').value,
      eng_districts: f.get('district_en').value,
      e_Taluka: f.get('taluka_en').value,
      start_date: f.get('start_date').value,
      end_date: f.get('end_date').value,
      narration: f.get('narration').value,
      rep_status: f.get('rep_status').value,





    };

    this.service.updateIssueSellerEntry(addrep).subscribe(() => {
      alert('Representative Updated Successfully...');
      this.ngOnInit();
      this.addform.reset();
      this.selected_repname = false;
    });
  }



  printSection4(sectionId: string): void {
    const sectionElem = document.getElementById(sectionId);
    if (!sectionElem) {
      console.warn(`Element with id "${sectionId}" not found.`);
      return;
    }

    const htmlToPrint = sectionElem.outerHTML;
    const printWindow = window.open('', '_blank',
      'width=1000%,height=650,left=200,toolbar=0,scrollbars=1,status=0');
    if (!printWindow) return;

    printWindow.document.write(`
    <html>
      <head>
        <title>Print Representatives</title>
        <style>
          @media print {
            @page { margin: 0; }
            body { margin: 10mm; }

            /* Hide the last two columns in all rows */
            th:last-child,
            td:last-child,
            th:nth-last-child(2),
            td:nth-last-child(2) {
              display: none;
            }
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th, td {
            border: 1px solid #333;
            padding: 8px;
            text-align: center;
          }

          thead {
            background-color: #f2f2f2;
          }
        </style>
      </head>
      <body onload="window.print();">
        ${htmlToPrint}
      </body>
    </html>
  `);

    printWindow.document.close();
  }


  show = false
  //   printPagesList() {
  //     this.show = true;

  //     const printContent = document.getElementById('repListSection1')?.outerHTML;
  //     if (!printContent) {
  //       console.error("Print section not found!");
  //       return;
  //     }

  //     const width = 1400;
  //     const height = 1000;
  //     const left = (window.screen.width / 2) - (width / 2);
  //     const top = (window.screen.height / 2) - (height / 2);

  //     const printWindow = window.open('', '', `width=${width},height=${height},top=${top},left=${left},scrollbars=yes`);

  //     if (printWindow) {
  //       printWindow.document.open();
  //       printWindow.document.write(`
  //       <html>
  //         <head>
  //           <title>Print Report</title>
  //          <style>
  //   @media print {
  //     @page {
  //       size: A3 landscape;
  //       margin: 5mm;
  //     }

  //     body {
  //       font-family: Arial, sans-serif;
  //       font-size: 15px;
  //       margin: 0;
  //       padding: 5mm;
  //       line-height: 1.2;
  //     }

  //     table {
  //       width: 100%;
  //       border-collapse: collapse;
  //       table-layout: fixed; /* Prevent column expansion */
  //       page-break-inside: avoid;
  //       word-wrap: break-word;
  //     }

  //     th, td {
  //       padding: 4px;
  //       border: 1px solid black;
  //       text-align: center;
  //       font-size: 14px;
  //       line-height: 1.2;
  //       overflow: hidden;
  //       text-overflow: ellipsis;
  //       word-wrap: break-word;
  //       white-space: normal; /* Allow line breaks */
  //     }

  //     .noPrint, .no-print {
  //       display: none !important;
  //     }
  //   }
  // </style>

  //         </head>
  //         <body>
  //           <div id="repListSection1">
  //             ${printContent}
  //           </div>
  //           <script>
  //             window.onload = function() {
  //               setTimeout(() => {
  //                 window.print();
  //                 window.close();
  //               }, 300); // delay to ensure full render
  //             };
  //           </script>
  //         </body>
  //       </html>
  //     `);
  //       printWindow.document.close();
  //     } else {
  //       console.error("Failed to open print window.");
  //     }
  //   }


  // printPagesList() {

  //    this._repDataForPrint = this.repList;
  //   console.log('REP DATA SAMPLE:', this.repList[0]); 
  //   this.show = true;

  //   const table = document.getElementById('repListSection1');
  //   if (!table) {
  //     console.error("Print section not found!");
  //     return;
  //   }

  //   // Extract rows from the existing table
  //   const rows = table.querySelectorAll('tr');
  //   let tableRows = '';

  //   rows.forEach((row, index) => {
  //     const cells = row.querySelectorAll('th, td');
  //     if (index === 0) return; // skip original header, we'll add our own

  //     let rowHtml = '<tr>';
  //     const cellArray = Array.from(cells);

  //     cellArray.forEach((cell, i) => {
  //       const text = cell.textContent?.trim() || '';
  //       // Column 2 (index 1) is address - skip it here, handled separately
  //       rowHtml += `<td>${text}</td>`;
  //     });

  //     rowHtml += '</tr>';
  //     tableRows += rowHtml;
  //   });

  //   const width = 1400;
  //   const height = 900;
  //   const left = (window.screen.width / 2) - (width / 2);
  //   const top = (window.screen.height / 2) - (height / 2);

  //   const printWindow = window.open('', '', `width=${width},height=${height},top=${top},left=${left},scrollbars=yes`);

  //   if (printWindow) {
  //     printWindow.document.open();
  //     printWindow.document.write(`
  //       <html>
  //         <head>
  //           <title>Representative List</title>
  //           <style>
  //             * { box-sizing: border-box; margin: 0; padding: 0; }

  //             body {
  //               font-family: Arial, sans-serif;
  //               font-size: 11px;
  //               padding: 8px;
  //               background: white;
  //               color: #000;
  //             }

  //             tbody td {
  //   color: #000000 !important;
  //   -webkit-print-color-adjust: exact;
  //   print-color-adjust: exact;
  // }

  //             h2.report-title {
  //               text-align: center;
  //               font-size: 15px;
  //               margin-bottom: 8px;
  //               font-weight: bold;
  //               text-decoration: underline;
  //             }

  //             table {
  //               width: 100%;
  //               border-collapse: collapse;
  //               table-layout: fixed;
  //             }

  //             thead tr {
  //               background-color: #003366;
  //               color: white;
  //             }

  //             thead th {
  //               padding: 5px 4px;
  //               border: 1px solid #000;
  //               text-align: center;
  //               font-size: 10px;
  //               font-weight: bold;
  //               word-wrap: break-word;
  //               white-space: normal;
  //             }

  //             tbody tr:nth-child(even) {
  //               background-color: #f0f4ff;
  //             }

  //             tbody tr:hover {
  //               background-color: #d0e8ff;
  //             }

  //             tbody td {
  //               padding: 4px 3px;
  //               border: 1px solid #aaa;
  //               text-align: center;
  //               font-size: 10px;
  //               word-wrap: break-word;
  //               white-space: normal;
  //               vertical-align: middle;
  //             }

  //             /* Address sub-header row */
  //             .addr-group th {
  //               background-color: #cce0ff;
  //               color: #000;
  //               font-size: 9px;
  //               padding: 3px 2px;
  //               border: 1px solid #888;
  //             }

  //             /* Column widths */
  //             col.c-sr       { width: 3%; }
  //             col.c-name     { width: 9%; }
  //             col.c-address  { width: 10%; }
  //             col.c-pincode  { width: 5%; }
  //             col.c-state    { width: 6%; }
  //             col.c-district { width: 6%; }
  //             col.c-taluka   { width: 6%; }
  //             col.c-mobile   { width: 7%; }
  //             col.c-email    { width: 10%; }
  //             col.c-dob      { width: 6%; }
  //             col.c-gst      { width: 8%; }
  //             col.c-pan      { width: 6%; }
  //             col.c-deposit  { width: 5%; }
  //             col.c-type     { width: 5%; }
  //             col.c-start    { width: 6%; }
  //             col.c-end      { width: 6%; }
  //             col.c-status   { width: 5%; }
  //             col.c-narr     { width: 6%; }

  //             @media print {
  //               @page {
  //                 size: A3 landscape;
  //                 margin: 6mm;
  //               }
  //               body { padding: 0; font-size: 10px; }
  //               .noPrint, .no-print { display: none !important; }
  //               thead { display: table-header-group; }
  //               tbody tr { page-break-inside: avoid; }
  //             }
  //           </style>
  //         </head>
  //         <body>

  //           <h2 class="report-title">Representative / Agent List</h2>

  //           <table id="repListSection1">
  //             <colgroup>
  //               <col class="c-sr">
  //               <col class="c-name">
  //               <col class="c-address">
  //               <col class="c-pincode">
  //               <col class="c-state">
  //               <col class="c-district">
  //               <col class="c-taluka">
  //               <col class="c-mobile">
  //               <col class="c-email">
  //               <col class="c-dob">
  //               <col class="c-gst">
  //               <col class="c-pan">
  //               <col class="c-deposit">
  //               <col class="c-type">
  //               <col class="c-start">
  //               <col class="c-end">
  //               <col class="c-status">
  //               <col class="c-narr">
  //             </colgroup>

  //             <thead>
  //               <!-- Row 1: Main headers with address group spanning 5 cols -->
  //               <tr>
  //                 <th rowspan="2">Sr</th>
  //                 <th rowspan="2">Name</th>
  //                 <th colspan="5" style="background:#1a5276;color:white;">Address</th>
  //                 <th rowspan="2">Mobile</th>
  //                 <th rowspan="2">Email</th>
  //                 <th rowspan="2">DOB</th>
  //                 <th rowspan="2">GST No</th>
  //                 <th rowspan="2">PAN No</th>
  //                 <th rowspan="2">Deposit (₹)</th>
  //                 <th rowspan="2">Type</th>
  //                 <th rowspan="2">Start Date</th>
  //                 <th rowspan="2">End Date</th>
  //                 <th rowspan="2">Status</th>
  //                 <th rowspan="2">Narration</th>
  //               </tr>
  //               <!-- Row 2: Address sub-columns -->
  //               <tr class="addr-group">
  //                 <th>Address</th>
  //                 <th>Pincode</th>
  //                 <th>Taluka</th>
  //                 <th>District</th>
  //                 <th>State</th>
  //               </tr>
  //             </thead>

  //             <tbody id="printTableBody">
  //               <!-- Rows injected below -->
  //             </tbody>
  //           </table>

  //           <script>
  //             // Data injected from Angular
  //             const repData = ${JSON.stringify(this._repDataForPrint)};

  //             const tbody = document.getElementById('printTableBody');
  //             repData.forEach((rep, i) => {
  //               const tr = document.createElement('tr');
  //               tr.innerHTML = \`
  //                 <td>\${i + 1}</td>
  //                 <td style="text-align:left">\${rep.issueSellerName || rep.issueSellerName || ''}<br><small>\${rep.repNameMarathi || rep.rep_name_marathi || ''}</small></td>
  //                 <td style="text-align:left">\${rep.address || ''}</td>
  //                 <td>\${rep.pincode || ''}</td>
  //                 <td>\${rep.taluka || ''}</td>
  //                 <td>\${rep.district || ''}</td>
  //                 <td>\${rep.state || ''}</td>
  //                 <td>\${rep.mobile_no || ''}</td>
  //                 <td style="font-size:9px">\${rep.email || ''}</td>
  //                 <td>\${rep.dateofbirth || ''}</td>
  //                 <td style="font-size:9px">\${rep.gstNo || rep.gst_no || ''}</td>
  //                 <td>\${rep.pan_no || rep.pan_no || ''}</td>
  //                 <td>\${rep.deposit ?? ''}</td>
  //                 <td>\${rep.type || ''}</td>
  //                 <td>\${rep.startDate || rep.start_date || ''}</td>
  //                 <td>\${rep.endDate || rep.end_date || ''}</td>
  //                 <td>\${rep.status || ''}</td>
  //                 <td>\${rep.narration || ''}</td>
  //               \`;
  //               tbody.appendChild(tr);
  //             });

  //             window.onload = function() {
  //               setTimeout(() => {
  //                 window.print();
  //                 window.close();
  //               }, 400);
  //             };
  //           </script>
  //         </body>
  //       </html>
  //     `);
  //     printWindow.document.close();
  //   } else {
  //     console.error("Failed to open print window.");
  //   }
  // }

//   printPagesList() {
//     this._repDataForPrint = this.repList;
//     console.log('REP DATA SAMPLE:', this.repList[0]);
//     this.show = true;

//     const table = document.getElementById('repListSection1');
//     if (!table) {
//       console.error("Print section not found!");
//       return;
//     }

//     const width = 1400;
//     const height = 900;
//     const left = (window.screen.width / 2) - (width / 2);
//     const top = (window.screen.height / 2) - (height / 2);

//     const printWindow = window.open('', '', `width=${width},height=${height},top=${top},left=${left},scrollbars=yes`);

//     if (printWindow) {
//       printWindow.document.open();
//       printWindow.document.write(`
//       <html>
//         <head>
//           <title>Representative List</title>
//          <style>
//   * { box-sizing: border-box; margin: 0; padding: 0; }

//   body {
//     font-family: Arial, sans-serif;
//     font-size: 14px;
//     padding: 8px;
//     background: white;
//     color: #000;
//     -webkit-print-color-adjust: exact;
//     print-color-adjust: exact;
//   }

//   h2.report-title {
//     text-align: center;
//     font-size: 16px;
//     margin-bottom: 8px;
//     font-weight: bold;
//     text-decoration: underline;
//   }

//   table {
//     width: 100%;
//     border-collapse: collapse;
//     table-layout: fixed;
//   }

//   thead { display: table-header-group; }

//   thead tr:first-child th {
//     background-color: #003366 !important;
//     color: #fff !important;
//     padding: 5px 4px;
//     border: 1px solid #000;
//     text-align: center;
//     font-size: 13px;
//     font-weight: bold;
//     white-space: normal;
//     word-wrap: break-word;
//     -webkit-print-color-adjust: exact;
//     print-color-adjust: exact;
//   }

//   .addr-group th {
//     background-color: #003366 !important;
//     color: #fff !important;
//     font-size: 12px;
//     font-weight: bold;
//     padding: 4px 4px;
//     border: 1px solid #000;
//     text-align: center;
//     white-space: normal;
//     word-wrap: break-word;
//     -webkit-print-color-adjust: exact;
//     print-color-adjust: exact;
//   }

//   tbody tr td {
//     background-color: #ffffff !important;
//     -webkit-print-color-adjust: exact;
//     print-color-adjust: exact;
//   }

//   tbody td {
//     padding: 4px 5px;
//     border: 1px solid #aaa;
//     font-size: 14px;
//     color: #000 !important;
//     vertical-align: middle;
//     white-space: normal;
//     word-wrap: break-word;
//     text-align: left;
//   }

//   td.col-sr    { text-align: center !important; font-weight: 700; width: 30px; }
//   td.col-num   { text-align: right !important; }

//   /* Fixed column widths — tweak as needed */
//   col.c-sr       { width: 30px; }
//   col.c-name     { width: 130px; }
//   col.c-address  { width: 180px; }
//   col.c-pincode  { width: 55px; }
//   col.c-taluka   { width: 70px; }
//   col.c-district { width: 70px; }
//   col.c-state    { width: 60px; }
//   col.c-mobile   { width: 80px; }
//   col.c-email    { width: 110px; font-size: 12px; }
//   col.c-dob      { width: 70px; }
//   col.c-gst      { width: 100px; }
//   col.c-pan      { width: 75px; }
//   col.c-deposit  { width: 60px; }
//   col.c-type     { width: 50px; }
//   col.c-start    { width: 70px; }
//   col.c-end      { width: 70px; }
//   col.c-status   { width: 50px; }
//   col.c-narr     { width: 100px; }

//   @media print {
//     @page { size: A3 landscape; margin: 6mm; }
//     body { padding: 0; font-size: 14px; }
//     .noPrint, .no-print { display: none !important; }
//     tbody tr { page-break-inside: avoid; }
//   }
// </style>
//         </head>
//         <body>

//           <h2 class="report-title">Representative / Agent List</h2>

//          <table>
//   <colgroup>
//     <col class="c-sr">
//     <col class="c-name">
//     <col class="c-address">
//     <col class="c-pincode">
//     <col class="c-taluka">
//     <col class="c-district">
//     <col class="c-state">
//     <col class="c-mobile">
//     <col class="c-email">
//     <col class="c-dob">
//     <col class="c-gst">
//     <col class="c-pan">
//     <col class="c-deposit">
//     <col class="c-type">
//     <col class="c-start">
//     <col class="c-end">
//     <col class="c-status">
//     <col class="c-narr">
//   </colgroup>
//   <thead>

//           <script>
//             const repData = ${JSON.stringify(this._repDataForPrint)};
//             const tbody = document.getElementById('printTableBody');

//             repData.forEach((rep, i) => {
//               const tr = document.createElement('tr');
//               tr.innerHTML =
//                 '<td class="col-sr">'  + (i + 1) + '</td>' +

//                 // Name - left
//                 '<td>' + (rep.issueSellerName || '') + '</td>' +

//                 // Address - wraps
//                 '<td class="col-address">' + (rep.address || '') + '</td>' +

//                 // Pincode - right (number)
//                 '<td class="col-num">' + (rep.pincode || '') + '</td>' +

//                 // Taluka - left
//                 '<td>' + (rep.taluka || '') + '</td>' +

//                 // District - left
//                 '<td>' + (rep.district || '') + '</td>' +

//                 // State - left
//                 '<td>' + (rep.state || '') + '</td>' +

//                 // Mobile - right (number)
//                 '<td class="col-num">' + (rep.mobile_no || '') + '</td>' +

//                 // Email - left
//                 '<td style="font-size:9px">' + (rep.email || '') + '</td>' +

//                 // DOB - center
//                 '<td style="text-align:center">' + (rep.dateofbirth || '') + '</td>' +

//                 // GST - left
//                 '<td style="font-size:9px">' + (rep.gstNo || rep.gst_no || '') + '</td>' +

//                 // PAN - left
//                 '<td>' + (rep.pan_no || '') + '</td>' +

//                 // Deposit - right (number)
//                 '<td class="col-num">' + (rep.deposit ?? '') + '</td>' +

//                 // Type - center
//                 '<td style="text-align:center">' + (rep.type || '') + '</td>' +

//                 // Start Date - center
//                 '<td style="text-align:center">' + (rep.startDate || rep.start_date || '') + '</td>' +

//                 // End Date - center
//                 '<td style="text-align:center">' + (rep.endDate || rep.end_date || '') + '</td>' +

//                 // Status - center
//                 '<td style="text-align:center">' + (rep.status || '') + '</td>' +

//                 // Narration - left
//                 '<td>' + (rep.narration || '') + '</td>';

//               tbody.appendChild(tr);
//             });

//             window.onload = function () {
//               setTimeout(() => {
//                 window.print();
//                 window.close();
//               }, 400);
//             };
//           </script>
//         </body>
//       </html>
//     `);
//       printWindow.document.close();
//     } else {
//       console.error("Failed to open print window.");
//     }
//   }

printPagesList() {

   this._repDataForPrint = this.filteredList;

  console.log('REP DATA SAMPLE:', this.filteredList[0]);
  this.show = true;

  console.log('REP DATA SAMPLE:', this.repList[0]);
  this.show = true;

  const table = document.getElementById('repListSection1');
  if (!table) {
    console.error("Print section not found!");
    return;
  }

  const width = 1600;
  const height = 900;
  const left = (window.screen.width / 2) - (width / 2);
  const top = (window.screen.height / 2) - (height / 2);

  const printWindow = window.open('', '', `width=${width},height=${height},top=${top},left=${left},scrollbars=yes`);

  if (printWindow) {
    const repData = this._repDataForPrint;

    let rows = '';
    repData.forEach((rep: any, i: number) => {

      // Build address string: address, pincode, taluka, district, state
      const addrParts = [
        rep.address   || '',
        rep.pincode   || '',
        rep.taluka    || '',
        rep.district  || '',
        rep.state     || ''
      ].filter(p => p.toString().trim() !== '').join(', ');

      rows += `<tr>
        <td class="col-sr">${i + 1}</td>
        <td>${rep.issueSellerName || ''}</td>
        <td class="col-address">${addrParts}</td>
        <td class="col-num">${rep.mobile_no || ''}</td>
        <td class="col-email">${rep.email || ''}</td>
        <td class="col-center">${rep.dateofbirth || ''}</td>
        <td class="col-small">${rep.gstNo || rep.gst_no || ''}</td>
        <td>${rep.pan_no || ''}</td>
        <td class="col-num">${rep.deposit ?? ''}</td>
        <td class="col-center">${rep.type || ''}</td>
        <td class="col-center">${rep.startDate || rep.start_date || ''}</td>
        <td class="col-center">${rep.endDate || rep.end_date || ''}</td>
        <td class="col-center">${rep.status || ''}</td>
        <td>${rep.narration || ''}</td>
      </tr>`;
    });

    printWindow.document.open();
    printWindow.document.write(`<!DOCTYPE html>
<html>
  <head>
    <meta charset="UTF-8">
    <title>Representative List</title>
    <style>
      * { box-sizing: border-box; margin: 0; padding: 0; }

      body {
        font-family: Arial, sans-serif;
        font-size: 13px;
        padding: 10px;
        background: #fff;
        color: #000;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      h2.report-title {
        text-align: center;
        font-size: 16px;
        margin-bottom: 10px;
        font-weight: bold;
        text-decoration: underline;
        color: #000;
      }

      .table-wrapper {
        width: 100%;
        overflow-x: auto;
      }

      table {
        border-collapse: collapse;
        table-layout: auto;
        width: max-content;
        min-width: 100%;
      }

      thead { display: table-header-group; }

      thead tr.main-header th {
        background-color: #003366 !important;
        color: #fff !important;
        padding: 5px 8px;
        border: 1px solid #000;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        white-space: nowrap;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      tbody tr {
        background-color: #ffffff !important;
      }

      tbody td {
        background-color: #ffffff !important;
        padding: 4px 8px;
        border: 1px solid #aaa;
        font-size: 13px;
        color: #000 !important;
        vertical-align: middle;
        white-space: nowrap;
        text-align: left;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      /* Address column wraps, fixed width */
      td.col-address {
        white-space: normal !important;
        word-wrap: break-word;
        max-width: 200px;
        min-width: 150px;
        vertical-align: top;
        font-size: 12px !important;
      }

      td.col-sr     { text-align: center !important; font-weight: 700; }
      td.col-num    { text-align: right !important; }
      td.col-center { text-align: center !important; }
      td.col-email  { font-size: 11px !important; }
      td.col-small  { font-size: 11px !important; }

      @media print {
        @page {
          size: A2 landscape;
          margin: 6mm;
        }
        body { padding: 0; margin: 0; }
        .table-wrapper { overflow: visible; }
        .print-scale { transform-origin: top left; }
        .no-print { display: none !important; }
        tbody tr { page-break-inside: avoid; }
      }
    </style>
  </head>
  <body>

    <h2 class="report-title">Representative / Agent List</h2>

    <div class="table-wrapper">
      <table id="mainTable" class="print-scale">
        <thead>
          <tr class="main-header">
            <th>Sr</th>
            <th>Name</th>
            <th>Address</th>
            <th>Mobile</th>
            <th>Email</th>
            <th>DOB</th>
            <th>GST No</th>
            <th>PAN No</th>
            <th>Deposit (&#8377;)</th>
            <th>Type</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Status</th>
            <th>Narration</th>
          </tr>
        </thead>
        <tbody>
          ${rows}
        </tbody>
      </table>
    </div>

    <script>
      window.onload = function () {
        // A2 landscape ~582mm printable = ~2200px at 96dpi
        const printAreaWidth = 2200;
        const tableWidth = document.getElementById('mainTable').scrollWidth;

        if (tableWidth > printAreaWidth) {
          const scale = printAreaWidth / tableWidth;
          const t = document.getElementById('mainTable');
          t.style.transformOrigin = 'top left';
          t.style.transform = 'scale(' + scale + ')';
        }

        setTimeout(function() {
          window.print();
          window.close();
        }, 600);
      };
    </script>

  </body>
</html>`);
    printWindow.document.close();
  } else {
    console.error("Failed to open print window.");
  }
}

  printPages(): void {
    this.show = true;

    const sectionElem = document.getElementById('repListSection1');
    if (!sectionElem) {
      console.error('Print section not found!');
      return;
    }

    const rows = Array.from(sectionElem.querySelectorAll('table tbody tr'));

    const labels = rows.map((row: any) => {
      const tds = row.querySelectorAll('td');
      return {
        name: tds[1]?.innerText?.trim() || '',
        address: [
          tds[2]?.innerText?.trim(),   // address
          tds[6]?.innerText?.trim(),   // taluka
          tds[5]?.innerText?.trim(),   // district
          tds[3]?.innerText?.trim(),   // pincode
          tds[4]?.innerText?.trim(),   // state
        ].filter(Boolean).join(', '),
        mobile: tds[7]?.innerText?.trim() || ''  // mobile
      };
    }).filter((x: any) => x.name);

    if (!labels.length) { alert('No data found'); return; }

    const LABELS_PER_PAGE = 18;
    const pages = [];
    for (let i = 0; i < labels.length; i += LABELS_PER_PAGE) {
      pages.push(labels.slice(i, i + LABELS_PER_PAGE));
    }

    const totalPages = pages.length;
    const today = new Date();
    const dateStr = today.toLocaleDateString('mr-IN', {
      day: '2-digit', month: '2-digit', year: 'numeric'
    });

    let finalHtml = '';

    pages.forEach((pageLabels: any[], pageIndex: number) => {

      while (pageLabels.length < LABELS_PER_PAGE) {
        pageLabels.push({ name: '', address: '', mobile: '' });
      }

      let rowsHtml = '';
      for (let r = 0; r < 6; r++) {
        const rowItems = pageLabels.slice(r * 3, r * 3 + 3);
        rowsHtml += `
        <div class="print-row">
          ${rowItems.map((l: any) => `
            <div class="label-box">
              ${l.name ? `<div class="lbl-name">${l.name}</div>` : ''}
              ${l.address ? `<div class="lbl-address">${l.address}</div>` : ''}
              ${l.mobile && l.mobile !== '0'
            ? `<div class="lbl-mobile">मो.क्र :- ${l.mobile}</div>` : ''}
            </div>
          `).join('')}
        </div>
      `;
      }

      finalHtml += `
      <div class="page">
        <div class="page-header">
          <span class="page-left"></span>
          <span class="page-title">प्रतिनिधी यादी</span>
          <span class="page-date">दि. ${dateStr}</span>
        </div>
        <div class="page-content">
          ${rowsHtml}
        </div>
        <div class="page-footer">
          <span>पृष्ठ ${pageIndex + 1} / ${totalPages}</span>
        </div>
      </div>
    `;
    });

    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    printWindow.document.write(`
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>प्रतिनिधी यादी</title>
<style>
* { box-sizing: border-box; margin: 0; padding: 0; }
body { font-family: Arial, sans-serif; background: #ccc; }

.page {
  width: 210mm;
  height: 297mm;
  background: #fff;
  margin: 6px auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page-header {
  flex: 0 0 12mm;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 6mm;
  background: #fff;
}

.page-left {
  font-size: 12px;
  font-weight: bold;
  text-align: left;
}

.page-title {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  padding: 0 4mm;
}

.page-date {
  font-size: 11px;
  text-align: right;
  white-space: nowrap;
}

.page-content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 3mm 5mm;
  overflow: hidden;
}

.print-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex: 1 1 0;
  overflow: hidden;
  min-height: 0;
}

.label-box {
  width: 32.5%;
  overflow: hidden;
  padding: 2mm 2.5mm 1.5mm 6mm;
  display: block;
}

.lbl-name {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.3;
  margin-bottom: 1mm;
  word-break: break-word;
}

.lbl-address {
  font-size: 14px;
  line-height: 1.35;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  margin-bottom: 1mm;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}

.lbl-mobile {
  font-size: 14px;
  line-height: 1.2;
}

.page-footer {
  flex: 0 0 8mm;
  display: flex;
  align-items: center;
  justify-content: right;
  padding: 0 6mm;
  font-size: 11px;
  font-weight: bold;
  color: #000;
}

@media print {
  body { background: white; }

  @page {
    size: A4 portrait;
    margin: 0;
  }

  .page {
    width: 100%;
    height: 297mm;
    margin: 0;
    page-break-after: always;
    overflow: hidden;
  }

  .page:last-child { page-break-after: auto; }

  .page-header {
    flex: 0 0 12mm;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    padding: 0 6mm;
    background: #fff;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .page-footer {
    flex: 0 0 8mm;
    display: flex;
    align-items: center;
    justify-content: right;
    padding: 0 6mm;
    font-size: 11px;
    font-weight: bold;
    color: #000;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .page-content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 3mm 5mm;
    overflow: hidden;
  }

  .print-row {
    flex: 1 1 0;
    overflow: hidden;
    min-height: 0;
    page-break-inside: avoid;
  }

  .label-box {
    overflow: hidden;
    display: block;
    padding: 2mm 2.5mm 1.5mm 6mm;
  }

  .lbl-address {
    font-size: 14px;
    line-height: 1.35;
    -webkit-line-clamp: 4;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .lbl-mobile {
    font-size: 14px;
    line-height: 1.2;
  }
}
</style>
</head>
<body>
${finalHtml}
</body>
</html>
  `);

    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => { printWindow.print(); }, 700);
  }


  addofficerepform() {
    let addofficerep = {
      officerep: this.officerepform.get('issuesellername').value,
      address1: this.officerepform.get('address1').value,
      pincode: this.officerepform.get('pincode').value,
      country: this.officerepform.get('country').value,
      state: this.officerepform.get('state').value,
      taluka: this.officerepform.get('taluka').value,
      district: this.officerepform.get('district').value,
      mnumber: this.officerepform.get('mnumber').value,
      email: this.officerepform.get('email').value,
      landline_no: this.officerepform.get('landline_no').value ? null : '',
      dob: this.officerepform.get('dob')?.value,
      gstno: this.officerepform.get('gstno').value,
      panno: this.officerepform.get('panno').value,
      start_date: this.officerepform.get('start_date').value,
      end_date: this.officerepform.get('end_date').value,
      status: this.officerepform.get('1').value,

    };
    // console.log(addofficerep);

    this.service.addOfficeRep(addofficerep).subscribe((data) => {
      // console.log('addOfficeRep', data);
      window.alert('Office Representative Added Successfully....');
      this.officerepform.reset();
      this.ngOnInit();
    });
  }

  // addassignrep() {
  //   let dataofrep = {
  //     rep_id: this.rep_id,
  //     book_id: this.book_id,
  //     sub_id: this.sub_id,
  //     advt_id: this.advt_id,
  //     issue_id: this.issue_id,
  //   };

  //   setTimeout(() => {
  //     this.service.adddeptwiseOfficeRep(dataofrep).subscribe((data) => {
  //       // console.log('adddeptwiseOfficeRep', data);
  //       window.alert('Department wise Representative assigned successfully...');
  //       setTimeout(() => {
  //         this.repassignform.reset();
  //       }, 2000);
  //     });
  //     this.ngOnInit();
  //     window.alert('Representative already available...');
  //   }, 2000);
  //   this.ngOnInit();
  // }

  addassignrep() {
  let dataofrep = {
    rep_id: this.rep_id,
    book_id: this.book_id,
    sub_id: this.sub_id,
    advt_id: this.advt_id,
    issue_id: this.issue_id,
  };

  this.service.adddeptwiseOfficeRep(dataofrep).subscribe({
    next: (data) => {
      window.alert('Department wise Representative assigned successfully...');
      this.repassignform.reset();
            // extract your refresh logic here instead of calling ngOnInit()
    },
    error: (err) => {
      if (err.status === 409 || err.status === 422) {
        window.alert(err.error?.error || 'Representative already assigned.');
      } else {
        window.alert('Something went wrong. Please try again.');
      }
    }
  });
}

  updateassignrep() {
    let dataofrep = {
      id: this.rep_off_assign_id,
      book_id: this.book_id,
      sub_id: this.sub_id,
      advt_id: this.advt_id,
      issue_id: this.issue_id,
    };

    // console.log(dataofrep);
    this.service.updateDeptwiseOffRepAssign(dataofrep).subscribe((data) => {
      window.alert('Department wise Representative updated successfully...');
      // location.reload();
      this.repassignform.reset();
      this.autocomfunction();
    });
    this.ngOnInit();
  }


  printSection3(sectionId: string): void {
    const sectionElem = document.getElementById(sectionId);
    if (!sectionElem) {
      console.warn(`Element with id "${sectionId}" not found.`);
      return;
    }

    const htmlToPrint = sectionElem.outerHTML;
    const printWindow = window.open('', '_blank',
      'width=900,height=650,left=200,toolbar=0,scrollbars=1,status=0');
    if (!printWindow) return;

    printWindow.document.write(`
    <html>
      <head>
        <title>Print Representatives</title>
        <style>
          @media print {
            @page { margin: 0; }
            body {
              margin: 10mm;
              font-family: Arial, sans-serif;
              font-size: 14px; /* Global font size */
            }
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 13px; /* Table font size */
            }
            th {
              font-size: 14px; /* Heading font size */
              background-color: #f2f2f2;
            }
            th, td {
              border: 1px solid #333;
              padding: 8px;
              text-align: center;
            }
          }
        </style>
      </head>
      <body onload="window.print();">
        ${htmlToPrint}
      </body>
    </html>
  `);

    printWindow.document.close();
  }



  getPincode2(event) {
    if (this.officerepform.get('pincode').valid) {
      // console.log(this.officerepform.get('pincode').value);
      this.service
        .getPincodeData(parseInt(this.officerepform.get('pincode').value))
        .subscribe((data) => {
          // console.log('pincode data', data);
          this.getCountry({ value: data[0]['country_name'] });
          setTimeout(() => {
            this.getState({ value: data[0]['state_name'] });
          }, 100);
          setTimeout(() => {
            this.getDistricts({ value: data[0]['district_name'] });
          }, 500);
          this.officerepform.get('country').setValue(data[0]['country_name']);
          this.officerepform.get('state').setValue(data[0]['state_name']);
          this.officerepform.get('district').setValue(data[0]['district_name']);
          setTimeout(() => {
            this.officerepform.get('taluka').setValue(data[0]['taluka_name']);
          }, 500);
        });
    }
  } //getPincode

  // getCountry(event) {
  //   let country = this.countries.find((a) => a.country_name == event.value);
  //   if (country != undefined) {
  //     // Set Marathi value
  //     this.addform.get('country').setValue(event.value);

  //     // Auto-translate to English
  //     this.translateText(event.value, 'mr', 'en').subscribe({
  //       next: (translatedText) => {
  //         this.addform.get('country_en')?.setValue(translatedText, { emitEvent: false });
  //       },
  //       error: (err) => console.error('Country translation error:', err)
  //     });

  //     // Load states for the selected country
  //     this.service.getState(country['country_code']).subscribe((data) => {
  //       this.states = data;
  //     });
  //   }
  // }

  // getState(event) {
  //   console.log(event.value);
  //   this.state_id = event.value;

  //   // Set Marathi value
  //   this.addform.get('state').setValue(event.value);

  //   // Auto-translate to English
  //   this.translateText(event.value, 'mr', 'en').subscribe({
  //     next: (translatedText) => {
  //       this.addform.get('state_en')?.setValue(translatedText, { emitEvent: false });
  //     },
  //     error: (err) => console.error('State translation error:', err)
  //   });

  //   let state = this.states.find((a) => a.state_name == event.value);
  //   if (state != undefined) {
  //     this.selectedState = state.state_name;
  //     this.service.getDistrict(state['state_id']).subscribe((data) => {
  //       this.cities = data;
  //       this.selectedCity = null;
  //     });
  //   }
  // }

  // getDistricts(event) {
  //   // Set Marathi value
  //   this.addform.get('district').setValue(event.value);
  //   this.selectedCity = event.value;

  //   // Auto-translate to English
  //   this.translateText(event.value, 'mr', 'en').subscribe({
  //     next: (translatedText) => {
  //       this.addform.get('district_en')?.setValue(translatedText, { emitEvent: false });
  //     },
  //     error: (err) => console.error('District translation error:', err)
  //   });

  //   let district = this.cities.find((a) => a.district_name == event.value);
  //   let dist = [];
  //   dist.push(district['district_id']);
  //   if (district != undefined) {
  //     this.service.getTaluka(dist).subscribe((data) => {
  //       this.talukas = data;
  //     });
  //   }
  // }

  // Add this method for Taluka selection
  getTalukaValue(event) {
    // Set Marathi value
    this.addform.get('taluka').setValue(event.value);
    this.selectedTaluka = event.value;

    // Auto-translate to English
    this.translateText(event.value, 'mr', 'en').subscribe({
      next: (translatedText) => {
        this.addform.get('taluka_en')?.setValue(translatedText, { emitEvent: false });
      },
      error: (err) => console.error('Taluka translation error:', err)
    });
  }

  cancelRepresentativeForm() {
    let mobile = this.form2.get('mobileNumber').value;
    var sixdigitsrandom = Math.floor(100000 + Math.random() * 900000);
    let msg =
      'Dear Subscriber, Your Verification Code is ' +
      sixdigitsrandom +
      ', Regards OEM Ekvira Media Pvt. Ltd.';
    let template = 'Brahman20';
    this.service.sendSMS(mobile, msg, template).subscribe((a) => { });
    this.dialog.open(CancelRepDialogComponent, {
      data: {
        message: sixdigitsrandom,
        mobile: mobile,
        height: '600px',
        width: '600px',
      },
    });
    this.form2.reset();
  }

  magazineData = [];
  addmags() {
    if (
      this.NewMagazineForm.get('mag_name').value != null &&
      this.NewMagazineForm.get('ig_cat').value != null
    ) {
      let mag_name = this.NewMagazineForm.get('mag_name').value;
      let ig_cat = this.NewMagazineForm.get('ig_cat').value;

      this.magazineData.push({
        mag_name: mag_name,
        ig_cat: ig_cat,
      });
      // this.NewMagazineForm.get('mag_name').reset();
      this.NewMagazineForm.get('ig_cat').reset();
    }
  }

  removeItem(item, i) {
    if (window.confirm('Do you really want to remove ?')) {
      if (item['id']) {
        // console.log('remove from DB');
        this.service
          .updateMagazineIssueGranthCategorytoInactive(item['id'])
          .subscribe((data) => {
            window.alert('Data Removed Successfully...');
            location.reload();
          });
      } else {
        this.magazineData.splice(i, 1);
      }
    }
  }

  addNewMagazine() {
    // console.log(this.magazineData.length);
    if (this.magazineData.length != 0) {
      for (
        let index = 0;
        index < Object.keys(this.magazineData).length;
        index++
      ) {
        if (this.magazineData[index]['id']) {
          this.magazineData.splice(index, 1);
        }

        // console.log(this.magazineData);

        let data = {
          mag_name: this.magazineData[index]['mag_name'],
          ig_cat: this.magazineData[index]['ig_cat'],
        };

        this.service.insertMagazineIssueGranthCate(data).subscribe((res) => {
          // console.log(res);
        });
      }

      setTimeout(() => {
        alert('Magazine Added Successfully...');
        this.magazineData = [];
      }, 1000);
    }
  }

  getMagazineIssueGranthData() {
    this.service.getMagazineIssueGranthCategoryData().subscribe((data) => {
      // console.log(data);
      this.MagazineIssueGranthData = data;
      for (
        let index = 0;
        index < Object.keys(this.MagazineIssueGranthData).length;
        index++
      ) {
        this.MagazineIssueGranthMag_names.push({
          mag_name: this.MagazineIssueGranthData[index]['mag_name'],
        });
      }

      this.MagazineIssueGranthMag_names = this.uniqueid(
        this.MagazineIssueGranthMag_names,
        (a) => a['mag_name']
      );
    });
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  selected_magName(event, option) {
    if (event.isUserInput) {
      let data = this.MagazineIssueGranthData.filter(
        (a) => a['mag_name'] == option['mag_name']
      );
      // console.log(data);
      this.magazineData = data;
    }
  }

  updateItem(item, i) {
    // console.log(item);
    let result = this.dialog.open(UpdateMagazineNameAndCategoryComponent, {
      data: {
        val: item,
      },
      width: '500px',
      height: '400px',
      maxWidth: '100%',
    });

    // console.log(this.magazineData[i]);

    result.afterClosed().subscribe((res) => {
      // console.log(res);
      if (res['res'] != 'close') {
        this.magazineData[i]['mag_name'] = res['res']['mag_name'];
        this.magazineData[i]['ig_cat'] = res['res']['ig_cat'];
      } else {
        window.alert('Data Uploaded Successfully...');
        location.reload();
      }
    });
  }

  updateAdvtSize(item) {
    // console.log(item);

    let result = this.dialog.open(UpdateAdvtSizesComponent, {
      data: {
        val: item,
      },
      width: '500px',
      height: '400px',
      maxWidth: '100%',
    });

    result.afterClosed().subscribe((res) => {
      if (res['res'] == 'close') {
        window.alert('Data Updated Successfully...');
        this.ngOnInit();
      }
    });
  }

  removeAdvtSize(item) {
    if (window.confirm('Do you really want to remove ?')) {
      this.service.updateAdvtSizeInactive(item['id']).subscribe((data) => {
        this.ngOnInit();
      });
    }
  }

  total_pages = 0;
  calcPages(event) {
    // console.log(event.target.value);
    this.total_pages += parseInt(event.target.value);
    this.IssueDates.get('totalpages').setValue(this.total_pages);
  }

  getIssues(e) {

    // console.log(e);
    this.issueName = e.value;
    // console.log('jgfdfgh', this.issueName);
    this.service.getAdvtSizeByCategory(e.value).subscribe((data) => {
      this.advtsizebyCategory = data;
    });
    // console.log('hi', e.option.group.label);

    // console.log(
    //   'advt_mag_name_details',
    //   this.advt_mag_name_details.filter((a) => a.issue_name == this.issueName)
    // );
    // this.getFilterMagPublishDates = this.advt_mag_name_details.filter(
    //   (a) => a.issue_name == this.issueName
    // )[0]['publishing_date'];
    // console.log(this.getFilterMagPublishDates);
    this.service.getAdvtDatesAndNames(e.value).subscribe((data) => {
      this.getMagIssueDatesandNames = data;
      // console.log('Issue Dates and Names:', this.getMagIssueDatesandNames);
      for (
        let index = 0;
        index < Object.keys(this.getMagIssueDatesandNames).length;
        index++
      ) {
        this.filterdMagIssueDatesandNames.push({
          value: `${formatDate(
            this.getMagIssueDatesandNames[index]['issueDate'],
            'dd/MM/yyyy',
            'en-IN',
            'GMT+0530'
          )},${this.getMagIssueDatesandNames[index]['issueName']},${formatDate(
            this.getMagIssueDatesandNames[index]['publishedDate'],
            'dd/MM/yyyy',
            'en-IN',
            'GMT+0530'
          )}`,
          data: `${formatDate(
            this.getMagIssueDatesandNames[index]['issueDate'],
            'dd/MM/yyyy',
            'en-IN',
            'GMT+0530'
          )} ${this.getMagIssueDatesandNames[index]['issueName']} ${formatDate(
            this.getMagIssueDatesandNames[index]['publishedDate'],
            'dd/MM/yyyy',
            'en-IN',
            'GMT+0530'
          )}`,
        });
      }
      // console.log(
      //   'filterdMagIssueDatesandNames:',
      //   this.filterdMagIssueDatesandNames
      // );
    });
  }

  getDates;
  stringdates;
  getAdvtDates(e) {


    // console.log(e.value)


    if (e.value[0] == 'ALL') {
      this.getDates = e.value;;
      return
    }
    this.getDates = e.value;;
    // this.getDates = this.getDates.filter((a) => a != 'all');
    // console.log('getDates', this.getDates);
    this.stringdates = this.getDates.toString();
    this.issueDates = this.stringdates;
    // console.log('StringDates', this.stringdates);
    // this.startDate_registrationReport = '';
    // this.enddate_registrationReport = '';
    // this.getAnkSerialNo(this.issueDates);
  }

  allSelected2 = false;
  @ViewChild('mySel2') skillSel2: MatSelect;
  toggleAllSelection2() {
    this.allSelected2 = !this.allSelected2; // to control select-unselect
    // console.log(this.skillSel2.options);
    if (this.allSelected2) {
      this.skillSel2.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel2.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel2.close();
  }
  adddates() {
    let issueseller = {
      issueSellerId: this.repId1,
      start_date: this.startDate_contract,
      end_date: this.enddate_contract
    }

    this.service.addstart_end_dates_to_rep(issueseller).subscribe(
      (data) => {
        alert('Representative dates added successfully...');
        // this.addform.reset();
        this.ngOnInit();
      },
      (error) => {
        alert('Representative Already Present ...');
      }
    );


  }

  addsbhet() {

    this.issuedate = this.sbhet.get('date').value

    this.formattedDate = formatDate(this.issuedate, 'yyyy-MM-dd', 'en-IN');


    let issueseller = {
      issueSellerId: this.sbhet.get('issueseller').value,
      sbhet: this.sbhet.get('sbhet').value,
      // issue_date: this.sbhet.get('issuedate').value,
      issue_name: this.sbhet.get('issuename').value,
      issue_date: this.formattedDate,
      jahiratsbhet: this.sbhet.value.jahiratsbhet,
      issuesbhet: this.sbhet.value.issuesbhet,
      inputValue: this.sbhet.value.input_value,
      input_value1: this.sbhet.value.input_value1,
      input_value2: this.sbhet.value.input_value2,
    };

    this.service.addIssueSellerSaprembhet(issueseller).subscribe(
      (data) => {
        alert('Representative added successfully...');
        this.addform.reset();
        this.ngOnInit();
      },
      (error) => {
        // alert('Representative Already Present ...');
        if (error.status === 409) {
          alert('Representative Already Present for this date');
        } else {
          alert('An error occurred: ' + error.error.error);
        }
      }
    );


    console.log(this.sbhet.value)
  }

  selected_repname1: boolean = false;
  repId1 = 0;
  selected_rep_name1(event: any, option: any) {
    this.searchDataOfSapremBhet(option.name);

    if (!event.isUserInput) return;

    const data = this.issue_seller_name.filter(
      (a: any) => a['name'] === option['name']
    );
    if (!data || !data.length) return;

    const d = data[0];
    this.sbhet.get('issueseller').setValue(d['id']);
    this.selected_repname1 = true;
    this.repId1 = d['id'];

    this.addform.patchValue({
      issuesellername: d['issueSellerName'] || d['name'] || '',
      address1: d['address'] || '',
      pincode: d['pincode'] || '',
      mnumber: d['mobile_no'] || '',
      email: d['email'] || '',
      landline_no: d['landline_no'] || '',
      dob: d['dateofbirth']
        ? formatDate(d['dateofbirth'], 'yyyy-MM-dd', 'en-IN', 'GMT+0530')
        : '',
      panno: d['panno'] || '',
      depositamt: d['deposit_amt'] || '',
      option: d['issueSellerType'] || '',
      sampremebhet: d['s_bhet'] || '',
      distype: d['distype'] || '',
      country: d['country'] || '',
      state: d['state'] || '',
      district: d['district'] || '',
      taluka: d['taluka'] || '',
      // English fields from DB
      issuesellername_en: d['eng_issueSellerName'] || '',
      address1_en: d['e_Address'] || '',
      country_en: d['e_Country'] || '',
      state_en: d['e_State'] || '',
      district_en: d['eng_districts'] || '',
      taluka_en: d['e_Taluka'] || '',
      start_date: d['start_date'] || '',
      end_date: d['end_date'] || '',
      narration: d['narration'] || '',
      rep_status: d['status'] || '',

    });

    this.selectedCity = d['district'];

    this.getCountry({ value: d['country'] });
    setTimeout(() => this.getState({ value: d['state'] }), 300);
    setTimeout(() => this.getDistricts({ value: d['district'] }), 700);
    setTimeout(
      () => this.addform.get('taluka')?.setValue(d['taluka'], { emitEvent: false }),
      1100
    );
  }

  searchData: any[] = []
  serachParam: any = null
  searchDataOfSapremBhet(name: any) {
    this.serachParam = name;
    if (!name) {
      this.searchData = [...this.sbhetdata];
    } else {
      this.searchData = this.sbhetdata.filter(item => item.issueSellerName === name);
    }
  }
  setOriginalData() {
    this.serachParam = null
    this.searchData = this.sbhetdata;
  }

  deletesbhet(item) {
    let issueseller = {
      issueSellerId: item.id,
    };

    this.service.deleteIssueSellerSaprembhet(issueseller).subscribe(
      (data) => {
        alert('Dates delete successfully...');
        this.startenddate.reset();
        this.ngOnInit();
      }
    );
  }
  deletesbhet1(item) {
    let issueseller = {
      id: item.id,
    };

    this.service.deleteIssueStartEndDate(issueseller).subscribe(
      (data) => {
        alert('Saprem Bhet delete successfully...');
        this.addform.reset();
        this.ngOnInit();
      }
    );
  }

  deletesbhetlist(item) {
    let issueseller = {
      issueSellerId: item.id,
    };

    this.service.deleteIssueSellerSaprembhet(issueseller).subscribe(
      (data) => {
        alert('Saprem Bhet list delete successfully...');
        this.addform.reset();
        this.ngOnInit();
      }
    );
  }

  deleteoldlist(item) {
    let issueseller = {
      issueSellerId: item.id,
    };

    this.service.deleteolddatalist(issueseller).subscribe(
      (data) => {
        alert('Representative delete successfully...');
        // this.addform.reset();
        // this.ngOnInit();
      }
    );
  }
  updateActiveStatus(item: any, id: any) {
    let issueseller = {
      id: id,
      status: item
    };

    this.service.updateActiveStatus(issueseller).subscribe(
      (data) => {
        this.getSupremBhetData();
        alert('Saprem Bhet successfully ' + item);
        // this.addform.reset();
        // this.ngOnInit();
      }
    );
  }
  obj: any
  update_sapremBhetdata: any
  updateSbhetData(item) {
    this.update_sapremBhetdata = item
    this.updatesbhet = true;

    this.sbhet.get('id').setValue(item['issueSellerName']);
    this.sbhet.get('issuename').setValue(item['issueName']);
    this.sbhet.get('sbhet').setValue(item['s_bhet']);
    this.sbhet.get('date').setValue(item['start_date'])
    this.sbhet.get('jahiratsbhet').setValue(item['jahirat_sbhet'])
    this.sbhet.get('issuesbhet').setValue(item['issues_bhet'])
    this.getIssues1(item['issueName'], item['issueDate'])
    this.sbhet.get('input_value').setValue(item['input_value'] ?? 0);
    this.sbhet.get('input_value1').setValue(item['input_value1'] ?? 0);
    this.sbhet.get('input_value2').setValue(item['input_value2'] ?? 0);
  }

  update_sapremBhetdata1: any
  updateDates(item) {
    this.update_sapremBhetdata1 = item
    this.updatesbhet = true;

    this.startenddate.get('id').setValue(item['issueSellerName']);
    this.startenddate.get('start').setValue(item['start_date']);
    // this.sbhet.get('sbhet').setValue(item['s_bhet']); 
    this.startenddate.get('end').setValue(item['end_date'])
    // this.getIssues1(item['issueName'],item['issueDate'])
  }

  getIssues1(e, issuedate) {

    // console.log(e);
    this.issueName = e;
    // console.log('jgfdfgh', this.issueName);
    this.service.getAdvtSizeByCategory(e).subscribe((data) => {
      this.advtsizebyCategory = data;
    });
    // console.log('hi', e.option.group.label);

    // console.log(
    //   'advt_mag_name_details',
    //   this.advt_mag_name_details.filter((a) => a.issue_name == this.issueName)
    // );
    // this.getFilterMagPublishDates = this.advt_mag_name_details.filter(
    //   (a) => a.issue_name == this.issueName
    // )[0]['publishing_date'];
    // console.log(this.getFilterMagPublishDates);
    this.service.getAdvtDatesAndNames(e).subscribe((data) => {
      this.getMagIssueDatesandNames = data;

      this.obj = this.getMagIssueDatesandNames.filter((x: any) => x.issueDate === issuedate)[0];
      this.sbhet.get('issuedate').setValue(this.obj.id);

      // console.log('Issue Dates and Names:', this.getMagIssueDatesandNames);
      for (
        let index = 0;
        index < Object.keys(this.getMagIssueDatesandNames).length;
        index++
      ) {

        this.filterdMagIssueDatesandNames.push({ id: this.getMagIssueDatesandNames[index]['issueDate'] })
        this.filterdMagIssueDatesandNames.push({
          value: `${formatDate(
            this.getMagIssueDatesandNames[index]['issueDate'],
            'dd/MM/yyyy',
            'en-IN',
            'GMT+0530'
          )},${this.getMagIssueDatesandNames[index]['issueName']},${formatDate(
            this.getMagIssueDatesandNames[index]['publishedDate'],
            'dd/MM/yyyy',
            'en-IN',
            'GMT+0530'
          )}`,
          data: `${formatDate(
            this.getMagIssueDatesandNames[index]['issueDate'],
            'dd/MM/yyyy',
            'en-IN',
            'GMT+0530'
          )} ${this.getMagIssueDatesandNames[index]['issueName']} ${formatDate(
            this.getMagIssueDatesandNames[index]['publishedDate'],
            'dd/MM/yyyy',
            'en-IN',
            'GMT+0530'
          )}`,
        });
      }
      console.log(
        'filterdMagIssueDatesandNames:',
        this.filterdMagIssueDatesandNames
      );
    });
  }

  updatedates() {
    debugger
    let issueseller = {
      id: this.update_sapremBhetdata1.id,
      start_date: this.startDate_contract,
      end_date: this.enddate_contract,
    };

    this.service.updatesdates(issueseller).subscribe(
      (data) => {
        alert('Dates Updated  successfully...');
        this.addform.reset();
        this.ngOnInit();
      }
    );
  }
  updatesbhetdata() {
    debugger
    let issueseller = {
      issueSellerId: this.update_sapremBhetdata.id,
      sbhet: this.sbhet.get('sbhet').value,
      issue_date: this.sbhet.value.date,
      issue_name: this.sbhet.get('issuename').value,
      jahiratsbhet: this.sbhet.value.jahiratsbhet,
      issuesbhet: this.sbhet.value.issuesbhet,
      input_value: this.sbhet.value.input_value,
      input_value1: this.sbhet.value.input_value1,
      input_value2: this.sbhet.value.input_value2,
    };

    this.service.updatesbhetdata(issueseller).subscribe(
      (data) => {
        alert('Saprem Bhet Updated  successfully...');
        this.addform.reset();
        this.ngOnInit();
      }
    );
  }


  // onSelectionChange() {
  //   const selectedType = this.repassigntype.value.type
  //   const selectedOption = this.getdepwiserepcount1.find(option => option.rep_type === selectedType);
  //   this.count = selectedOption.count;
  //   this.assignoffwithtype();
  // }

  onSelectionChange() {
    const selectedType = this.repassigntype.value.type;

    // Find the selected object to get its count
    const selectedOption = this.getdepwiserepcount1.find(option => option.rep_type === selectedType);

    if (selectedOption) {
      this.count = selectedOption.count;
    } else {
      this.count = 0; // default to 0 if not found
    }

    this.assignoffwithtype();
  }


  assignoffwithtype() {
    setTimeout(() => {
      this.rep_type = this.repassigntype.value.type

      this.service.getListofassignrep(this.rep_type).subscribe((data) => {
        this.getdatabydep = data;
        console.log('Data by department:', this.getdatabydep);
      });
    }, 0);
  }


  printSection2(sectionId: string, selectedType: string = ''): void {

    const sectionElem = document.getElementById(sectionId);
    if (!sectionElem) { alert('Section not found'); return; }

    const rows = Array.from(sectionElem.querySelectorAll('table tbody tr'));

    const labels = rows.map((row: any) => {
      const tds = row.querySelectorAll('td');
      return {
        name: tds[2]?.textContent?.trim() || '',   // Rep. Name
        address: [
          tds[3]?.textContent?.trim(),                // Address
          tds[4]?.textContent?.trim(),                // Taluka
          tds[5]?.textContent?.trim(),                // District
          tds[6]?.textContent?.trim(),                // Pincode
          tds[7]?.textContent?.trim(),                // State
        ].filter(Boolean).join(', '),
        mobile: tds[8]?.textContent?.trim() || ''   // Mobile
      };
    }).filter((x: any) => x.name);

    if (!labels.length) { alert('No data found'); return; }

    const LABELS_PER_PAGE = 18;
    const pages = [];
    for (let i = 0; i < labels.length; i += LABELS_PER_PAGE) {
      pages.push(labels.slice(i, i + LABELS_PER_PAGE));
    }

    const totalPages = pages.length;
    const today = new Date();
    const dateStr = today.toLocaleDateString('mr-IN', {
      day: '2-digit', month: '2-digit', year: 'numeric'
    });

    let finalHtml = '';

    pages.forEach((pageLabels: any[], pageIndex: number) => {

      while (pageLabels.length < LABELS_PER_PAGE) {
        pageLabels.push({ name: '', address: '', mobile: '' });
      }

      let rowsHtml = '';
      for (let r = 0; r < 6; r++) {
        const rowItems = pageLabels.slice(r * 3, r * 3 + 3);
        rowsHtml += `
        <div class="print-row">
          ${rowItems.map((l: any) => `
            <div class="label-box">
              ${l.name ? `<div class="lbl-name">${l.name}</div>` : ''}
              ${l.address ? `<div class="lbl-address">${l.address}</div>` : ''}
              ${l.mobile && l.mobile !== '0'
            ? `<div class="lbl-mobile">मो.क्र :- ${l.mobile}</div>` : ''}
            </div>
          `).join('')}
        </div>
      `;
      }

      finalHtml += `
      <div class="page">

        <div class="page-header">
          <span class="page-left">${selectedType || ''}</span>
          <span class="page-title">प्रतिनिधी यादी</span>
          <span class="page-date">दि. ${dateStr}</span>
        </div>

        <div class="page-content">
          ${rowsHtml}
        </div>

        <div class="page-footer">
          <span>पृष्ठ ${pageIndex + 1} / ${totalPages}</span>
        </div>

      </div>
    `;
    });

    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    printWindow.document.write(`
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>प्रतिनिधी यादी</title>
<style>

* { box-sizing: border-box; margin: 0; padding: 0; }
body { font-family: Arial, sans-serif; background: #ccc; }

/* ══ PAGE ══ */
.page {
  width: 210mm;
  height: 297mm;
  background: #fff;
  margin: 6px auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ══ HEADER ══
   3 columns: left(name) | center(title) | right(date)
   Each takes equal width so center is truly centered
*/
.page-header {
  flex: 0 0 12mm;
  display: grid;
  grid-template-columns: 1fr auto 1fr;  /* left | center | right */
  align-items: center;
  padding: 0 6mm;
  background: #fff;
}

.page-left {
  font-size: 12px;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.page-title {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  padding: 0 4mm;
}

.page-date {
  font-size: 11px;
  text-align: right;
  white-space: nowrap;
}

/* ══ CONTENT ══ */
.page-content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 3mm 5mm;
  overflow: hidden;
}

/* ══ ROW ══ */
.print-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex: 1 1 0;
  overflow: hidden;
  min-height: 0;
}

/* ══ LABEL BOX ══ */
.label-box {
  width: 32.5%;
  overflow: hidden;
  padding: 2mm 2.5mm 1.5mm 6mm;
  display: block;
}

.lbl-name {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.3;
  margin-bottom: 1mm;
  word-break: break-word;
}

.lbl-address {
  font-size: 14px;
  line-height: 1.35;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  margin-bottom: 1mm;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}

.lbl-mobile {
  font-size: 14px;
  line-height: 1.2;
}

/* ══ FOOTER ══ */
.page-footer {
  flex: 0 0 8mm;
  display: flex;
  align-items: center;
  justify-content: right;   /* center the page number */
  padding: 0 6mm;
  font-size: 11px;
  font-weight: bold;
  color: #000;               /* black so it's always visible */
}

/* ══════════════════════════════
   PRINT
══════════════════════════════ */
@media print {

  body { background: white; }

  @page {
    size: A4 portrait;
    margin: 0;
  }

  .page {
    width: 100%;
    height: 297mm;
    margin: 0;
    page-break-after: always;
    overflow: hidden;
  }

  .page:last-child { page-break-after: auto; }

  .page-header {
    flex: 0 0 12mm;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    padding: 0 6mm;
    background: #fff;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .page-footer {
    flex: 0 0 8mm;
    display: flex;
    align-items: center;
    justify-content: right;
    padding: 0 6mm;
    font-size: 11px;
    font-weight: bold;
    color: #000;               /* force black in print */
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .page-content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 3mm 5mm;
    overflow: hidden;
  }

  .print-row {
    flex: 1 1 0;
    overflow: hidden;
    min-height: 0;
    page-break-inside: avoid;
  }

  .label-box {
    overflow: hidden;
    display: block;
    padding: 2mm 2.5mm 1.5mm 6mm;
  }

  .lbl-address {
    font-size: 14px;
    line-height: 1.35;
    -webkit-line-clamp: 4;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .lbl-mobile {
    font-size: 14px;
    line-height: 1.2;
  }
}

</style>
</head>
<body>
${finalHtml}
</body>
</html>
`);

    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => { printWindow.print(); }, 700);
  }



  addcountryfun() {
  if (this.updatecountry123) return; // ← prevent Add when in update mode

  const data: any = {
    "country_name": this.addcountry.value.country_name,
    "country_code": this.addcountry.value.country_code,
    "sequence_id": this.addcountry.value.sequence_id
  };

  this.service.addcountry(data).subscribe(
    () => {
      alert('Country Added Successfully...');
      this.addcountry.reset();
      this.ngOnInit(); // ← refresh list
    },
    () => alert('Something went wrong.')
  );
}


  // addlanguage() {
  //   const data: any = {
  //     "language": this.addlang.value.language,

  //   }

  //   console.log(data)

  //   this.service.addlanguage(data).subscribe(
  //     (data) => {
  //       alert('Language Added Successfully...');
  //       // this.addform.reset();
  //       this.ngOnInit();
  //     }
  //   );
  // }

 addlanguage() {
  const payload = {
    data: {
      language: this.addlang.value.language  // ← wrap it properly
    }
  };

  this.service.addlanguage(payload).subscribe(
    (res) => {
      alert('Language Added Successfully...');
      this.ngOnInit();
    }
  );
}



  // updatecountryfun() {
  //   const data: any = {
  //     "id": this.countryid,
  //     "country_name": this.addcountry.value.country_name,
  //     "country_code": this.addcountry.value.country_code,
  //     "sequence_id": this.addcountry.value.sequence_id  // make sure this is included
  //   }

  //   this.service.updatecountry(data).subscribe(
  //     (response) => {
  //       alert('Country Updated Successfully...');
  //       // this.addform.reset();
  //       // this.ngOnInit();
  //     },
  //     (error) => {
  //       if (error.status === 409) {
  //         alert('Sequence ID is already assigned to another country!');
  //       } else if (error.status === 400) {
  //         alert('Invalid country ID!');
  //       } else if (error.status === 422) {
  //         alert('Failed to update country. Please try again.');
  //       } else {
  //         alert('Something went wrong. Please try again.');
  //       }
  //     }
  //   );
  // }

  updatecountryfun() {
  const data: any = {
    "id": this.countryid,
    "country_name": this.addcountry.value.country_name,
    "country_code": this.addcountry.value.country_code,
    "sequence_id": this.addcountry.value.sequence_id
  };

  this.service.updatecountry(data).subscribe(
    () => {
      alert('Country Updated Successfully...');
      this.addcountry.reset();
      this.updatecountry123 = false; // ← reset update mode
      this.countryid = null;
      this.ngOnInit(); // ← refresh list
    },
    (error) => {
      if (error.status === 409) alert('Sequence ID is already assigned to another country!');
      else if (error.status === 400) alert('Invalid country ID!');
      else if (error.status === 422) alert('Failed to update country. Please try again.');
      else alert('Something went wrong. Please try again.');
    }
  );
}

  assignoffwithoffrep() {
    setTimeout(() => {
      this.off_rep = this.repassignoff.value.off_rep;

      this.service.getListofassignoff(this.off_rep).subscribe((response: any) => {
        // `response` is the object with `count` and `data`
        this.getdatabyoff = response.data;  // store the array of reps
        this.totalCount = response.count;   // store the count separately if needed

        console.log("Total Count:", this.totalCount);
        console.log("Representative Data:", this.getdatabyoff);
      });
    }, 0);
  }


  getSelectedRepNames(): string {
    const selectedIds: number[] = this.repassignoff.get('off_rep')?.value || [];
    const names = this.getrepname
      .filter(opt => selectedIds.includes(opt.id))
      .map(opt => opt.officerep)
      .join(', ');
    return `कार्यालय प्रतिनिधी :- ${names}`;
  }


  printSection1(sectionId: string, selectedName: string = ''): void {

    const sectionElem = document.getElementById(sectionId);
    if (!sectionElem) { alert('Section not found'); return; }

    const rows = Array.from(sectionElem.querySelectorAll('table tbody tr'));

    const labels = rows.map((row: any) => {
      const tds = row.querySelectorAll('td');
      return {
        name: tds[1]?.innerText?.trim() || '',
        address: tds[2]?.innerText?.trim() || '',
        mobile: tds[3]?.innerText?.trim() || ''
      };
    }).filter((x: any) => x.name);

    if (!labels.length) { alert('No data found'); return; }

    const LABELS_PER_PAGE = 18;
    const pages = [];
    for (let i = 0; i < labels.length; i += LABELS_PER_PAGE) {
      pages.push(labels.slice(i, i + LABELS_PER_PAGE));
    }

    const totalPages = pages.length;
    const today = new Date();
    const dateStr = today.toLocaleDateString('mr-IN', {
      day: '2-digit', month: '2-digit', year: 'numeric'
    });

    let finalHtml = '';

    pages.forEach((pageLabels: any[], pageIndex: number) => {

      while (pageLabels.length < LABELS_PER_PAGE) {
        pageLabels.push({ name: '', address: '', mobile: '' });
      }

      let rowsHtml = '';
      for (let r = 0; r < 6; r++) {
        const rowItems = pageLabels.slice(r * 3, r * 3 + 3);
        rowsHtml += `
        <div class="print-row">
          ${rowItems.map((l: any) => `
            <div class="label-box">
              ${l.name ? `<div class="lbl-name">${l.name}</div>` : ''}
              ${l.address ? `<div class="lbl-address">${l.address}</div>` : ''}
              ${l.mobile && l.mobile !== '0'
            ? `<div class="lbl-mobile">मो.क्र :- ${l.mobile}</div>` : ''}
            </div>
          `).join('')}
        </div>
      `;
      }

      finalHtml += `
      <div class="page">

        <div class="page-header">
          <span class="page-left">${selectedName}</span>
          <span class="page-title">प्रतिनिधी यादी</span>
          <span class="page-date">दि. ${dateStr}</span>
        </div>

        <div class="page-content">
          ${rowsHtml}
        </div>

        <div class="page-footer">
          <span>पृष्ठ ${pageIndex + 1} / ${totalPages}</span>
        </div>

      </div>
    `;
    });

    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    printWindow.document.write(`
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>प्रतिनिधी यादी</title>
<style>

* { box-sizing: border-box; margin: 0; padding: 0; }
body { font-family: Arial, sans-serif; background: #ccc; }

/* ══ PAGE ══ */
.page {
  width: 210mm;
  height: 297mm;
  background: #fff;
  margin: 6px auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ══ HEADER ══
   3 columns: left(name) | center(title) | right(date)
   Each takes equal width so center is truly centered
*/
.page-header {
  flex: 0 0 12mm;
  display: grid;
  grid-template-columns: 1fr auto 1fr;  /* left | center | right */
  align-items: center;
  padding: 0 6mm;
  background: #fff;
}

.page-left {
  font-size: 12px;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.page-title {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  padding: 0 4mm;
}

.page-date {
  font-size: 11px;
  text-align: right;
  white-space: nowrap;
}

/* ══ CONTENT ══ */
.page-content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 3mm 5mm;
  overflow: hidden;
}

/* ══ ROW ══ */
.print-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex: 1 1 0;
  overflow: hidden;
  min-height: 0;
}

/* ══ LABEL BOX ══ */
.label-box {
  width: 32.5%;
  overflow: hidden;
  padding: 2mm 2.5mm 1.5mm 6mm;
  display: block;
}

.lbl-name {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.3;
  margin-bottom: 1mm;
  word-break: break-word;
}

.lbl-address {
  font-size: 14px;
  line-height: 1.35;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  margin-bottom: 1mm;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}

.lbl-mobile {
  font-size: 14px;
  line-height: 1.2;
}

/* ══ FOOTER ══ */
.page-footer {
  flex: 0 0 8mm;
  display: flex;
  align-items: center;
  justify-content: right;   /* center the page number */
  padding: 0 6mm;
  font-size: 11px;
  font-weight: bold;
  color: #000;               /* black so it's always visible */
}

/* ══════════════════════════════
   PRINT
══════════════════════════════ */
@media print {

  body { background: white; }

  @page {
    size: A4 portrait;
    margin: 0;
  }

  .page {
    width: 100%;
    height: 297mm;
    margin: 0;
    page-break-after: always;
    overflow: hidden;
  }

  .page:last-child { page-break-after: auto; }

  .page-header {
    flex: 0 0 12mm;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    padding: 0 6mm;
    background: #fff;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .page-footer {
    flex: 0 0 8mm;
    display: flex;
    align-items: center;
    justify-content: right;
    padding: 0 6mm;
    font-size: 11px;
    font-weight: bold;
    color: #000;               /* force black in print */
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .page-content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 3mm 5mm;
    overflow: hidden;
  }

  .print-row {
    flex: 1 1 0;
    overflow: hidden;
    min-height: 0;
    page-break-inside: avoid;
  }

  .label-box {
    overflow: hidden;
    display: block;
    padding: 2mm 2.5mm 1.5mm 6mm;
  }

  .lbl-address {
    font-size: 14px;
    line-height: 1.35;
    -webkit-line-clamp: 4;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .lbl-mobile {
    font-size: 14px;
    line-height: 1.2;
  }
}

</style>
</head>
<body>
${finalHtml}
</body>
</html>
`);

    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => { printWindow.print(); }, 700);
  }






  setTabIndex(tabindex: any) {
    localStorage.setItem("tab", tabindex)
  }


  onTabClick(event: any) {
    console.log(event)
    localStorage.setItem("tab", event.index)
  }
  startDate_contract: any = '';
  enddate_contract: any = '';
  getChangedDateContractSE() {
    if (
      this.startenddate.get('start').value != null &&
      this.startenddate.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.startenddate.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.startenddate.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
    console.log(this.startDate_contract, this.enddate_contract, this.repId1)
    console.log(this.issue_seller_name)
  }

  selected_rep_name2(event: MatOptionSelectionChange, option: any) {
    if (event.isUserInput) {
      const selectedName = option.name;
      const selectedId = option.id;

      console.log('Selected Name:', selectedName);
      console.log('Selected ID:', selectedId);

      // You can now use the selected ID as needed in your component.
    }
  }

  // updatecountry(item) {
  //   this.updatecountry123 = true;
  //   debugger;
  //   this.countryid = item.country_id
  //   this.addcountry.get('country_name').setValue(item['country_name']);
  //   this.addcountry.get('country_code').setValue(item['country_code']);
  // }


  updatecountrysen(item) {
    this.updatesenioritybtn = true
    debugger;
    this.off_rep_id = item.id
    this.addseni.get('off_repname').setValue(item['officerep']);
    this.addseni.get('dept').setValue(item['dep_name']);
    this.addseni.get('seniority').setValue(item['seniority']);
  }
  deleteseniority(id) {
    this.service.deleteseniority(id).subscribe(
      (data) => {
        alert('Seniority Delete Successfully...');
        // this.addform.reset();
        // this.ngOnInit();
      }
    );
  }


  // updatesenioritybtn: boolean = false;
  // updateseniority() {
  //   const data: any = {
  //     "id": this.off_rep_id,
  //     "off_rep_id": this.addseni.value.off_repname,
  //     "dep_id": this.addseni.value.dept,
  //     "seniority": this.addseni.value.seniority,

  //   }
  //   debugger;

  //   this.service.updateseniority(data).subscribe((data) => {

  //     alert('Seniority Updated Successfully...');
  //     // this.addform.reset();
  //     // this.ngOnInit();
  //   }
  //   );
  // }


  getSupremBhetData() {
    debugger
    this.service.getSbhetdataadmin().subscribe((data) => {
      this.sbhetdata = data;
      this.searchData = [...this.sbhetdata];
      console.log('issueSellerName of sbhet ', data);
    });
  }

  exportToExcel(): void {
    const exportData = this.getdatabydep.map((item: any, index: number) => ({
      'Sr. No.': index + 1,
      'Off Representative Name': item['office_rep_name'],
      'Taluka': item['taluka'],
      'District': item['district'],
      'State': item['state'],
      'Address': item['address'],
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Representatives');

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    saveAs(blob, 'Representative_List.xlsx');
  }


  exportToExcelOffice() {
  const exportData = this.officeRepDataSource.data.map((rep, i) => ({
    '#': i + 1,
    'Name': rep.issuesellername,
    'Mobile': rep.mnumber,
    'Address': rep.address || '',
    'Pincode': rep.pincode || '',
    'Country': rep.country || '',
    'State': rep.state || '',
    'District': rep.district || '',
    'Taluka': rep.taluka || '',
    'Email': rep.email || '',
    'Start Date': rep.start_date || '',
    'End Date': rep.end_date || '',
    'Status': rep.status == 1 ? 'Active' : 'Inactive'
  }));

  const ws = XLSX.utils.json_to_sheet(exportData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Representatives');
  XLSX.writeFile(wb, 'office_representatives.xlsx');
}


  exportToExcelOffRep(): void {
    const exportData = this.getdatabyoff.map((item: any, index: number) => ({
      'Sr. No.': index + 1,
      'Representative Name': item['rep_name'],
      'Mobile No': item['mobile_no'],
      'Address': `${item['rep_address']} ${item['rep_taluka']} ${item['rep_district']} ${item['rep_state']}`,
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Representatives');

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    saveAs(blob, 'OfficeRep_Representative_List.xlsx');
  }

  exportToExcelAssignRep(): void {
    const exportData = this.deptwise_off_rep_list.map((item: any, index: number) => ({
      'Sr. No.': index + 1,
      'Representative Name': item['rep_name'],
      'Book Store': item['book_off_rep_name'],
      'Subscription': item['sub_off_rep_name'],
      'Advertisement': item['advt_off_rep_name'],
      'Issue Sale': item['issue_off_rep_name'],
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Assign Representatives');

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    saveAs(blob, 'Assign_Representative_List.xlsx');
  }



  // printSectionAddressList(sectionId: string): void {
  //   const sectionElem = document.getElementById(sectionId);
  //   if (!sectionElem) {
  //     console.warn(`Element with id "${sectionId}" not found.`);
  //     return;
  //   }

  //   const htmlToPrint = sectionElem.outerHTML;
  //   const printWindow = window.open('', '_blank',
  //     'width=900,height=650,left=200,toolbar=0,scrollbars=1,status=0');
  //   if (!printWindow) return;

  //   printWindow.document.write(`
  //   <html>
  //     <head>
  //       <title>Print Representatives</title>
  //       <style>
  //         @media print {
  //           @page {
  //             size: A3 landscape;
  //             margin: 8mm;
  //           }
  //         }

  //         body {
  //           margin: 0;
  //           padding: 10px 14px;
  //           font-family: Arial, sans-serif;
  //           font-size: 10px;
  //           color: #000;
  //           background: #fff;
  //           -webkit-print-color-adjust: exact;
  //           print-color-adjust: exact;
  //         }

  //         table {
  //           width: 100%;
  //           border-collapse: collapse;
  //           table-layout: auto;
  //         }

  //         thead { display: table-header-group; }

  //         th {
  //           font-size: 10px;
  //           font-weight: 700;
  //           background-color: #1a3556 !important;
  //           color: #fff !important;
  //           border: 1px solid #000;
  //           padding: 5px 6px;
  //           text-align: center;
  //           vertical-align: middle;
  //           white-space: nowrap;
  //           -webkit-print-color-adjust: exact;
  //           print-color-adjust: exact;
  //         }

  //         td {
  //           border: 1px solid #555;
  //           padding: 4px 6px;
  //           vertical-align: middle;
  //           color: #000 !important;
  //           font-size: 10px;
  //           white-space: nowrap;
  //           text-align: left;        /* default: left for all text */
  //         }

  //         /* Sr No - center */
  //         td:first-child {
  //           text-align: center !important;
  //           font-weight: 700;
  //         }

  //         /* Number columns - right align */
  //         td.num-col {
  //           text-align: right !important;
  //         }

  //         /* Address column - wrap + wider + left */
  //         td.address-col,
  //         th.address-col {
  //           white-space: normal !important;
  //           min-width: 180px;
  //           max-width: 220px;
  //           text-align: left !important;
  //           word-wrap: break-word;
  //         }

  //         tbody tr:nth-child(even) td {
  //           background-color: #f0f6ff !important;
  //           -webkit-print-color-adjust: exact;
  //           print-color-adjust: exact;
  //         }

  //         tbody tr { page-break-inside: avoid; }

  //         .noPrint, .no-print { display: none !important; }
  //       </style>

  //       <script>
  //         document.addEventListener('DOMContentLoaded', function () {
  //           const table = document.querySelector('table');
  //           if (!table) return;

  //           const headers = table.querySelectorAll('thead th');

  //           const addressKeywords  = ['address', 'पत्ता'];
  //           const numberKeywords   = ['mobile', 'phone', 'deposit', 'pincode',
  //                                     'pan', 'gst', 'amount', 'मोबाईल', 'ठेव',
  //                                     'pin', 'no.', 'number'];

  //           headers.forEach((th, i) => {
  //             const txt = th.textContent?.toLowerCase().trim() || '';

  //             /* ── Address column ── */
  //             if (addressKeywords.some(k => txt.includes(k))) {
  //               th.classList.add('address-col');
  //               table.querySelectorAll('tbody tr').forEach(row => {
  //                 const cells = row.querySelectorAll('td');
  //                 if (cells[i]) cells[i].classList.add('address-col');
  //               });
  //             }

  //             /* ── Number columns ── */
  //             else if (i > 0 && numberKeywords.some(k => txt.includes(k))) {
  //               th.style.textAlign = 'right';
  //               table.querySelectorAll('tbody tr').forEach(row => {
  //                 const cells = row.querySelectorAll('td');
  //                 if (cells[i]) cells[i].classList.add('num-col');
  //               });
  //             }
  //           });

  //           /* ── Sr No → always center ── */
  //           table.querySelectorAll('tbody tr').forEach(row => {
  //             const cells = row.querySelectorAll('td');
  //             if (cells[0]) {
  //               cells[0].classList.remove('num-col');
  //               cells[0].style.textAlign = 'center';
  //             }
  //           });
  //         });
  //       </script>
  //     </head>
  //     <body onload="window.print();">
  //       ${htmlToPrint}
  //     </body>
  //   </html>
  // `);

  //   printWindow.document.close();
  // }

printSectionAddressList(sectionId: string, selectedType?: string): void {
  const sectionElem = document.getElementById(sectionId);
  if (!sectionElem) {
    console.warn(`Element with id "${sectionId}" not found.`);
    return;
  }

  // Clone the table and merge address columns
  const clone = sectionElem.cloneNode(true) as HTMLElement;
  const cloneTable = clone.querySelector('table');

  if (cloneTable) {
    const headers = Array.from(cloneTable.querySelectorAll('thead th'));

    const addressKeywords = ['address', 'पत्ता', 'pincode', 'pin', 'taluka', 'district', 'state'];
    const addressColIndices: number[] = [];

    headers.forEach((th, i) => {
      const txt = th.textContent?.toLowerCase().trim() || '';
      if (addressKeywords.some(k => txt.includes(k))) {
        addressColIndices.push(i);
      }
    });

    if (addressColIndices.length > 1) {
      const firstAddrIdx = addressColIndices[0];

      const headerRow = cloneTable.querySelector('thead tr');
      if (headerRow) {
        const thCells = headerRow.querySelectorAll('th');
        thCells[firstAddrIdx].textContent = 'Address';
        thCells[firstAddrIdx].classList.add('address-col');
        for (let k = addressColIndices.length - 1; k >= 1; k--) {
          thCells[addressColIndices[k]]?.remove();
        }
      }

      cloneTable.querySelectorAll('tbody tr').forEach(row => {
        const cells = row.querySelectorAll('td');
        const parts: string[] = [];
        addressColIndices.forEach(idx => {
          const val = cells[idx]?.textContent?.trim() || '';
          if (val) parts.push(val);
        });
        const merged = parts.join(', ');
        if (cells[firstAddrIdx]) {
          cells[firstAddrIdx].textContent = merged;
          cells[firstAddrIdx].classList.add('address-col');
        }
        for (let k = addressColIndices.length - 1; k >= 1; k--) {
          cells[addressColIndices[k]]?.remove();
        }
      });
    }
  }

  const htmlToPrint = clone.outerHTML;

  // Build title based on selected type
  const typeLabel = selectedType ? selectedType.trim().toUpperCase() : 'ALL';
  const reportTitle = `प्रतिनिधी यादी: ${typeLabel}`;

  const printWindow = window.open('', '_blank',
    'width=1400,height=900,left=100,toolbar=0,scrollbars=1,status=0');
  if (!printWindow) return;

  printWindow.document.write(`<!DOCTYPE html>
<html>
  <head>
    <meta charset="UTF-8">
    <title>Print Representatives</title>
    <style>
      * { box-sizing: border-box; margin: 0; padding: 0; }

      @media print {
        @page {
          size: A2 landscape;
          margin: 6mm;
        }
      }

      body {
        margin: 0;
        padding: 10px 14px;
        font-family: Arial, sans-serif;
        font-size: 14px;
        color: #000;
        background: #fff;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      .report-header {
        text-align: center;
        margin-bottom: 10px;
      }

      .report-header h2 {
        font-size: 17px;
        font-weight: bold;
        text-decoration: underline;
        color: #000;
        margin-bottom: 4px;
      }

      .report-header .type-badge {
        display: inline-block;
        font-size: 13px;
        font-weight: 600;
        color: #fff;
        background-color: #003366 !important;
        padding: 3px 14px;
        border-radius: 4px;
        letter-spacing: 1px;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      .table-wrapper {
        width: 100%;
        overflow-x: auto;
      }

      table {
        border-collapse: collapse;
        table-layout: fixed;
        width: 100%;
      }

      col.c-sr       { width: 38px;  }
      col.c-offrep   { width: 110px; }
      col.c-repname  { width: 130px; }
      col.c-address  { width: 220px; }
      col.c-mobile   { width: 95px;  }
      col.c-email    { width: 130px; }
      col.c-dob      { width: 80px;  }
      col.c-gst      { width: 120px; }
      col.c-pan      { width: 85px;  }
      col.c-deposit  { width: 75px;  }
      col.c-type     { width: 55px;  }
      col.c-start    { width: 80px;  }
      col.c-end      { width: 80px;  }
      col.c-status   { width: 60px;  }
      col.c-narr     { width: 110px; }

      thead { display: table-header-group; }

      th {
        font-size: 13px;
        font-weight: 700;
        background-color: #003366 !important;
        color: #fff !important;
        border: 1px solid #000;
        padding: 5px 6px;
        text-align: center;
        vertical-align: middle;
        white-space: normal;
        word-wrap: break-word;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      td {
        border: 1px solid #aaa;
        padding: 4px 6px;
        vertical-align: middle;
        background-color: #ffffff !important;
        color: #000 !important;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      td:first-child {
        text-align: center !important;
        font-weight: 700;
      }

      td.num-col {
        text-align: right !important;
      }

      td.address-col,
      th.address-col {
        white-space: normal !important;
        overflow: visible;
        text-overflow: clip;
        text-align: left !important;
        word-wrap: break-word;
        font-size: 12px !important;
        vertical-align: top;
        padding-top: 5px;
      }

      td.name-col {
        white-space: normal !important;
        overflow: visible;
        text-overflow: clip;
        word-wrap: break-word;
        font-size: 13px !important;
      }

      tbody tr {
        background-color: #ffffff !important;
      }

      tbody tr td {
        background-color: #ffffff !important;
      }

      tbody tr { page-break-inside: avoid; }

      .noPrint, .no-print, button, .mat-icon-button,
      .action-col, [class*="action"] { display: none !important; }
    </style>

    <script>
      document.addEventListener('DOMContentLoaded', function () {
        const table = document.querySelector('table');
        if (!table) return;

        const colClasses = [
          'c-sr','c-offrep','c-repname','c-address',
          'c-mobile','c-email','c-dob','c-gst',
          'c-pan','c-deposit','c-type','c-start',
          'c-end','c-status','c-narr'
        ];

        const headers = table.querySelectorAll('thead th');
        const colCount = headers.length;

        const cg = document.createElement('colgroup');
        for (let i = 0; i < colCount; i++) {
          const col = document.createElement('col');
          if (colClasses[i]) col.className = colClasses[i];
          cg.appendChild(col);
        }
        table.insertBefore(cg, table.firstChild);

        const numberKeywords = ['mobile', 'phone', 'deposit',
                                'pan', 'gst', 'amount', 'मोबाईल',
                                'ठेव', 'no.', 'number'];
        const nameKeywords   = ['name', 'representative', 'नाव',
                                'off.', 'rep.', 'प्रतिनिधी'];

        headers.forEach((th, i) => {
          const txt = th.textContent?.toLowerCase().trim() || '';

          if (i > 0 && numberKeywords.some(k => txt.includes(k))) {
            th.style.textAlign = 'right';
            table.querySelectorAll('tbody tr').forEach(row => {
              const cells = row.querySelectorAll('td');
              if (cells[i]) cells[i].classList.add('num-col');
            });
          }

          if (nameKeywords.some(k => txt.includes(k))) {
            table.querySelectorAll('tbody tr').forEach(row => {
              const cells = row.querySelectorAll('td');
              if (cells[i]) cells[i].classList.add('name-col');
            });
          }
        });

        table.querySelectorAll('tbody tr').forEach(row => {
          const cells = row.querySelectorAll('td');
          if (cells[0]) {
            cells[0].classList.remove('num-col');
            cells[0].style.textAlign = 'center';
          }
        });

        const printAreaWidth = 2200;
        const tableWidth = table.scrollWidth;
        if (tableWidth > printAreaWidth) {
          const scale = printAreaWidth / tableWidth;
          table.style.transformOrigin = 'top left';
          table.style.transform = 'scale(' + scale + ')';
        }

        setTimeout(function () {
          window.print();
          window.close();
        }, 600);
      });
    </script>
  </head>
  <body>
    <div class="report-header">
      <h2>प्रतिनिधी यादी</h2>
      <span class="type-badge">Type : ${typeLabel}</span>
    </div>
    <div class="table-wrapper">
      ${htmlToPrint}
    </div>
  </body>
</html>`);

  printWindow.document.close();
}


  // printSectionAddressList1(sectionId: string , selectedName: string = ''): void {
  //   const sectionElem = document.getElementById(sectionId);
  //   if (!sectionElem) {
  //     console.warn(`Element with id "${sectionId}" not found.`);
  //     return;
  //   }

  //   const htmlToPrint = sectionElem.outerHTML;
  //   const printWindow = window.open('', '_blank',
  //     'width=900,height=650,left=200,toolbar=0,scrollbars=1,status=0');
  //   if (!printWindow) return;

  //   printWindow.document.write(`
	// 	<html>
	// 	  <head>
	// 		<title>Print Representatives</title>
	// 		<style>
	// 		  @media print {
	// 			@page { margin: 0; }
	// 			body {
	// 			  margin: 10mm;
	// 			  font-family: Arial, sans-serif;
	// 			  font-size: 14px; /* Global font size */
	// 			}
	// 			table {
	// 			  width: 100%;
	// 			  border-collapse: collapse;
	// 			  font-size: 13px; /* Table font size */
	// 			}
	// 			th {
	// 			  font-size: 14px; /* Heading font size */
	// 			  background-color: #f2f2f2;
	// 			}
	// 			th, td {
	// 			  border: 1px solid #333;
	// 			  padding: 8px;
	// 			  text-align: center;
	// 			}
	// 		  }
	// 		</style>
	// 	  </head>
	// 	  <body onload="window.print();">
	// 		${htmlToPrint}
	// 	  </body>
	// 	</html>
	//   `);

  //   printWindow.document.close();
  // }

  printSectionAddressList1(sectionId: string, selectedName: string = ''): void {
  const sectionElem = document.getElementById(sectionId);
  if (!sectionElem) {
    console.warn(`Element with id "${sectionId}" not found.`);
    return;
  }

  const htmlToPrint = sectionElem.outerHTML;
  const nameLabel = selectedName ? selectedName.trim() : 'All Representatives';

  const printWindow = window.open('', '_blank',
    'width=900,height=650,left=200,toolbar=0,scrollbars=1,status=0');
  if (!printWindow) return;

  printWindow.document.write(`
    <html>
      <head>
        <meta charset="UTF-8">
        <title>Print Representatives</title>
        <style>
          @media print {
            @page { margin: 0; }
            body {
              margin: 10mm;
              font-family: Arial, sans-serif;
              font-size: 14px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 13px;
            }
            th {
              font-size: 14px;
              background-color: #f2f2f2;
            }
            th, td {
              border: 1px solid #333;
              padding: 8px;
              text-align: center;
            }
          }

          body {
            font-family: Arial, sans-serif;
            font-size: 14px;
            margin: 10mm;
          }

          .report-header {
            text-align: center;
            margin-bottom: 12px;
          }

          .report-header h2 {
            font-size: 17px;
            font-weight: bold;
            text-decoration: underline;
            color: #000;
            margin-bottom: 5px;
          }

          .report-header .name-badge {
            display: inline-block;
            font-size: 13px;
            font-weight: 600;
            color: #fff;
            background-color: #003366;
            padding: 3px 14px;
            border-radius: 4px;
            letter-spacing: 0.5px;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        </style>
      </head>
      <body onload="window.print();">
        <div class="report-header">
          <h2>प्रतिनिधी यादी</h2>
          <span class="name-badge"> ${nameLabel}</span>
        </div>
        ${htmlToPrint}
      </body>
    </html>
  `);

  printWindow.document.close();
}

// printList() {
//   const printData = this.officeRepDataSource.data.map((rep, i) => ({
//     '#': i + 1,
//     'Name': rep.issuesellername || '—',
//     'Mobile': rep.mnumber || '—',
//     'Address': rep.address || '—',
//     'Pincode': rep.pincode || '—',
//     'State': rep.state || '—',
//     'District': rep.district || '—',
//     'Email': rep.email || '—',
//     'Start Date': rep.start_date || '—',
//     'End Date': rep.end_date || '—',
//     'Status': rep.status == 1 ? 'Active' : 'Inactive'
//   }));

//   const headers = Object.keys(printData[0])
//     .map(h => `<th>${h}</th>`)
//     .join('');

//   const rows = printData.map(r =>
//     `<tr>${Object.entries(r).map(([key, val]) => {
//       if (key === 'Status') {
//         const cls = val === 'Active' ? 'status-active' : 'status-inactive';
//         return `<td><span class="${cls}">${val}</span></td>`;
//       }
//       return `<td>${val}</td>`;
//     }).join('')}</tr>`
//   ).join('');

//   const printWindow = window.open('', '_blank');
//   if (!printWindow) return;

//   printWindow.document.write(`
//     <!DOCTYPE html>
//     <html>
//     <head>
//       <title>Office Representatives</title>
//       <style>
//         * {
//           box-sizing: border-box;
//           margin: 0;
//           padding: 0;
//         }

//         body {
//           font-family: Arial, sans-serif;
//           font-size: 11px;
//           padding: 16px;
//           color: #212121;
//         }

//         h2 {
//           color: #1a237e;
//           font-size: 15px;
//           margin-bottom: 4px;
//         }

//         .print-meta {
//           font-size: 10px;
//           color: #555;
//           margin-bottom: 12px;
//         }

//         table {
//           width: 100%;
//           border-collapse: collapse;
//           border: 2px solid #1a237e;
//           table-layout: fixed;
//         }

//         thead tr {
//           background-color: #1a237e !important;
//           -webkit-print-color-adjust: exact;
//           print-color-adjust: exact;
//           color: #ffffff;
//         }

//         th {
//           background-color: #1a237e !important;
//           -webkit-print-color-adjust: exact;
//           print-color-adjust: exact;
//           color: #ffffff !important;
//           padding: 7px 8px;
//           text-align: left;
//           font-size: 11px;
//           font-weight: 700;
//           border: 1px solid #3949ab;
//           word-break: break-word;
//         }

//         td {
//           padding: 6px 8px;
//           border: 1px solid #c5cae9;
//           vertical-align: top;

//           /* ✅ These 3 lines ensure NO data is ever cut */
//           white-space: normal;
//           word-break: break-word;
//           overflow: visible;

//           line-height: 1.5;
//         }

//         tr:nth-child(even) td {
//           background-color: #e8eaf6 !important;
//           -webkit-print-color-adjust: exact;
//           print-color-adjust: exact;
//         }

//         /* Fixed column widths — address gets most space */
//         th:nth-child(1)  { width: 28px;  }   /* # */
//         th:nth-child(2)  { width: 95px;  }   /* Name */
//         th:nth-child(3)  { width: 85px;  }   /* Mobile */
//         th:nth-child(4)  { width: 145px; }   /* Address */
//         th:nth-child(5)  { width: 52px;  }   /* Pincode */
//         th:nth-child(6)  { width: 62px;  }   /* State */
//         th:nth-child(7)  { width: 65px;  }   /* District */
//         th:nth-child(8)  { width: 125px; }   /* Email */
//         th:nth-child(9)  { width: 62px;  }   /* Start Date */
//         th:nth-child(10) { width: 62px;  }   /* End Date */
//         th:nth-child(11) { width: 50px;  }   /* Status */

//         .status-active {
//           color: #1b5e20;
//           font-weight: 700;
//           background-color: #c8e6c9 !important;
//           -webkit-print-color-adjust: exact;
//           print-color-adjust: exact;
//           padding: 2px 7px;
//           border-radius: 10px;
//           font-size: 10px;
//           display: inline-block;
//         }

//         .status-inactive {
//           color: #b71c1c;
//           font-weight: 700;
//           background-color: #ffcdd2 !important;
//           -webkit-print-color-adjust: exact;
//           print-color-adjust: exact;
//           padding: 2px 7px;
//           border-radius: 10px;
//           font-size: 10px;
//           display: inline-block;
//         }

//         @media print {
//           thead {
//             display: table-header-group; /* repeat header on every page */
//           }
//           tr {
//             page-break-inside: avoid;   /* don't split a row across pages */
//           }
//         }
//       </style>
//     </head>
//     <body>
//       <h2>Office Representatives List</h2>
//       <div class="print-meta">
//         Printed on: ${new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
//         &nbsp;|&nbsp; Total Records: ${printData.length}
//       </div>
//       <table>
//         <thead><tr>${headers}</tr></thead>
//         <tbody>${rows}</tbody>
//       </table>
//     </body>
//     </html>
//   `);

//   printWindow.document.close();

//   // ✅ Wait for content to fully render before printing
//   printWindow.onload = () => {
//     printWindow.focus();
//     printWindow.print();
//   };
// }

printListAddress(): void {
  const data = this.officeRepDataSource.data;

  if (!data || !data.length) {
    alert('No data found');
    return;
  }

  const labels = data
    .filter((rep: any) => rep.issuesellername)
    .map((rep: any) => ({
      name: rep.issuesellername || '',
      address: [
        rep.address,
        rep.taluka || rep.e_Taluka,
        rep.district || rep.eng_districts,
        rep.pincode,
        rep.state
      ].filter(Boolean).join(', '),
      mobile: rep.mnumber || ''
    }));

  if (!labels.length) { alert('No data found'); return; }

  const LABELS_PER_PAGE = 18;
  const pages: any[][] = [];
  for (let i = 0; i < labels.length; i += LABELS_PER_PAGE) {
    pages.push(labels.slice(i, i + LABELS_PER_PAGE));
  }

  const totalPages = pages.length;
  const dateStr = new Date().toLocaleDateString('mr-IN', {
    day: '2-digit', month: '2-digit', year: 'numeric'
  });

  let finalHtml = '';

  pages.forEach((pageLabels: any[], pageIndex: number) => {

    // Pad to fill 18 slots
    while (pageLabels.length < LABELS_PER_PAGE) {
      pageLabels.push({ name: '', address: '', mobile: '' });
    }

    let rowsHtml = '';
    for (let r = 0; r < 6; r++) {
      const rowItems = pageLabels.slice(r * 3, r * 3 + 3);
      rowsHtml += `
        <div class="print-row">
          ${rowItems.map((l: any) => `
            <div class="label-box">
              ${l.name ? `<div class="lbl-name">${l.name}</div>` : ''}
              ${l.address ? `<div class="lbl-address">${l.address}</div>` : ''}
              ${l.mobile && l.mobile !== '0'
                ? `<div class="lbl-mobile">मो.क्र :- ${l.mobile}</div>` : ''}
            </div>
          `).join('')}
        </div>
      `;
    }

    finalHtml += `
      <div class="page">
        <div class="page-header">
          <span class="page-left"></span>
          <span class="page-title">प्रतिनिधी यादी</span>
          <span class="page-date">दि. ${dateStr}</span>
        </div>
        <div class="page-content">
          ${rowsHtml}
        </div>
        <div class="page-footer">
          <span>पृष्ठ ${pageIndex + 1} / ${totalPages}</span>
        </div>
      </div>
    `;
  });

  const printWindow = window.open('', '_blank');
  if (!printWindow) return;

  printWindow.document.write(`
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>प्रतिनिधी यादी</title>
<style>
* { box-sizing: border-box; margin: 0; padding: 0; }
body { font-family: Arial, sans-serif; background: #ccc; }

.page {
  width: 210mm;
  height: 297mm;
  background: #fff;
  margin: 6px auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page-header {
  flex: 0 0 12mm;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 6mm;
  background: #fff;
}

.page-title {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  padding: 0 4mm;
}

.page-date {
  font-size: 11px;
  text-align: right;
  white-space: nowrap;
}

.page-content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 3mm 5mm;
  overflow: hidden;
}

.print-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex: 1 1 0;
  overflow: hidden;
  min-height: 0;
}

.label-box {
  width: 32.5%;
  overflow: hidden;
  padding: 2mm 2.5mm 1.5mm 6mm;
  display: block;
}

.lbl-name {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.3;
  margin-bottom: 1mm;
  word-break: break-word;
}

.lbl-address {
  font-size: 14px;
  line-height: 1.35;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  margin-bottom: 1mm;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}

.lbl-mobile {
  font-size: 14px;
  line-height: 1.2;
}

.page-footer {
  flex: 0 0 8mm;
  display: flex;
  align-items: center;
  justify-content: right;
  padding: 0 6mm;
  font-size: 11px;
  font-weight: bold;
  color: #000;
}

@media print {
  body { background: white; }

  @page {
    size: A4 portrait;
    margin: 0;
  }

  .page {
    width: 100%;
    height: 297mm;
    margin: 0;
    page-break-after: always;
    overflow: hidden;
  }

  .page:last-child { page-break-after: auto; }

  .page-header {
    flex: 0 0 12mm;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    padding: 0 6mm;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .page-content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 3mm 5mm;
    overflow: hidden;
  }

  .print-row {
    flex: 1 1 0;
    overflow: hidden;
    min-height: 0;
    page-break-inside: avoid;
  }

  .label-box {
    overflow: hidden;
    display: block;
    padding: 2mm 2.5mm 1.5mm 6mm;
  }

  .lbl-address {
    -webkit-line-clamp: 4;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .page-footer {
    flex: 0 0 8mm;
    display: flex;
    align-items: center;
    justify-content: right;
    padding: 0 6mm;
    font-size: 11px;
    font-weight: bold;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>
</head>
<body>
${finalHtml}
</body>
</html>
  `);

  printWindow.document.close();
  printWindow.focus();
  setTimeout(() => { printWindow.print(); }, 700);
}

printList() {
  const printData = this.officeRepDataSource.data.map((rep, i) => [
    i + 1,
    rep.issuesellername || '—',
    rep.mnumber || '—',
    rep.address || '—',
    rep.pincode || '—',
    rep.state || '—',
    rep.district || '—',
    rep.email || '—',
    rep.start_date || '—',
    rep.end_date || '—',
    rep.status == 1 ? 'Active' : 'Inactive'
  ]);

  const headerLabels = ['#', 'Name', 'Mobile', 'Address', 'Pincode', 'State', 'District', 'Email', 'Start Date', 'End Date', 'Status'];

  const headers = headerLabels.map(h => `<th>${h}</th>`).join('');

  const rows = printData.map(r =>
    `<tr>${r.map((val, colIndex) => {
      if (colIndex === 10) { // Status column
        const cls = val === 'Active' ? 'status-active' : 'status-inactive';
        return `<td><span class="${cls}">${val}</span></td>`;
      }
      return `<td>${val}</td>`;
    }).join('')}</tr>`
  ).join('');

  const printWindow = window.open('', '_blank');
  if (!printWindow) return;

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>कार्यलय प्रतिनिधी</title>
      <style>
        @page {
          size: A4 landscape;
          margin: 10mm 12mm;
        }

        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        body {
          font-family: Arial, sans-serif;
          font-size: 10px;
          color: #212121;
          width: 273mm; /* A4 landscape (297mm) - 12mm*2 margins */
        }

        h2 {
          color: #1a237e;
          font-size: 13px;
          margin-bottom: 3px;
        }

        .print-meta {
          font-size: 9px;
          color: #555;
          margin-bottom: 8px;
        }

        table {
          width: 273mm;
          border-collapse: collapse;
          border: 2px solid #1a237e;
          table-layout: fixed; /* CRITICAL: enforces column widths strictly */
        }

        thead tr {
          background-color: #1a237e !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          color: #ffffff;
        }

        th {
          background-color: #1a237e !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          color: #ffffff !important;
          padding: 5px 5px;
          text-align: left;
          font-size: 12px;
          font-weight: 700;
          border: 1px solid #3949ab;
          /* CRITICAL: prevent header text from wrapping/overflowing */
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        td {
          padding: 4px 5px;
          border: 1px solid #c5cae9;
          vertical-align: top;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;
          line-height: 1.4;
          font-size: 12px;
        }

        tr:nth-child(even) td {
          background-color: #e8eaf6 !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        /*
          Total = 273mm
          Distribute: #(6) + Name(26) + Mobile(20) + Address(48) +
          Pincode(14) + State(18) + District(20) + Email(52) +
          StartDate(18) + EndDate(18) + Status(18) = 258mm
          Remaining 15mm auto handled by table width
        */
        th:nth-child(1)  { width: 10mm;  }   /* #         */
        th:nth-child(2)  { width: 28mm; }   /* Name      */
        th:nth-child(3)  { width: 22mm; }   /* Mobile    */
        th:nth-child(4)  { width: 50mm; }   /* Address   */
        th:nth-child(5)  { width: 14mm; }   /* Pincode   */
        th:nth-child(6)  { width: 20mm; }   /* State     */
        th:nth-child(7)  { width: 22mm; }   /* District  */
        th:nth-child(8)  { width: 53mm; }   /* Email     */
        th:nth-child(9)  { width: 20mm; }   /* Start Date*/
        th:nth-child(10) { width: 20mm; }   /* End Date  */
        th:nth-child(11) { width: 18mm; }   /* Status    */

        .status-active {
          color: #1b5e20;
          font-weight: 700;
          background-color: #c8e6c9 !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          padding: 1px 5px;
          border-radius: 8px;
          font-size: 11px;
          display: inline-block;
        }

        td:nth-child(1) {
  white-space: nowrap;
  text-align: center;
}
        .status-inactive {
          color: #b71c1c;
          font-weight: 700;
          background-color: #ffcdd2 !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          padding: 1px 5px;
          border-radius: 8px;
          font-size: 11px;
          display: inline-block;
        }

        @media print {
          body {
            width: 273mm;
          }
          thead {
            display: table-header-group;
          }
          tr {
            page-break-inside: avoid;
          }
        }
      </style>
    </head>
    <body>
      <h2>कार्यलय प्रतिनिधी</h2>
      <div class="print-meta">
        Printed on: ${new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
        &nbsp;|&nbsp; Total Records: ${printData.length}
      </div>
      <table>
        <thead><tr>${headers}</tr></thead>
        <tbody>${rows}</tbody>
      </table>
    </body>
    </html>
  `);

  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
  };
}


  ngOnDestroy(): void {
    // Restore default cursor when leaving this component
    document.body.style.cursor = 'auto';
  }




  cursorEnter(): void {
    if (!this.cursorDot || !this.cursorRing) return;
    this.cursorDot.style.width = '16px';
    this.cursorDot.style.height = '16px';
    this.cursorDot.style.opacity = '0.6';
    this.cursorRing.style.width = '48px';
    this.cursorRing.style.height = '48px';
    this.cursorRing.style.opacity = '0.8';
  }

  cursorLeave(): void {
    if (!this.cursorDot || !this.cursorRing) return;
    this.cursorDot.style.width = '10px';
    this.cursorDot.style.height = '10px';
    this.cursorDot.style.opacity = '1';
    this.cursorRing.style.width = '32px';
    this.cursorRing.style.height = '32px';
    this.cursorRing.style.opacity = '0.5';
  }

  onMouseMove(e: MouseEvent): void {
    const x = e.clientX;
    const y = e.clientY;

    this.cursorGlow.style.left = x + 'px';
    this.cursorGlow.style.top = y + 'px';
    this.cursorDot.style.left = x + 'px';
    this.cursorDot.style.top = y + 'px';
    this.cursorRing.style.left = x + 'px';
    this.cursorRing.style.top = y + 'px';
    this.cursorLabel.style.left = x + 'px';
    this.cursorLabel.style.top = y + 'px';

    // REMOVE the textContent line entirely — or set empty string:
    this.cursorLabel.textContent = '';
  }


  // ── Seniority state ──────────────────────────────────────
  updatesenioritybtn: boolean = false;
  editingRowId: number | null = null;
  // off_rep_id: any;

  /** Edit button: pre-fill form and switch to update mode */
  editSeniority(item: any) {
    this.updatesenioritybtn = true;
    this.editingRowId = item.id;
    this.off_rep_id = item.id;

    // Match by ID so mat-select highlights the correct option
    const matchedRep = this.getrepname.find(
      (r: any) => r.officerep === item.officerep
    );
    const matchedDept = this.getdeptdata.find(
      (d: any) => d.dep_name === item.dep_name || d.dep_id === item.dep_id
    );

    this.addseni.patchValue({
      off_repname: matchedRep ? matchedRep.id : item.off_rep_id,
      dept: matchedDept ? matchedDept.dep_id : item.dep_id,
      seniority: item.seniority,
    });
  }

  /** Cancel edit — reset form and flags */
  cancelSeniorityEdit() {
    this.updatesenioritybtn = false;
    this.editingRowId = null;
    this.off_rep_id = null;
    this.addseni.reset();
  }

  /** Add new seniority record */
  addseniority() {
    if (!this.addseni.value.off_repname || !this.addseni.value.dept || !this.addseni.value.seniority) {
      alert('Please fill all fields before adding.');
      return;
    }

    const data = {
      off_rep_id: this.addseni.value.off_repname,   // ID from select
      dep_id: this.addseni.value.dept,            // dep_id from select
      seniority: this.addseni.value.seniority,
    };

    this.service.addseniority(data).subscribe({
      next: () => {
        alert('Seniority added successfully.');
        this.addseni.reset();
        this.refreshSeniorityList();
      },
      error: (err) => {
        console.error('Add seniority failed', err);
        alert('Failed to add seniority. Please try again.');
      }
    });
  }

  /** Update existing seniority record */
  updateseniority() {
    if (!this.addseni.value.off_repname || !this.addseni.value.dept || !this.addseni.value.seniority) {
      alert('Please fill all fields before saving.');
      return;
    }

    const data = {
      id: this.off_rep_id,
      off_rep_id: this.addseni.value.off_repname,
      dep_id: this.addseni.value.dept,
      seniority: this.addseni.value.seniority,
    };

    this.service.updateseniority(data).subscribe({
      next: () => {
        alert('Seniority updated successfully.');
        this.cancelSeniorityEdit();     // resets flags + form
        this.refreshSeniorityList();
      },
      error: (err) => {
        console.error('Update seniority failed', err);
        alert('Failed to update seniority. Please try again.');
      }
    });
  }

  /** Confirm then delete */
  confirmDeleteSeniority(id: number) {
    if (!confirm('Are you sure you want to delete this record?')) return;
    this.service.deleteseniority(id).subscribe({
      next: () => {
        alert('Seniority deleted successfully.');
        if (this.editingRowId === id) this.cancelSeniorityEdit();
        this.refreshSeniorityList();
      },
      error: (err) => {
        console.error('Delete seniority failed', err);
        alert('Failed to delete. Please try again.');
      }
    });
  }

  /** Refresh list from backend */
  private refreshSeniorityList() {
    this.service.getseniority().subscribe((data: any) => {
      this.senioritylist = data;
    });
  }


  // Translation methods for Representative form
  // Translation methods for Representative form
  // translateToEnglishRep(sourceField: string, targetField: string) {
  //   const marathiText = this.addform.get(sourceField)?.value;

  //   if (!marathiText || marathiText.trim() === '') {
  //     this.addform.get(targetField)?.setValue('');
  //     return;
  //   }

  //   // Clear previous timeout
  //   if (this.translationTimeout) {
  //     clearTimeout(this.translationTimeout);
  //   }

  //   // Set new timeout to avoid too many API calls while typing
  //   this.translationTimeout = setTimeout(() => {
  //     this.translateText(marathiText, 'mr', 'en').subscribe({
  //       next: (translatedText) => {
  //         this.addform.get(targetField)?.setValue(translatedText, { emitEvent: false });
  //       },
  //       error: (error) => {
  //         console.error('Translation error:', error);
  //       }
  //     });
  //   }, 800); // Wait 800ms after user stops typing
  // }


  translateToEnglishRep(sourceField: string, targetField: string) {
    const marathiText = this.addform.get(sourceField)?.value;

    if (!marathiText || marathiText.trim() === '') {
      this.addform.get(targetField)?.setValue('', { emitEvent: false });
      return;
    }

    if (this.translationTimeout) clearTimeout(this.translationTimeout);

    this.translationTimeout = setTimeout(() => {
      this.translateText(marathiText, 'mr', 'en').subscribe({
        next: (translated) =>
          this.addform.get(targetField)?.setValue(translated, { emitEvent: false }),
        error: (err) => console.error('Translation error:', err),
      });
    }, 800);
  }

  translateFromEnglishToMarathiRep(sourceField: string, targetField: string) {
    const englishText = this.addform.get(sourceField)?.value;

    if (!englishText || englishText.trim() === '') {
      this.addform.get(targetField)?.setValue('');
      return;
    }

    // Clear previous timeout
    if (this.translationTimeout) {
      clearTimeout(this.translationTimeout);
    }

    // Set new timeout to avoid too many API calls while typing
    this.translationTimeout = setTimeout(() => {
      this.translateText(englishText, 'en', 'mr').subscribe({
        next: (translatedText) => {
          this.addform.get(targetField)?.setValue(translatedText, { emitEvent: false });
        },
        error: (error) => {
          console.error('Translation error:', error);
        }
      });
    }, 800);
  }



  // Translation method using MyMemory API (free, no API key required)
  translateText(text: string, fromLang: string, toLang: string): Observable<string> {
    const url = `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=${fromLang}|${toLang}`;

    return this.http.get(url).pipe(
      map((response: any) => {
        if (response && response.responseData && response.responseData.translatedText) {
          let translatedText = response.responseData.translatedText;
          // Clean up HTML entities
          translatedText = translatedText.replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&amp;/g, '&');
          return translatedText;
        }
        return text;
      })
    );
  }

  // Country Selection with Translation
  // onCountrySelect(event: any) {
  //   const selectedCountry = event.value;
  //   this.addform.get('country').setValue(selectedCountry);

  //   // Translate to English
  //   this.translateText(selectedCountry, 'mr', 'en').subscribe({
  //     next: (translated) => {
  //       this.addform.get('country_en')?.setValue(translated, { emitEvent: false });
  //     },
  //     error: (err) => console.error('Country translation error:', err)
  //   });

  //   // Load states for selected country
  //   let country = this.countries.find((a) => a.country_name == selectedCountry);
  //   if (country != undefined) {
  //     this.service.getState(country['country_code']).subscribe((data) => {
  //       this.states = data;
  //     });
  //   }
  // }

  onCountrySelect(event: any) {
    const selectedCountry = event.value;
    this.addform.get('country').setValue(selectedCountry, { emitEvent: false });

    // Reset downstream
    this.addform.get('state').setValue('', { emitEvent: false });
    this.addform.get('state_en').setValue('', { emitEvent: false });
    this.addform.get('district').setValue('', { emitEvent: false });
    this.addform.get('district_en').setValue('', { emitEvent: false });
    this.addform.get('taluka').setValue('', { emitEvent: false });
    this.addform.get('taluka_en').setValue('', { emitEvent: false });
    this.cities = [];
    this.talukas = [];

    this.translateText(selectedCountry, 'mr', 'en').subscribe({
      next: (translated) =>
        this.addform.get('country_en')?.setValue(translated, { emitEvent: false }),
      error: (err) => console.error('Country translation error:', err),
    });

    const country = this.countries.find((a) => a.country_name === selectedCountry);
    if (country) {
      this.service.getState(country['country_code']).subscribe((data) => {
        this.states = data;
      });
    }
  }

  // State Selection with Translation
  // onStateSelect(event: any) {
  //   const selectedState = event.value;
  //   this.addform.get('state').setValue(selectedState);
  //   this.selectedState = selectedState;

  //   // Translate to English
  //   this.translateText(selectedState, 'mr', 'en').subscribe({
  //     next: (translated) => {
  //       this.addform.get('state_en')?.setValue(translated, { emitEvent: false });
  //     },
  //     error: (err) => console.error('State translation error:', err)
  //   });

  //   // Load districts for selected state
  //   let state = this.states.find((a) => a.state_name == selectedState);
  //   if (state != undefined) {
  //     this.service.getDistrict(state['state_id']).subscribe((data) => {
  //       this.cities = data;
  //       this.selectedCity = null;
  //     });
  //   }
  // }


  // ─── 4. onStateSelect ────────────────────────────────────────
  onStateSelect(event: any) {
    const selectedState = event.value;
    this.addform.get('state').setValue(selectedState, { emitEvent: false });
    this.selectedState = selectedState;

    // Reset downstream
    this.addform.get('district').setValue('', { emitEvent: false });
    this.addform.get('district_en').setValue('', { emitEvent: false });
    this.addform.get('taluka').setValue('', { emitEvent: false });
    this.addform.get('taluka_en').setValue('', { emitEvent: false });
    this.cities = [];
    this.talukas = [];

    this.translateText(selectedState, 'mr', 'en').subscribe({
      next: (translated) =>
        this.addform.get('state_en')?.setValue(translated, { emitEvent: false }),
      error: (err) => console.error('State translation error:', err),
    });

    const state = this.states.find((a) => a.state_name === selectedState);
    if (state) {
      this.service.getDistrict(state['state_id']).subscribe((data) => {
        this.cities = data;
      });
    }
  }

  // District Selection with Translation
  // onDistrictSelect(event: any) {
  //   const selectedDistrict = event.value;
  //   this.addform.get('district').setValue(selectedDistrict);
  //   this.selectedCity = selectedDistrict;

  //   // Translate to English
  //   this.translateText(selectedDistrict, 'mr', 'en').subscribe({
  //     next: (translated) => {
  //       this.addform.get('district_en')?.setValue(translated, { emitEvent: false });
  //     },
  //     error: (err) => console.error('District translation error:', err)
  //   });

  //   // Load talukas for selected district
  //   let district = this.cities.find((a) => a.district_name == selectedDistrict);
  //   if (district != undefined) {
  //     let dist = [district['district_id']];
  //     this.service.getTaluka(dist).subscribe((data) => {
  //       this.talukas = data;
  //     });
  //   }
  // }


  onTalukaSelect(event: any) {
    const selectedTaluka = event.value;
    this.addform.get('taluka').setValue(selectedTaluka, { emitEvent: false });
    this.selectedTaluka = selectedTaluka;

    this.translateText(selectedTaluka, 'mr', 'en').subscribe({
      next: (translated) =>
        this.addform.get('taluka_en')?.setValue(translated, { emitEvent: false }),
      error: (err) => console.error('Taluka translation error:', err),
    });
  }


  onDistrictSelect(event: any) {
    const selectedDistrict = event.value;
    this.addform.get('district').setValue(selectedDistrict, { emitEvent: false });
    this.selectedCity = selectedDistrict;

    // Reset downstream
    this.addform.get('taluka').setValue('', { emitEvent: false });
    this.addform.get('taluka_en').setValue('', { emitEvent: false });
    this.talukas = [];

    this.translateText(selectedDistrict, 'mr', 'en').subscribe({
      next: (translated) =>
        this.addform.get('district_en')?.setValue(translated, { emitEvent: false }),
      error: (err) => console.error('District translation error:', err),
    });

    const district = this.cities.find((a) => a.district_name === selectedDistrict);
    if (district) {
      this.service.getTaluka([district['district_id']]).subscribe((data) => {
        this.talukas = data;
      });
    }
  }




  // ─── 7. getCountry (used by pincode auto-fill & selected_rep_name1) ──
  getCountry(event: any) {
    const country = this.countries.find((a) => a.country_name === event.value);
    if (!country) return;

    this.addform.get('country').setValue(event.value, { emitEvent: false });

    this.translateText(event.value, 'mr', 'en').subscribe({
      next: (translated) =>
        this.addform.get('country_en')?.setValue(translated, { emitEvent: false }),
      error: (err) => console.error('Country translation error:', err),
    });

    this.service.getState(country['country_code']).subscribe((data) => {
      this.states = data;
    });
  }

  // ─── 8. getState (used by pincode auto-fill & selected_rep_name1) ────
  getState(event: any) {
    this.state_id = event.value;
    this.addform.get('state').setValue(event.value, { emitEvent: false });
    this.selectedState = event.value;

    this.translateText(event.value, 'mr', 'en').subscribe({
      next: (translated) =>
        this.addform.get('state_en')?.setValue(translated, { emitEvent: false }),
      error: (err) => console.error('State translation error:', err),
    });

    const state = this.states.find((a) => a.state_name === event.value);
    if (state) {
      this.service.getDistrict(state['state_id']).subscribe((data) => {
        this.cities = data;
      });
    }
  }



  // ─── 9. getDistricts (used by pincode auto-fill & selected_rep_name1) ─
  getDistricts(event: any) {
    this.addform.get('district').setValue(event.value, { emitEvent: false });
    this.selectedCity = event.value;

    this.translateText(event.value, 'mr', 'en').subscribe({
      next: (translated) =>
        this.addform.get('district_en')?.setValue(translated, { emitEvent: false }),
      error: (err) => console.error('District translation error:', err),
    });

    const district = this.cities.find((a) => a.district_name === event.value);
    if (!district) return;
    this.service.getTaluka([district['district_id']]).subscribe((data) => {
      this.talukas = data;
    });
  }

  // ─── 10. getPincode1 (fixed) ─────────────────────────────────
  getPincode1(event: any) {
    if (!this.addform.get('pincode').valid) return;

    this.service
      .getPincodeData(parseInt(this.addform.get('pincode').value))
      .subscribe((data: any[]) => {
        if (!data || !data.length) return;
        const d = data[0];

        // Set Marathi values first
        this.addform.get('country').setValue(d['country_name'], { emitEvent: false });
        this.addform.get('state').setValue(d['state_name'], { emitEvent: false });
        this.addform.get('district').setValue(d['district_name'], { emitEvent: false });
        this.addform.get('taluka').setValue(d['taluka_name'], { emitEvent: false });

        // Translate all to English in parallel
        ['country_name', 'state_name', 'district_name', 'taluka_name'].forEach(
          (key, i) => {
            const targets = ['country_en', 'state_en', 'district_en', 'taluka_en'];
            this.translateText(d[key], 'mr', 'en').subscribe({
              next: (translated) =>
                this.addform.get(targets[i])?.setValue(translated, { emitEvent: false }),
            });
          }
        );

        // Load dropdown data in sequence
        this.getCountry({ value: d['country_name'] });
        setTimeout(() => this.getState({ value: d['state_name'] }), 300);
        setTimeout(() => this.getDistricts({ value: d['district_name'] }), 700);
        setTimeout(
          () =>
            this.addform
              .get('taluka')
              ?.setValue(d['taluka_name'], { emitEvent: false }),
          1100
        );
      });
  }


  // ─── 13. loadLocationDropdowns (called after selecting a rep) ─
  loadLocationDropdowns(selectedData: any) {
    const country = this.countries.find(
      (a) => a.country_name === selectedData['country']
    );
    if (!country) return;

    this.service.getState(country['country_code']).subscribe((statesData) => {
      this.states = statesData;

      const state = this.states.find(
        (a) => a.state_name === selectedData['state']
      );
      if (!state) return;

      this.service.getDistrict(state['state_id']).subscribe((districtsData) => {
        this.cities = districtsData;

        const district = this.cities.find(
          (a) => a.district_name === selectedData['district']
        );
        if (!district) return;

        this.service
          .getTaluka([district['district_id']])
          .subscribe((talukasData) => {
            this.talukas = talukasData;
          });
      });
    });
  }


  selected_rep_name(event: any, option: any) {
    if (!event.isUserInput) return;

    const data = this.issueSellerName.filter(
      (a: any) => a['issueSellerName'] === option['name']
    );
    if (!data || !data.length) return;

    const s = data[0];
    this.selected_repname = true;
    this.repId1 = s['id'];

    // Marathi fields
    this.addform.patchValue({
      issuesellername: s['issueSellerName'] || '',
      address1: s['address'] || '',
      country: s['country'] || '',
      state: s['state'] || '',
      district: s['district'] || '',
      taluka: s['taluka'] || '',
      pincode: s['pincode'] || '',
      mnumber: s['mobile_no'] || '',
      email: s['email'] || '',
      landline_no: s['landline_no'] || '',
      dob: s['dateofbirth'] || '',
      gstno: s['gst_no'] || '',
      panno: s['pan_no'] || '',
      depositamt: s['deposit_amt'] || '',
      option: s['issueSellerType'] || '',
      sampremebhet: s['s_bhet'] || '',
      distype: s['distype'] || '',
      // English fields — use DB values if present, translate otherwise
      issuesellername_en: s['eng_issueSellerName'] || '',
      address1_en: s['e_Address'] || '',
      country_en: s['e_Country'] || '',
      state_en: s['e_State'] || '',
      district_en: s['eng_districts'] || '',
      taluka_en: s['e_Taluka'] || '',
      start_date: s['start_date'] || '',
      end_date: s['end_date'] || '',
      narration: s['narration'] || '',
      rep_status: (s['status'] || '').toLowerCase().trim(),


    });

    // If English fields are empty in DB, translate on-the-fly
    const translateIfEmpty = (dbValue: string, marathiValue: string, targetCtrl: string) => {
      if (!dbValue && marathiValue) {
        this.translateText(marathiValue, 'mr', 'en').subscribe({
          next: (t) => this.addform.get(targetCtrl)?.setValue(t, { emitEvent: false }),
        });
      }
    };
    translateIfEmpty(s['eng_issueSellerName'], s['issueSellerName'], 'issuesellername_en');
    translateIfEmpty(s['e_Address'], s['address'], 'address1_en');
    translateIfEmpty(s['e_Country'], s['country'], 'country_en');
    translateIfEmpty(s['e_State'], s['state'], 'state_en');
    translateIfEmpty(s['eng_districts'], s['district'], 'district_en');
    translateIfEmpty(s['e_Taluka'], s['taluka'], 'taluka_en');

    this.selectedCity = s['district'];
    this.selectedTaluka = s['taluka'];
    this.selectedState = s['state'];

    this.loadLocationDropdowns(s);
  }



  onEndDateChange(event: any) {
    const endDate = event.target.value;
    if (endDate) {
      // Optionally auto-prompt narration if end date is filled
      const narration = this.addform.get('narration')?.value;
      if (!narration) {
        // You can show a snackbar/alert nudging the user to fill narration
        // this.snackBar.open('Please provide a reason for deactivation.', 'OK', { duration: 3000 });
      }
    }
  }

  // ── Issue Seller Type (Representative dept) ────────────────────────────────

  get filteredIssueSellerTypeOptions(): string[] {
    const term = this.issueSellerTypeSearch.trim().toLowerCase();
    if (!term) return this.issueSellerTypeOptions;
    return this.issueSellerTypeOptions.filter(o => o.toLowerCase().includes(term));
  }
  get isAllIssueSellerTypeSelected(): boolean {
    return this.issueSellerTypeOptions.every(v =>
      (this.formData.issueSellerTypeIds as string[]).includes(v)
    );
  }
  toggleAllIssueSellerTypes() {
    this.formData.issueSellerTypeIds = this.isAllIssueSellerTypeSelected
      ? [] : [...this.issueSellerTypeOptions];
  }
  isIssueSellerTypeSelected(val: string): boolean {
    return (this.formData.issueSellerTypeIds as string[]).includes(val);
  }
  toggleIssueSellerType(val: string) {
    const arr = this.formData.issueSellerTypeIds as string[];
    this.formData.issueSellerTypeIds = arr.includes(val) ? arr.filter(v => v !== val) : [...arr, val];
  }
  get selectedIssueSellerTypeLabel(): string {
    const count = (this.formData.issueSellerTypeIds as string[]).length;
    if (!count) return 'Select Issue Seller Type';
    if (this.isAllIssueSellerTypeSelected) return 'All';
    if (count === 1) return (this.formData.issueSellerTypeIds as string[])[0];
    return `${count} types selected`;
  }

  // ── Subscription Type multi-select ─────────────────────────────────────────

  get filteredSubscriptionTypes(): any[] {
    const term = this.subscriptionTypeSearch.trim().toLowerCase();
    if (!term) return this.subscriptionTypeList;
    return this.subscriptionTypeList.filter(t => t.subtype?.toLowerCase().includes(term));
  }
  isSubscriptionTypeSelected(val: string): boolean {
    return (this.formData.subscriptionTypeIds as string[]).includes(val);
  }
  toggleSubscriptionType(val: string) {
    const arr = this.formData.subscriptionTypeIds as string[];
    this.formData.subscriptionTypeIds = arr.includes(val) ? arr.filter(v => v !== val) : [...arr, val];
  }
  get selectedSubscriptionTypeLabel(): string {
    const count = (this.formData.subscriptionTypeIds as string[]).length;
    if (!count) return 'Select Subscription Type';
    if (count === 1) return (this.formData.subscriptionTypeIds as string[])[0];
    return `${count} types selected`;
  }

  // ── Delivery Mode multi-select ──────────────────────────────────────────────

  get filteredDeliveryModes(): any[] {
    const term = this.deliveryModeSearch.trim().toLowerCase();
    if (!term) return this.deliveryModeList;
    return this.deliveryModeList.filter(m => m.delivery_mode?.toLowerCase().includes(term));
  }
  isDeliveryModeSelected(val: string): boolean {
    return (this.formData.deliveryModeIds as string[]).includes(val);
  }
  toggleDeliveryMode(val: string) {
    const arr = this.formData.deliveryModeIds as string[];
    this.formData.deliveryModeIds = arr.includes(val) ? arr.filter(v => v !== val) : [...arr, val];
  }
  get selectedDeliveryModeLabel(): string {
    const count = (this.formData.deliveryModeIds as string[]).length;
    if (!count) return 'Select Delivery Mode';
    if (count === 1) return (this.formData.deliveryModeIds as string[])[0];
    return `${count} modes selected`;
  }

  // ── Book Name multi-select ──────────────────────────────────────────────────

  get filteredBookNameList(): any[] {
    const term = this.bookSearch.trim().toLowerCase();
    if (!term) return this.bookNameList;
    return this.bookNameList.filter(b => b.book_name?.toLowerCase().includes(term));
  }
  isBookNameSelected(val: string): boolean {
    return (this.formData.bookNames as string[]).includes(val);
  }
  toggleBookName(val: string) {
    const arr = this.formData.bookNames as string[];
    this.formData.bookNames = arr.includes(val) ? arr.filter(v => v !== val) : [...arr, val];
  }
  get selectedBookNameLabel(): string {
    const count = (this.formData.bookNames as string[]).length;
    if (!count) return 'Select Book Name';
    if (count === 1) return (this.formData.bookNames as string[])[0];
    return `${count} books selected`;
  }

  // ── Advertisement — Issue/Grantha + Issue Dates ────────────────────────────

  get filteredAdvtCategories(): any[] {
    const term = this.advtCategorySearch.trim().toLowerCase();
    if (!term) return this.issueNameList;
    return this.issueNameList.filter(i => i.category?.toLowerCase().includes(term));
  }
  selectAdvtCategory(val: string) {
    this.formData.issueName = val;
    this.advtCategoryDropdownOpen = false;
    this.advtCategorySearch = '';
    this.formData.issueDates = [];
    this.getMagIssueDatesandAdvtNames = [];
    if (!val) return;
    this.service.getAdvtDatesAndNames(val).subscribe((data: any[]) => {
      this.getMagIssueDatesandAdvtNames = data || [];
    });
  }
  get filteredIssueDates(): any[] {
    const term = this.issueDateSearch.trim().toLowerCase();
    if (!term) return this.getMagIssueDatesandAdvtNames;
    return this.getMagIssueDatesandAdvtNames.filter(item =>
      item.issueName?.toLowerCase().includes(term) || (item.issueDate || '').includes(term)
    );
  }
  isIssueDateSelected(item: any): boolean {
    return this.formData.issueDates.includes(String(item.id));
  }
  toggleIssueDate(item: any) {
    const id = String(item.id);
    this.formData.issueDates = this.formData.issueDates.includes(id)
      ? this.formData.issueDates.filter(d => d !== id)
      : [...this.formData.issueDates, id];
  }
  get selectedIssueDateLabel(): string {
    const count = this.formData.issueDates.length;
    if (!count) return 'Select Issue Dates';
    if (count === 1) {
      const item = this.getMagIssueDatesandAdvtNames.find(i => String(i.id) === this.formData.issueDates[0]);
      return item ? `${formatDate(item.issueDate, 'dd-MM-yyyy', 'en-IN')} — ${item.issueName}` : '1 selected';
    }
    return `${count} dates selected`;
  }

  // ── Issue Seller — Issue + Issue Dates ────────────────────────────────────

  get filteredIssueSellerIssues(): any[] {
    const term = this.issueSellerIssueSearch.trim().toLowerCase();
    if (!term) return this.advtCategorylist || [];
    return (this.advtCategorylist || []).filter(i => i.category?.toLowerCase().includes(term));
  }
  selectIssueSellerIssue(val: string) {
    this.formData.issueSellerIssueName = val;
    this.issueSellerIssueDropdownOpen = false;
    this.issueSellerIssueSearch = '';
    this.formData.issueSellerIssueDateIds = [];
    this.issueSellerIssueDateDropdownOpen = false;
    this.issueSellerIssueDateSearch = '';
    if (!val) return;
    this.getIssues({ value: val });
  }
  private issueSellerDateValue(item: any): string {
    return `${formatDate(item.issueDate, 'yyyy-MM-dd', 'en-IN')} ${item.issueName}`;
  }
  get filteredIssueSellerDates(): any[] {
    const term = this.issueSellerIssueDateSearch.trim().toLowerCase();
    const list = this.getMagIssueDatesandNames || [];
    if (!term) return list;
    return list.filter(item =>
      item.issueName?.toLowerCase().includes(term) || (item.issueDate || '').includes(term)
    );
  }
  isIssueSellerDateSelected(item: any): boolean {
    return (this.formData.issueSellerIssueDateIds as string[]).includes(this.issueSellerDateValue(item));
  }
  toggleIssueSellerDate(item: any) {
    const val = this.issueSellerDateValue(item);
    const arr = this.formData.issueSellerIssueDateIds as string[];
    this.formData.issueSellerIssueDateIds = arr.includes(val) ? arr.filter(d => d !== val) : [...arr, val];
  }
  get selectedIssueSellerDateLabel(): string {
    const count = (this.formData.issueSellerIssueDateIds as string[]).length;
    if (!count) return 'Select Issue Dates';
    if (count === 1) return (this.formData.issueSellerIssueDateIds as string[])[0];
    return `${count} dates selected`;
  }

  get isBookDept(): boolean {
    if (!this.formData.departmentId) return false;
    const dept = this.departmentList.find(d => String(d.dep_id) === String(this.formData.departmentId));
    if (!dept) return false;
    const name = (dept.dep_name as string).toLowerCase();
    return name.includes('book') || name.includes('पुस्तक');
  }

  get isAdvtDept(): boolean {
    if (!this.formData.departmentId) return false;
    const dept = this.departmentList.find(d => String(d.dep_id) === String(this.formData.departmentId));
    if (!dept) return false;
    const name = (dept.dep_name as string).toLowerCase();
    return name.includes('advt') || name.includes('advertisement') || name.includes('जाहिरात');
  }

  get isIssueSellerDept(): boolean {
    if (!this.formData.departmentId) return false;
    const dept = this.departmentList.find(d => String(d.dep_id) === String(this.formData.departmentId));
    if (!dept) return false;
    const name = (dept.dep_name as string).toLowerCase();
    return name.includes('issue') || name.includes('अंक');
  }

  get isRepresentativeDept(): boolean {
    if (!this.formData.departmentId) return false;
    const dept = this.departmentList.find(d => String(d.dep_id) === String(this.formData.departmentId));
    if (!dept) return false;
    const name = (dept.dep_name as string).toLowerCase();
    return name.includes('representative') || name.includes('प्रतिनिधी') || name.includes('rep');
  }

  onDepartmentChange() {
    this.formData.subscriptionTypeIds = [];
    this.formData.deliveryModeIds = [];
    this.formData.bookNames = [];
    this.formData.issueName = '';
    this.formData.issueDates = [];
    this.formData.issueSellerIssueName = '';
    this.formData.issueSellerIssueDateIds = [];
    this.bookSearch = '';
    this.subscriptionTypeList = [];
    this.deliveryModeList = [];
    this.bookNameList = [];
    this.issueNameList = [];
    this.getMagIssueDatesandAdvtNames = [];
    this.issueSellerIssueDates = [];
    this.issueDateDropdownOpen = false;
    this.issueDateSearch = '';
    this.advtCategoryDropdownOpen = false;
    this.advtCategorySearch = '';
    this.issueSellerIssueDropdownOpen = false;
    this.issueSellerIssueSearch = '';
    this.issueSellerIssueDateDropdownOpen = false;
    this.issueSellerIssueDateSearch = '';
    this.formData.issueSellerTypeIds = [];
    this.issueSellerTypeDropdownOpen = false;
    this.issueSellerTypeSearch = '';

    if (this.isSubscriptionDept) {
      this.service.getSubscriptionType().subscribe((data: any[]) => { this.subscriptionTypeList = data || []; });
      this.service.getAllDistributionModes1().subscribe((data: any[]) => { this.deliveryModeList = data || []; });
    }
    if (this.isBookDept) {
      this.service.get_book_names().subscribe((data: any[]) => { this.bookNameList = data || []; });
    }
    if (this.isAdvtDept || this.isIssueSellerDept) {
      this.service.getAdvtCategory().subscribe((data: any[]) => { this.issueNameList = data || []; });
    }
  }

  // ── Build unique dropdown values from loaded data ────────────
  buildFilterDropdowns() {
    const unique = (arr: string[]) =>
      [...new Set(arr.filter(v => v && v.trim() !== ''))].sort();

    this.filterCountries = unique(
      this.issueSellerName.map(i => i['country'] || '')
    );
    // States, districts, talukas start as full list;
    // they get narrowed as user selects higher-level filters
    this.filterStates = unique(this.issueSellerName.map(i => i['state'] || ''));
    this.filterDistricts = unique(this.issueSellerName.map(i => i['district'] || ''));
    this.filterTalukas = unique(this.issueSellerName.map(i => i['taluka'] || ''));
  }

  // ── Cascading: Country selected → narrow States ──────────────
  onFilterCountryChange() {
    this.filterState = '';
    this.filterDistrict = '';
    this.filterTaluka = '';

    const source = this.filterCountry
      ? this.issueSellerName.filter(i => i['country'] === this.filterCountry)
      : this.issueSellerName;

    const unique = (arr: string[]) =>
      [...new Set(arr.filter(v => v && v.trim() !== ''))].sort();

    this.filterStates = unique(source.map(i => i['state'] || ''));
    this.filterDistricts = unique(source.map(i => i['district'] || ''));
    this.filterTalukas = unique(source.map(i => i['taluka'] || ''));

    this.applyFilters();
  }

  // ── Cascading: State selected → narrow Districts ─────────────
  onFilterStateChange() {
    this.filterDistrict = '';
    this.filterTaluka = '';

    const source = this.issueSellerName.filter(i => {
      const matchCountry = !this.filterCountry || i['country'] === this.filterCountry;
      const matchState = !this.filterState || i['state'] === this.filterState;
      return matchCountry && matchState;
    });

    const unique = (arr: string[]) =>
      [...new Set(arr.filter(v => v && v.trim() !== ''))].sort();

    this.filterDistricts = unique(source.map(i => i['district'] || ''));
    this.filterTalukas = unique(source.map(i => i['taluka'] || ''));

    this.applyFilters();
  }

  // ── Cascading: District selected → narrow Talukas ───────────
  onFilterDistrictChange() {
    this.filterTaluka = '';

    const source = this.issueSellerName.filter(i => {
      const matchCountry = !this.filterCountry || i['country'] === this.filterCountry;
      const matchState = !this.filterState || i['state'] === this.filterState;
      const matchDistrict = !this.filterDistrict || i['district'] === this.filterDistrict;
      return matchCountry && matchState && matchDistrict;
    });

    const unique = (arr: string[]) =>
      [...new Set(arr.filter(v => v && v.trim() !== ''))].sort();

    this.filterTalukas = unique(source.map(i => i['taluka'] || ''));

    this.applyFilters();
  }

  // ── Main filter method ───────────────────────────────────────


  //   applyFilters() {
  //   this.filteredList = this.repList.filter(item => {

  //     // --- existing filters (search, status, country, state, district, taluka) ---
  //     const q = this.searchQuery?.toLowerCase() || '';
  //     const matchSearch = !q ||
  //       item['issueSellerName']?.toLowerCase().includes(q) ||
  //       item['mobile_no']?.toLowerCase().includes(q) ||
  //       item['email']?.toLowerCase().includes(q);

  //     const matchStatus = !this.statusFilter || item['rep_status'] === this.statusFilter;
  //     const matchCountry  = !this.filterCountry  || item['country']   === this.filterCountry;
  //     const matchState    = !this.filterState    || item['state']     === this.filterState;
  //     const matchDistrict = !this.filterDistrict || item['district']  === this.filterDistrict;
  //     const matchTaluka   = !this.filterTaluka   || item['taluka']    === this.filterTaluka;

  //     // --- NEW: DOB range filter ---
  //     let matchDob = true;
  //     const dobRaw = item['dateofbirth'];
  //     if (dobRaw && dobRaw !== '0000-00-00 00:00:00') {
  //       const dob = new Date(dobRaw);
  //       if (this.filterDobFrom && dob < this.filterDobFrom) matchDob = false;
  //       if (this.filterDobTo   && dob > this.filterDobTo)   matchDob = false;
  //     } else if (this.filterDobFrom || this.filterDobTo) {
  //       // If DOB filter is set but item has no DOB, exclude it
  //       matchDob = false;
  //     }

  //     return matchSearch && matchStatus && matchCountry &&
  //            matchState && matchDistrict && matchTaluka && matchDob;
  //   });
  // }

  get pagedList(): any[] {
    const start = this.currentPage * this.pageSize;
    return this.filteredList.slice(start, start + this.pageSize);
  }

  get totalPagesCount(): number {
    return Math.ceil(this.filteredList.length / this.pageSize);
  }

  nextPage() {
    if (this.currentPage < this.totalPagesCount - 1) this.currentPage++;
  }

  prevPage() {
    if (this.currentPage > 0) this.currentPage--;
  }

  currentPage = 0;
  pageSize = 15;


getRepStatus(item: any): string {
  const val = item['rep_status'] ?? item['status'];
  if (val === null || val === undefined || val === '') return '';
  const s = val.toString().toLowerCase().trim();
  if (s === '1' || s === 'active') return 'active';
  if (s === '0' || s === 'deactive' || s === 'inactive') return 'deactive';
  return s;
}


  // applyFilters() {
  //   this.filteredList = this.repList.filter(item => {

  //     const q = this.searchQuery?.toLowerCase() || '';
  //     const matchSearch = !q ||
  //       item['issueSellerName']?.toLowerCase().includes(q) ||
  //       item['mobile_no']?.toLowerCase().includes(q) ||
  //       item['email']?.toLowerCase().includes(q);

       

  //     const matchStatus = !this.statusFilter || this.getRepStatus(item) === this.statusFilter;
  //     const matchCountry = !this.filterCountry || item['country'] === this.filterCountry;
  //     const matchState = !this.filterState || item['state'] === this.filterState;
  //     const matchDistrict = !this.filterDistrict || item['district'] === this.filterDistrict;
  //     const matchTaluka = !this.filterTaluka || item['taluka'] === this.filterTaluka;

  //     // Month-only DOB filter
  //     let matchDob = true;
  //     if (this.filterDobMonth) {
  //       const dobRaw = item['dateofbirth'];
  //       if (!dobRaw || dobRaw === '0000-00-00 00:00:00') {
  //         matchDob = false;
  //       } else {
  //         const dob = new Date(dobRaw);
  //         matchDob = (dob.getMonth() + 1) === Number(this.filterDobMonth);
  //       }
  //     }

  //     // Start Date exact match filter
  //     let matchStartDate = true;
  //     if (this.filterStartDate) {
  //       const selected = new Date(this.filterStartDate);
  //       selected.setHours(0, 0, 0, 0);
  //       const startRaw = item['start_date'];
  //       if (!startRaw || startRaw === '0000-00-00 00:00:00') {
  //         matchStartDate = false;
  //       } else {
  //         const itemDate = new Date(startRaw);
  //         itemDate.setHours(0, 0, 0, 0);
  //         matchStartDate = itemDate.getTime() === selected.getTime();
  //       }
  //     }

  //     return matchSearch && matchStatus && matchCountry &&
  //       matchState && matchDistrict && matchTaluka && matchDob && matchStartDate;
  //   });
  // }


  // Update clearAllFilters():
  
//  applyFilters() {
//   this.filteredList = this.repList.filter(item => {

//     const q = this.searchQuery?.toLowerCase() || '';
//     const matchSearch = !q ||
//       item['issueSellerName']?.toLowerCase().includes(q) ||
//       item['mobile_no']?.toLowerCase().includes(q) ||
//       item['email']?.toLowerCase().includes(q);

//     const matchStatus = !this.statusFilter || this.getRepStatus(item) === this.statusFilter;
//     const matchCountry = !this.filterCountry || item['country'] === this.filterCountry;
//     const matchState = !this.filterState || item['state'] === this.filterState;
//     const matchDistrict = !this.filterDistrict || item['district'] === this.filterDistrict;
//     const matchTaluka = !this.filterTaluka || item['taluka'] === this.filterTaluka;

//     const matchType = !this.typeFilter ||
//       (item['issueSellerType'] || '').toLowerCase() === this.typeFilter.toLowerCase();

//     // ── START DATE range filter ──────────────────────────────
//     let matchStartDate = true;
//     if (this.filterStartDate) {
//       const selectedStart = new Date(this.filterStartDate);
//       selectedStart.setHours(0, 0, 0, 0);
//       const startRaw = item['start_date'];
//       if (!startRaw || startRaw === '0000-00-00' || startRaw === '0000-00-00 00:00:00') {
//         matchStartDate = false;
//       } else {
//         const itemStart = new Date(startRaw);
//         itemStart.setHours(0, 0, 0, 0);
//         matchStartDate = itemStart >= selectedStart; // ← range: on or after
//       }
//     }

//     // ── END DATE range filter ────────────────────────────────
//     let matchEndDate = true;
//     if (this.filterEndDate) {
//       const selectedEnd = new Date(this.filterEndDate);
//       selectedEnd.setHours(0, 0, 0, 0);
//       const endRaw = item['end_date'];
//       if (!endRaw || endRaw === '0000-00-00' || endRaw === '0000-00-00 00:00:00') {
//         matchEndDate = false;
//       } else {
//         const itemEnd = new Date(endRaw);
//         itemEnd.setHours(0, 0, 0, 0);
//         matchEndDate = itemEnd <= selectedEnd; // ← range: on or before
//       }
//     }

//     // ── DOB Month filter ─────────────────────────────────────
//     let matchDob = true;
//     if (this.filterDobMonth) {
//       const dobRaw = item['dateofbirth'];
//       if (!dobRaw || dobRaw === '0000-00-00 00:00:00') {
//         matchDob = false;
//       } else {
//         const dob = new Date(dobRaw);
//         matchDob = (dob.getMonth() + 1) === Number(this.filterDobMonth);
//       }
//     }

//     return matchSearch && matchStatus && matchCountry &&
//       matchState && matchDistrict && matchTaluka &&
//       matchDob && matchStartDate && matchType && matchEndDate;
//   });
// }

applyFilters() {
  // Auto-set end date to end of start date's month if only start date is selected
  let effectiveEndDate: Date | null = null;
  if (this.filterStartDate) {
    if (this.filterEndDate) {
      effectiveEndDate = new Date(this.filterEndDate);
    } else {
      // Auto: last day of the same month as start date
      const s = new Date(this.filterStartDate);
      effectiveEndDate = new Date(s.getFullYear(), s.getMonth() + 1, 0); // last day of month
    }
    effectiveEndDate.setHours(23, 59, 59, 999);
  }

  this.filteredList = this.repList.filter(item => {

    const q = this.searchQuery?.toLowerCase() || '';
    const matchSearch = !q ||
      item['issueSellerName']?.toLowerCase().includes(q) ||
      item['mobile_no']?.toLowerCase().includes(q) ||
      item['email']?.toLowerCase().includes(q);

    const matchStatus = !this.statusFilter || this.getRepStatus(item) === this.statusFilter;
    const matchCountry = !this.filterCountry || item['country'] === this.filterCountry;
    const matchState = !this.filterState || item['state'] === this.filterState;
    const matchDistrict = !this.filterDistrict || item['district'] === this.filterDistrict;
    const matchTaluka = !this.filterTaluka || item['taluka'] === this.filterTaluka;

    const matchType = !this.typeFilter ||
      (item['issueSellerType'] || '').toLowerCase() === this.typeFilter.toLowerCase();

    // ── START + END DATE range filter ────────────────────────
    let matchDateRange = true;
    if (this.filterStartDate) {
      const selectedStart = new Date(this.filterStartDate);
      selectedStart.setHours(0, 0, 0, 0);

      const startRaw = item['start_date'];
      if (!startRaw || startRaw === '0000-00-00' || startRaw === '0000-00-00 00:00:00') {
        matchDateRange = false;
      } else {
        const itemStart = new Date(startRaw);
        itemStart.setHours(0, 0, 0, 0);
        matchDateRange = itemStart >= selectedStart && itemStart <= effectiveEndDate;
      }
    } else if (this.filterEndDate) {
      // Only end date selected — show records on or before end date
      const selectedEnd = new Date(this.filterEndDate);
      selectedEnd.setHours(23, 59, 59, 999);
      const startRaw = item['start_date'];
      if (!startRaw || startRaw === '0000-00-00' || startRaw === '0000-00-00 00:00:00') {
        matchDateRange = false;
      } else {
        const itemStart = new Date(startRaw);
        matchDateRange = itemStart <= selectedEnd;
      }
    }

    // ── DOB Month filter ─────────────────────────────────────
    let matchDob = true;
    if (this.filterDobMonth) {
      const dobRaw = item['dateofbirth'];
      if (!dobRaw || dobRaw === '0000-00-00 00:00:00') {
        matchDob = false;
      } else {
        const dob = new Date(dobRaw);
        matchDob = (dob.getMonth() + 1) === Number(this.filterDobMonth);
      }
    }

    return matchSearch && matchStatus && matchCountry &&
      matchState && matchDistrict && matchTaluka &&
      matchDob && matchDateRange && matchType;
  });
}
  
  
 

  clearAllFilters() {
  this.searchQuery = '';
  this.statusFilter = '';
  this.filterCountry = '';
  this.filterState = '';
  this.filterDistrict = '';
  this.filterTaluka = '';
  this.filterDobMonth = '';
  this.filterStartDate = null;
  this.typeFilter = '';        // ← ADD
  this.filterEndDate = null;   // ← ADD
  this.applyFilters();
}


  exportFilteredList(): void {
    if (!this.filteredList.length) {
      alert('No records to export.');
      return;
    }

    const exportData = this.filteredList.map((item: any, index: number) => ({
      'Sr. No.': index + 1,
      'Name': item['issueSellerName'] || '',
      'Address': item['address'] || '',
      'Pincode': item['pincode'] || '',
      'State': item['state'] || '',
      'District': item['district'] || '',
      'Taluka': item['taluka'] || '',
      'Mobile': item['mobile_no'] || '',
      'Email': item['email'] || '',
      'DOB': (item['dateofbirth'] && item['dateofbirth'] !== '0000-00-00 00:00:00')
        ? formatDate(item['dateofbirth'], 'dd-MM-yyyy', 'en-IN')
        : '',
      'GST No': item['gst_no'] || '',
      'PAN No': item['pan_no'] || '',
      'Deposit (₹)': item['deposit_amt'] || '0',
      'Type': item['issueSellerType'] || '',
      'Start Date': (item['start_date'] && item['start_date'] !== '0000-00-00')
        ? formatDate(item['start_date'], 'dd-MM-yyyy', 'en-IN')
        : '',
      'End Date': (item['end_date'] && item['end_date'] !== '0000-00-00')
        ? formatDate(item['end_date'], 'dd-MM-yyyy', 'en-IN')
        : '',
      'Status': item['rep_status'] || '',
      'Narration': item['narration'] || '',
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Representatives');

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const today = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN');
    saveAs(blob, `Representative_List_${today}.xlsx`);
  }

  // applyFilterOff(): void {
  //   const name = this.searchName.trim().toLowerCase();
  //   const mobile = this.searchMobile.trim();

  //   const filtered = this.allRepresentatives.filter(rep => {
  //     const matchName = name
  //       ? (rep.issuesellername || '').toLowerCase().includes(name)
  //       : true;
  //     const matchMobile = mobile
  //       ? (rep.mnumber || '').includes(mobile)
  //       : true;
  //     return matchName && matchMobile;
  //   });

  //   this.officeRepDataSource.data = filtered;
  //   this.filteredRepresentatives = filtered;
  // }

//  applyFilterOff() {
  
//   let filtered = [...this.allRepresentatives];

//   // Name search
//   if (this.searchName && this.searchName.trim()) {
//     filtered = filtered.filter(r =>
//       r.issuesellername?.toLowerCase().includes(this.searchName.toLowerCase())
//     );
//   }

//   // Mobile search
//   if (this.searchMobile && this.searchMobile.trim()) {
//     filtered = filtered.filter(r =>
//       r.mnumber?.includes(this.searchMobile)
//     );
//   }

//   // Status filter — handles BOTH statusFilter (filter bar) and searchStatus (search bar)
//   // Priority: statusFilter (filter bar) takes precedence
//   const activeStatusFilter = this.statusFilter !== '' ? this.statusFilter : this.searchStatus;
//   if (activeStatusFilter !== '') {
//     filtered = filtered.filter(r => String(r.status) === String(activeStatusFilter));
//   }

//   // Start Date From
//   if (this.startDateFrom) {
//     const from = new Date(this.startDateFrom);
//     from.setHours(0, 0, 0, 0);
//     filtered = filtered.filter(r => {
//       if (!r.start_date || r.start_date === '0000-00-00' || r.start_date === '') return false;
//       const d = new Date(r.start_date);
//       d.setHours(0, 0, 0, 0);
//       return d >= from;
//     });
//   }

//   // Start Date To
//   if (this.startDateTo) {
//     const to = new Date(this.startDateTo);
//     to.setHours(23, 59, 59, 999);
//     filtered = filtered.filter(r => {
//       if (!r.start_date || r.start_date === '0000-00-00' || r.start_date === '') return false;
//       const d = new Date(r.start_date);
//       return d <= to;
//     });
//   }

//   this.filteredRepresentatives = filtered;
//   this.officeRepDataSource.data = filtered;

//   if (this.paginator) {
//     this.paginator.firstPage();
//   }
// }

// applyFilterOff(): void {
//   let filtered = [...this.allRepresentatives];

//   // Name search
//   if (this.searchName?.trim()) {
//     const name = this.searchName.trim().toLowerCase();
//     filtered = filtered.filter(r =>
//       (r.issuesellername || '').toLowerCase().includes(name)
//     );
//   }

//   // Mobile search
//   if (this.searchMobile?.trim()) {
//     filtered = filtered.filter(r =>
//       (r.mnumber || '').includes(this.searchMobile.trim())
//     );
//   }

//   // Status filter — coerce both sides to string for safe comparison
//   if (this.statusFilter !== '' && this.statusFilter !== null && this.statusFilter !== undefined) {
//     filtered = filtered.filter(r => String(r.status) === String(this.statusFilter));
//   }

//   // Start Date From — handle both Date and Moment objects
//   if (this.startDateFrom) {
//     const from = new Date(this.startDateFrom);
//     from.setHours(0, 0, 0, 0);
//     if (!isNaN(from.getTime())) {
//       filtered = filtered.filter(r => {
//         if (!r.start_date || r.start_date === '0000-00-00' || r.start_date === '') return false;
//         const d = new Date(r.start_date);
//         d.setHours(0, 0, 0, 0);
//         return !isNaN(d.getTime()) && d >= from;
//       });
//     }
//   }

//   // Start Date To
//   if (this.startDateTo) {
//     const to = new Date(this.startDateTo);
//     to.setHours(23, 59, 59, 999);
//     if (!isNaN(to.getTime())) {
//       filtered = filtered.filter(r => {
//         if (!r.start_date || r.start_date === '0000-00-00' || r.start_date === '') return false;
//         const d = new Date(r.start_date);
//         return !isNaN(d.getTime()) && d <= to;
//       });
//     }
//   }

//   this.filteredRepresentatives = filtered;
//   this.officeRepDataSource.data = filtered;

//   if (this.paginator) {
//     this.paginator.firstPage();
//   }
// }

applyFilterOff(): void {
  let filtered = [...this.allRepresentatives];

  // Name search
  if (this.searchName?.trim()) {
    const name = this.searchName.trim().toLowerCase();
    filtered = filtered.filter(r =>
      (r.issuesellername || '').toLowerCase().includes(name)
    );
  }

  // Mobile search
  if (this.searchMobile?.trim()) {
    filtered = filtered.filter(r =>
      (r.mnumber || '').includes(this.searchMobile.trim())
    );
  }

  // Status filter
  if (this.statusFilter !== '' && this.statusFilter !== null && this.statusFilter !== undefined) {
    filtered = filtered.filter(r => String(r.status) === String(this.statusFilter));
  }

  // ✅ Date Range Filter — both dates evaluated together in ONE filter pass
  const hasFrom = !!this.startDateFrom;
  const hasTo   = !!this.startDateTo;

  if (hasFrom || hasTo) {
    let from: Date | null = null;
    let to:   Date | null = null;

    if (hasFrom) {
      from = new Date(this.startDateFrom);
      from.setHours(0, 0, 0, 0);
      if (isNaN(from.getTime())) from = null; // invalid date guard
    }

    if (hasTo) {
      to = new Date(this.startDateTo);
      to.setHours(23, 59, 59, 999);
      if (isNaN(to.getTime())) to = null; // invalid date guard
    }

    filtered = filtered.filter(r => {
      // Skip records with no/invalid start_date
      if (!r.start_date || r.start_date === '0000-00-00' || r.start_date === '') return false;

      const d = new Date(r.start_date);
      if (isNaN(d.getTime())) return false;

      // Apply whichever boundaries are set
      if (from && to)   return d >= from && d <= to;  // ✅ Both: range filter
      if (from)         return d >= from;              // Only From
      if (to)           return d <= to;                // Only To

      return true;
    });
  }

  this.filteredRepresentatives = filtered;
  this.officeRepDataSource.data = filtered;

  if (this.paginator) {
    this.paginator.firstPage();
  }
}


clearFilters(): void {
  this.statusFilter = '';
  this.startDateFrom = null;
  this.startDateTo = null;
  this.searchName = '';
  this.searchMobile = '';
  this.filteredRepresentatives = [...this.allRepresentatives];
  this.officeRepDataSource.data = [...this.allRepresentatives];
  if (this.paginator) {
    this.paginator.firstPage();
  }
}

  clearSearch(): void {
    this.searchName = '';
    this.searchMobile = '';
    this.officeRepDataSource.data = [...this.allRepresentatives];
    this.filteredRepresentatives = [...this.allRepresentatives];
  }

onRepNameSelect(event: any) {

  if (this.isAddingNewRep) return;
  if (!event.value) {
    this.isEditingOffRep = false;
    this.officerepform.reset();
    return;
  }

  const rep = this.allRepresentatives.find(r => r.issuesellername === event.value);
  if (rep) {
    this.editRep(rep);
  }
}


updatecountry(item) {
  this.updatecountry123 = true;
  this.countryid = item.country_id;
  this.addcountry.get('country_name').setValue(item['country_name']);
  this.addcountry.get('country_code').setValue(item['country_code']);
  this.addcountry.get('sequence_id').setValue(item['sequence_id']); // ← ADD THIS
}

toggleRepMode(): void {
  this.isAddingNewRep = !this.isAddingNewRep;
  
  // Clear the field when switching modes
  this.officerepform.get('issuesellername')?.setValue('');
  
  // Also clear dependent fields if switching to Add mode
  if (this.isAddingNewRep) {
    this.officerepform.patchValue({
      address: '',
      pincode: '',
      state: '',
      // ...clear other auto-filled fields
    });
  }
}

deletecountry(item: any) {
  if (!confirm(`Are you sure you want to delete "${item.country_name}"?`)) return;

 const data: any = {
  "country_id": item.country_id
};

  this.service.deletecountry(data).subscribe(
    (response) => {
      alert('Country Deleted Successfully...');
      this.ngOnInit();
    },
    (error) => {
      alert('Something went wrong. Please try again.');
    }
  );
}

}